import * as e from "react";
import { useLayoutEffect as t, useState as n } from "react";
import { Fragment as r, jsx as i, jsxs as a } from "react/jsx-runtime";
import * as o from "react-dom";
//#region ../../node_modules/clsx/dist/clsx.mjs
function s(e) {
	var t, n, r = "";
	if (typeof e == "string" || typeof e == "number") r += e;
	else if (typeof e == "object") if (Array.isArray(e)) {
		var i = e.length;
		for (t = 0; t < i; t++) e[t] && (n = s(e[t])) && (r && (r += " "), r += n);
	} else for (n in e) e[n] && (r && (r += " "), r += n);
	return r;
}
function c() {
	for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (t = s(e)) && (r && (r += " "), r += t);
	return r;
}
//#endregion
//#region ../../node_modules/tailwind-merge/dist/bundle-mjs.mjs
var l = (e, t) => {
	let n = Array(e.length + t.length);
	for (let t = 0; t < e.length; t++) n[t] = e[t];
	for (let r = 0; r < t.length; r++) n[e.length + r] = t[r];
	return n;
}, u = (e, t) => ({
	classGroupId: e,
	validator: t
}), d = (e = /* @__PURE__ */ new Map(), t = null, n) => ({
	nextPart: e,
	validators: t,
	classGroupId: n
}), f = "-", p = [], m = "arbitrary..", h = (e) => {
	let t = v(e), { conflictingClassGroups: n, conflictingClassGroupModifiers: r } = e;
	return {
		getClassGroupId: (e) => {
			if (e.startsWith("[") && e.endsWith("]")) return _(e);
			let n = e.split(f);
			return g(n, +(n[0] === "" && n.length > 1), t);
		},
		getConflictingClassGroupIds: (e, t) => {
			if (t) {
				let t = r[e], i = n[e];
				return t ? i ? l(i, t) : t : i || p;
			}
			return n[e] || p;
		}
	};
}, g = (e, t, n) => {
	if (e.length - t === 0) return n.classGroupId;
	let r = e[t], i = n.nextPart.get(r);
	if (i) {
		let n = g(e, t + 1, i);
		if (n) return n;
	}
	let a = n.validators;
	if (a === null) return;
	let o = t === 0 ? e.join(f) : e.slice(t).join(f), s = a.length;
	for (let e = 0; e < s; e++) {
		let t = a[e];
		if (t.validator(o)) return t.classGroupId;
	}
}, _ = (e) => e.slice(1, -1).indexOf(":") === -1 ? void 0 : (() => {
	let t = e.slice(1, -1), n = t.indexOf(":"), r = t.slice(0, n);
	return r ? m + r : void 0;
})(), v = (e) => {
	let { theme: t, classGroups: n } = e;
	return y(n, t);
}, y = (e, t) => {
	let n = d();
	for (let r in e) {
		let i = e[r];
		b(i, n, r, t);
	}
	return n;
}, b = (e, t, n, r) => {
	let i = e.length;
	for (let a = 0; a < i; a++) {
		let i = e[a];
		x(i, t, n, r);
	}
}, x = (e, t, n, r) => {
	if (typeof e == "string") {
		S(e, t, n);
		return;
	}
	if (typeof e == "function") {
		C(e, t, n, r);
		return;
	}
	w(e, t, n, r);
}, S = (e, t, n) => {
	let r = e === "" ? t : T(t, e);
	r.classGroupId = n;
}, C = (e, t, n, r) => {
	if (E(e)) {
		b(e(r), t, n, r);
		return;
	}
	t.validators === null && (t.validators = []), t.validators.push(u(n, e));
}, w = (e, t, n, r) => {
	let i = Object.entries(e), a = i.length;
	for (let e = 0; e < a; e++) {
		let [a, o] = i[e];
		b(o, T(t, a), n, r);
	}
}, T = (e, t) => {
	let n = e, r = t.split(f), i = r.length;
	for (let e = 0; e < i; e++) {
		let t = r[e], i = n.nextPart.get(t);
		i || (i = d(), n.nextPart.set(t, i)), n = i;
	}
	return n;
}, E = (e) => "isThemeGetter" in e && e.isThemeGetter === !0, ee = (e) => {
	if (e < 1) return {
		get: () => void 0,
		set: () => {}
	};
	let t = 0, n = Object.create(null), r = Object.create(null), i = (i, a) => {
		n[i] = a, t++, t > e && (t = 0, r = n, n = Object.create(null));
	};
	return {
		get(e) {
			let t = n[e];
			if (t !== void 0) return t;
			if ((t = r[e]) !== void 0) return i(e, t), t;
		},
		set(e, t) {
			e in n ? n[e] = t : i(e, t);
		}
	};
}, D = "!", O = ":", te = [], k = (e, t, n, r, i) => ({
	modifiers: e,
	hasImportantModifier: t,
	baseClassName: n,
	maybePostfixModifierPosition: r,
	isExternal: i
}), A = (e) => {
	let { prefix: t, experimentalParseClassName: n } = e, r = (e) => {
		let t = [], n = 0, r = 0, i = 0, a, o = e.length;
		for (let s = 0; s < o; s++) {
			let o = e[s];
			if (n === 0 && r === 0) {
				if (o === O) {
					t.push(e.slice(i, s)), i = s + 1;
					continue;
				}
				if (o === "/") {
					a = s;
					continue;
				}
			}
			o === "[" ? n++ : o === "]" ? n-- : o === "(" ? r++ : o === ")" && r--;
		}
		let s = t.length === 0 ? e : e.slice(i), c = s, l = !1;
		s.endsWith(D) ? (c = s.slice(0, -1), l = !0) : s.startsWith(D) && (c = s.slice(1), l = !0);
		let u = a && a > i ? a - i : void 0;
		return k(t, l, c, u);
	};
	if (t) {
		let e = t + O, n = r;
		r = (t) => t.startsWith(e) ? n(t.slice(e.length)) : k(te, !1, t, void 0, !0);
	}
	if (n) {
		let e = r;
		r = (t) => n({
			className: t,
			parseClassName: e
		});
	}
	return r;
}, j = (e) => {
	let t = /* @__PURE__ */ new Map();
	return e.orderSensitiveModifiers.forEach((e, n) => {
		t.set(e, 1e6 + n);
	}), (e) => {
		let n = [], r = [];
		for (let i = 0; i < e.length; i++) {
			let a = e[i], o = a[0] === "[", s = t.has(a);
			o || s ? (r.length > 0 && (r.sort(), n.push(...r), r = []), n.push(a)) : r.push(a);
		}
		return r.length > 0 && (r.sort(), n.push(...r)), n;
	};
}, M = (e) => ({
	cache: ee(e.cacheSize),
	parseClassName: A(e),
	sortModifiers: j(e),
	postfixLookupClassGroupIds: ne(e),
	...h(e)
}), ne = (e) => {
	let t = Object.create(null), n = e.postfixLookupClassGroups;
	if (n) for (let e = 0; e < n.length; e++) t[n[e]] = !0;
	return t;
}, N = /\s+/, re = (e, t) => {
	let { parseClassName: n, getClassGroupId: r, getConflictingClassGroupIds: i, sortModifiers: a, postfixLookupClassGroupIds: o } = t, s = [], c = e.trim().split(N), l = "";
	for (let e = c.length - 1; e >= 0; --e) {
		let t = c[e], { isExternal: u, modifiers: d, hasImportantModifier: f, baseClassName: p, maybePostfixModifierPosition: m } = n(t);
		if (u) {
			l = t + (l.length > 0 ? " " + l : l);
			continue;
		}
		let h = !!m, g;
		if (h) {
			g = r(p.substring(0, m));
			let e = g && o[g] ? r(p) : void 0;
			e && e !== g && (g = e, h = !1);
		} else g = r(p);
		if (!g) {
			if (!h) {
				l = t + (l.length > 0 ? " " + l : l);
				continue;
			}
			if (g = r(p), !g) {
				l = t + (l.length > 0 ? " " + l : l);
				continue;
			}
			h = !1;
		}
		let _ = d.length === 0 ? "" : d.length === 1 ? d[0] : a(d).join(":"), v = f ? _ + D : _, y = v + g;
		if (s.indexOf(y) > -1) continue;
		s.push(y);
		let b = i(g, h);
		for (let e = 0; e < b.length; ++e) {
			let t = b[e];
			s.push(v + t);
		}
		l = t + (l.length > 0 ? " " + l : l);
	}
	return l;
}, ie = (...e) => {
	let t = 0, n, r, i = "";
	for (; t < e.length;) (n = e[t++]) && (r = ae(n)) && (i && (i += " "), i += r);
	return i;
}, ae = (e) => {
	if (typeof e == "string") return e;
	let t, n = "";
	for (let r = 0; r < e.length; r++) e[r] && (t = ae(e[r])) && (n && (n += " "), n += t);
	return n;
}, oe = (e, ...t) => {
	let n, r, i, a, o = (o) => (n = M(t.reduce((e, t) => t(e), e())), r = n.cache.get, i = n.cache.set, a = s, s(o)), s = (e) => {
		let t = r(e);
		if (t) return t;
		let a = re(e, n);
		return i(e, a), a;
	};
	return a = o, (...e) => a(ie(...e));
}, P = [], F = (e) => {
	let t = (t) => t[e] || P;
	return t.isThemeGetter = !0, t;
}, I = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, se = /^\((?:(\w[\w-]*):)?(.+)\)$/i, ce = /^\d+(?:\.\d+)?\/\d+(?:\.\d+)?$/, L = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, le = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, ue = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, de = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, fe = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, pe = (e) => ce.test(e), R = (e) => !!e && !Number.isNaN(Number(e)), me = (e) => !!e && Number.isInteger(Number(e)), he = (e) => e.endsWith("%") && R(e.slice(0, -1)), ge = (e) => L.test(e), _e = () => !0, ve = (e) => le.test(e) && !ue.test(e), ye = () => !1, be = (e) => de.test(e), xe = (e) => fe.test(e), Se = (e) => !z(e) && !B(e), Ce = (e) => e.startsWith("@container") && (e[10] === "/" && e[11] !== void 0 || e[11] === "s" && e[16] !== void 0 && e.startsWith("-size/", 10) || e[11] === "n" && e[18] !== void 0 && e.startsWith("-normal/", 10)), we = (e) => ze(e, Ue, ye), z = (e) => I.test(e), Te = (e) => ze(e, We, ve), Ee = (e) => ze(e, Ge, R), De = (e) => ze(e, qe, _e), Oe = (e) => ze(e, Ke, ye), ke = (e) => ze(e, Ve, ye), Ae = (e) => ze(e, He, xe), je = (e) => ze(e, Je, be), B = (e) => se.test(e), Me = (e) => Be(e, We), Ne = (e) => Be(e, Ke), Pe = (e) => Be(e, Ve), Fe = (e) => Be(e, Ue), Ie = (e) => Be(e, He), Le = (e) => Be(e, Je, !0), Re = (e) => Be(e, qe, !0), ze = (e, t, n) => {
	let r = I.exec(e);
	return r ? r[1] ? t(r[1]) : n(r[2]) : !1;
}, Be = (e, t, n = !1) => {
	let r = se.exec(e);
	return r ? r[1] ? t(r[1]) : n : !1;
}, Ve = (e) => e === "position" || e === "percentage", He = (e) => e === "image" || e === "url", Ue = (e) => e === "length" || e === "size" || e === "bg-size", We = (e) => e === "length", Ge = (e) => e === "number", Ke = (e) => e === "family-name", qe = (e) => e === "number" || e === "weight", Je = (e) => e === "shadow", Ye = /*#__PURE__*/ oe(() => {
	let e = F("color"), t = F("font"), n = F("text"), r = F("font-weight"), i = F("tracking"), a = F("leading"), o = F("breakpoint"), s = F("container"), c = F("spacing"), l = F("radius"), u = F("shadow"), d = F("inset-shadow"), f = F("text-shadow"), p = F("drop-shadow"), m = F("blur"), h = F("perspective"), g = F("aspect"), _ = F("ease"), v = F("animate"), y = () => [
		"auto",
		"avoid",
		"all",
		"avoid-page",
		"page",
		"left",
		"right",
		"column"
	], b = () => [
		"center",
		"top",
		"bottom",
		"left",
		"right",
		"top-left",
		"left-top",
		"top-right",
		"right-top",
		"bottom-right",
		"right-bottom",
		"bottom-left",
		"left-bottom"
	], x = () => [
		...b(),
		B,
		z
	], S = () => [
		"auto",
		"hidden",
		"clip",
		"visible",
		"scroll"
	], C = () => [
		"auto",
		"contain",
		"none"
	], w = () => [
		B,
		z,
		c
	], T = () => [
		pe,
		"full",
		"auto",
		...w()
	], E = () => [
		me,
		"none",
		"subgrid",
		B,
		z
	], ee = () => [
		"auto",
		{ span: [
			"full",
			me,
			B,
			z
		] },
		me,
		B,
		z
	], D = () => [
		me,
		"auto",
		B,
		z
	], O = () => [
		"auto",
		"min",
		"max",
		"fr",
		B,
		z
	], te = () => [
		"start",
		"end",
		"center",
		"between",
		"around",
		"evenly",
		"stretch",
		"baseline",
		"center-safe",
		"end-safe"
	], k = () => [
		"start",
		"end",
		"center",
		"stretch",
		"center-safe",
		"end-safe"
	], A = () => ["auto", ...w()], j = () => [
		pe,
		"auto",
		"full",
		"dvw",
		"dvh",
		"lvw",
		"lvh",
		"svw",
		"svh",
		"min",
		"max",
		"fit",
		...w()
	], M = () => [
		pe,
		"screen",
		"full",
		"dvw",
		"lvw",
		"svw",
		"min",
		"max",
		"fit",
		...w()
	], ne = () => [
		pe,
		"screen",
		"full",
		"lh",
		"dvh",
		"lvh",
		"svh",
		"min",
		"max",
		"fit",
		...w()
	], N = () => [
		e,
		B,
		z
	], re = () => [
		...b(),
		Pe,
		ke,
		{ position: [B, z] }
	], ie = () => ["no-repeat", { repeat: [
		"",
		"x",
		"y",
		"space",
		"round"
	] }], ae = () => [
		"auto",
		"cover",
		"contain",
		Fe,
		we,
		{ size: [B, z] }
	], oe = () => [
		he,
		Me,
		Te
	], P = () => [
		"",
		"none",
		"full",
		l,
		B,
		z
	], I = () => [
		"",
		R,
		Me,
		Te
	], se = () => [
		"solid",
		"dashed",
		"dotted",
		"double"
	], ce = () => [
		"normal",
		"multiply",
		"screen",
		"overlay",
		"darken",
		"lighten",
		"color-dodge",
		"color-burn",
		"hard-light",
		"soft-light",
		"difference",
		"exclusion",
		"hue",
		"saturation",
		"color",
		"luminosity"
	], L = () => [
		R,
		he,
		Pe,
		ke
	], le = () => [
		"",
		"none",
		m,
		B,
		z
	], ue = () => [
		"none",
		R,
		B,
		z
	], de = () => [
		"none",
		R,
		B,
		z
	], fe = () => [
		R,
		B,
		z
	], ve = () => [
		pe,
		"full",
		...w()
	];
	return {
		cacheSize: 500,
		theme: {
			animate: [
				"spin",
				"ping",
				"pulse",
				"bounce"
			],
			aspect: ["video"],
			blur: [ge],
			breakpoint: [ge],
			color: [_e],
			container: [ge],
			"drop-shadow": [ge],
			ease: [
				"in",
				"out",
				"in-out"
			],
			font: [Se],
			"font-weight": [
				"thin",
				"extralight",
				"light",
				"normal",
				"medium",
				"semibold",
				"bold",
				"extrabold",
				"black"
			],
			"inset-shadow": [ge],
			leading: [
				"none",
				"tight",
				"snug",
				"normal",
				"relaxed",
				"loose"
			],
			perspective: [
				"dramatic",
				"near",
				"normal",
				"midrange",
				"distant",
				"none"
			],
			radius: [ge],
			shadow: [ge],
			spacing: ["px", R],
			text: [ge],
			"text-shadow": [ge],
			tracking: [
				"tighter",
				"tight",
				"normal",
				"wide",
				"wider",
				"widest"
			]
		},
		classGroups: {
			aspect: [{ aspect: [
				"auto",
				"square",
				pe,
				z,
				B,
				g
			] }],
			container: ["container"],
			"container-type": [{ "@container": [
				"",
				"normal",
				"size",
				B,
				z
			] }],
			"container-named": [Ce],
			columns: [{ columns: [
				R,
				z,
				B,
				s
			] }],
			"break-after": [{ "break-after": y() }],
			"break-before": [{ "break-before": y() }],
			"break-inside": [{ "break-inside": [
				"auto",
				"avoid",
				"avoid-page",
				"avoid-column"
			] }],
			"box-decoration": [{ "box-decoration": ["slice", "clone"] }],
			box: [{ box: ["border", "content"] }],
			display: [
				"block",
				"inline-block",
				"inline",
				"flex",
				"inline-flex",
				"table",
				"inline-table",
				"table-caption",
				"table-cell",
				"table-column",
				"table-column-group",
				"table-footer-group",
				"table-header-group",
				"table-row-group",
				"table-row",
				"flow-root",
				"grid",
				"inline-grid",
				"contents",
				"list-item",
				"hidden"
			],
			sr: ["sr-only", "not-sr-only"],
			float: [{ float: [
				"right",
				"left",
				"none",
				"start",
				"end"
			] }],
			clear: [{ clear: [
				"left",
				"right",
				"both",
				"none",
				"start",
				"end"
			] }],
			isolation: ["isolate", "isolation-auto"],
			"object-fit": [{ object: [
				"contain",
				"cover",
				"fill",
				"none",
				"scale-down"
			] }],
			"object-position": [{ object: x() }],
			overflow: [{ overflow: S() }],
			"overflow-x": [{ "overflow-x": S() }],
			"overflow-y": [{ "overflow-y": S() }],
			overscroll: [{ overscroll: C() }],
			"overscroll-x": [{ "overscroll-x": C() }],
			"overscroll-y": [{ "overscroll-y": C() }],
			position: [
				"static",
				"fixed",
				"absolute",
				"relative",
				"sticky"
			],
			inset: [{ inset: T() }],
			"inset-x": [{ "inset-x": T() }],
			"inset-y": [{ "inset-y": T() }],
			start: [{
				"inset-s": T(),
				start: T()
			}],
			end: [{
				"inset-e": T(),
				end: T()
			}],
			"inset-bs": [{ "inset-bs": T() }],
			"inset-be": [{ "inset-be": T() }],
			top: [{ top: T() }],
			right: [{ right: T() }],
			bottom: [{ bottom: T() }],
			left: [{ left: T() }],
			visibility: [
				"visible",
				"invisible",
				"collapse"
			],
			z: [{ z: [
				me,
				"auto",
				B,
				z
			] }],
			basis: [{ basis: [
				pe,
				"full",
				"auto",
				s,
				...w()
			] }],
			"flex-direction": [{ flex: [
				"row",
				"row-reverse",
				"col",
				"col-reverse"
			] }],
			"flex-wrap": [{ flex: [
				"nowrap",
				"wrap",
				"wrap-reverse"
			] }],
			flex: [{ flex: [
				R,
				pe,
				"auto",
				"initial",
				"none",
				z
			] }],
			grow: [{ grow: [
				"",
				R,
				B,
				z
			] }],
			shrink: [{ shrink: [
				"",
				R,
				B,
				z
			] }],
			order: [{ order: [
				me,
				"first",
				"last",
				"none",
				B,
				z
			] }],
			"grid-cols": [{ "grid-cols": E() }],
			"col-start-end": [{ col: ee() }],
			"col-start": [{ "col-start": D() }],
			"col-end": [{ "col-end": D() }],
			"grid-rows": [{ "grid-rows": E() }],
			"row-start-end": [{ row: ee() }],
			"row-start": [{ "row-start": D() }],
			"row-end": [{ "row-end": D() }],
			"grid-flow": [{ "grid-flow": [
				"row",
				"col",
				"dense",
				"row-dense",
				"col-dense"
			] }],
			"auto-cols": [{ "auto-cols": O() }],
			"auto-rows": [{ "auto-rows": O() }],
			gap: [{ gap: w() }],
			"gap-x": [{ "gap-x": w() }],
			"gap-y": [{ "gap-y": w() }],
			"justify-content": [{ justify: [...te(), "normal"] }],
			"justify-items": [{ "justify-items": [...k(), "normal"] }],
			"justify-self": [{ "justify-self": ["auto", ...k()] }],
			"align-content": [{ content: ["normal", ...te()] }],
			"align-items": [{ items: [...k(), { baseline: ["", "last"] }] }],
			"align-self": [{ self: [
				"auto",
				...k(),
				{ baseline: ["", "last"] }
			] }],
			"place-content": [{ "place-content": te() }],
			"place-items": [{ "place-items": [...k(), "baseline"] }],
			"place-self": [{ "place-self": ["auto", ...k()] }],
			p: [{ p: w() }],
			px: [{ px: w() }],
			py: [{ py: w() }],
			ps: [{ ps: w() }],
			pe: [{ pe: w() }],
			pbs: [{ pbs: w() }],
			pbe: [{ pbe: w() }],
			pt: [{ pt: w() }],
			pr: [{ pr: w() }],
			pb: [{ pb: w() }],
			pl: [{ pl: w() }],
			m: [{ m: A() }],
			mx: [{ mx: A() }],
			my: [{ my: A() }],
			ms: [{ ms: A() }],
			me: [{ me: A() }],
			mbs: [{ mbs: A() }],
			mbe: [{ mbe: A() }],
			mt: [{ mt: A() }],
			mr: [{ mr: A() }],
			mb: [{ mb: A() }],
			ml: [{ ml: A() }],
			"space-x": [{ "space-x": w() }],
			"space-x-reverse": ["space-x-reverse"],
			"space-y": [{ "space-y": w() }],
			"space-y-reverse": ["space-y-reverse"],
			size: [{ size: j() }],
			"inline-size": [{ inline: ["auto", ...M()] }],
			"min-inline-size": [{ "min-inline": ["auto", ...M()] }],
			"max-inline-size": [{ "max-inline": ["none", ...M()] }],
			"block-size": [{ block: ["auto", ...ne()] }],
			"min-block-size": [{ "min-block": ["auto", ...ne()] }],
			"max-block-size": [{ "max-block": ["none", ...ne()] }],
			w: [{ w: [
				s,
				"screen",
				...j()
			] }],
			"min-w": [{ "min-w": [
				s,
				"screen",
				"none",
				...j()
			] }],
			"max-w": [{ "max-w": [
				s,
				"screen",
				"none",
				"prose",
				{ screen: [o] },
				...j()
			] }],
			h: [{ h: [
				"screen",
				"lh",
				...j()
			] }],
			"min-h": [{ "min-h": [
				"screen",
				"lh",
				"none",
				...j()
			] }],
			"max-h": [{ "max-h": [
				"screen",
				"lh",
				...j()
			] }],
			"font-size": [{ text: [
				"base",
				n,
				Me,
				Te
			] }],
			"font-smoothing": ["antialiased", "subpixel-antialiased"],
			"font-style": ["italic", "not-italic"],
			"font-weight": [{ font: [
				r,
				Re,
				De
			] }],
			"font-stretch": [{ "font-stretch": [
				"ultra-condensed",
				"extra-condensed",
				"condensed",
				"semi-condensed",
				"normal",
				"semi-expanded",
				"expanded",
				"extra-expanded",
				"ultra-expanded",
				he,
				z
			] }],
			"font-family": [{ font: [
				Ne,
				Oe,
				t
			] }],
			"font-features": [{ "font-features": [z] }],
			"fvn-normal": ["normal-nums"],
			"fvn-ordinal": ["ordinal"],
			"fvn-slashed-zero": ["slashed-zero"],
			"fvn-figure": ["lining-nums", "oldstyle-nums"],
			"fvn-spacing": ["proportional-nums", "tabular-nums"],
			"fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
			tracking: [{ tracking: [
				i,
				B,
				z
			] }],
			"line-clamp": [{ "line-clamp": [
				R,
				"none",
				B,
				Ee
			] }],
			leading: [{ leading: [a, ...w()] }],
			"list-image": [{ "list-image": [
				"none",
				B,
				z
			] }],
			"list-style-position": [{ list: ["inside", "outside"] }],
			"list-style-type": [{ list: [
				"disc",
				"decimal",
				"none",
				B,
				z
			] }],
			"text-alignment": [{ text: [
				"left",
				"center",
				"right",
				"justify",
				"start",
				"end"
			] }],
			"placeholder-color": [{ placeholder: N() }],
			"text-color": [{ text: N() }],
			"text-decoration": [
				"underline",
				"overline",
				"line-through",
				"no-underline"
			],
			"text-decoration-style": [{ decoration: [...se(), "wavy"] }],
			"text-decoration-thickness": [{ decoration: [
				R,
				"from-font",
				"auto",
				B,
				Te
			] }],
			"text-decoration-color": [{ decoration: N() }],
			"underline-offset": [{ "underline-offset": [
				R,
				"auto",
				B,
				z
			] }],
			"text-transform": [
				"uppercase",
				"lowercase",
				"capitalize",
				"normal-case"
			],
			"text-overflow": [
				"truncate",
				"text-ellipsis",
				"text-clip"
			],
			"text-wrap": [{ text: [
				"wrap",
				"nowrap",
				"balance",
				"pretty"
			] }],
			indent: [{ indent: w() }],
			"tab-size": [{ tab: [
				me,
				B,
				z
			] }],
			"vertical-align": [{ align: [
				"baseline",
				"top",
				"middle",
				"bottom",
				"text-top",
				"text-bottom",
				"sub",
				"super",
				B,
				z
			] }],
			whitespace: [{ whitespace: [
				"normal",
				"nowrap",
				"pre",
				"pre-line",
				"pre-wrap",
				"break-spaces"
			] }],
			break: [{ break: [
				"normal",
				"words",
				"all",
				"keep"
			] }],
			wrap: [{ wrap: [
				"break-word",
				"anywhere",
				"normal"
			] }],
			hyphens: [{ hyphens: [
				"none",
				"manual",
				"auto"
			] }],
			content: [{ content: [
				"none",
				B,
				z
			] }],
			"bg-attachment": [{ bg: [
				"fixed",
				"local",
				"scroll"
			] }],
			"bg-clip": [{ "bg-clip": [
				"border",
				"padding",
				"content",
				"text"
			] }],
			"bg-origin": [{ "bg-origin": [
				"border",
				"padding",
				"content"
			] }],
			"bg-position": [{ bg: re() }],
			"bg-repeat": [{ bg: ie() }],
			"bg-size": [{ bg: ae() }],
			"bg-image": [{ bg: [
				"none",
				{
					linear: [
						{ to: [
							"t",
							"tr",
							"r",
							"br",
							"b",
							"bl",
							"l",
							"tl"
						] },
						me,
						B,
						z
					],
					radial: [
						"",
						B,
						z
					],
					conic: [
						me,
						B,
						z
					]
				},
				Ie,
				Ae
			] }],
			"bg-color": [{ bg: N() }],
			"gradient-from-pos": [{ from: oe() }],
			"gradient-via-pos": [{ via: oe() }],
			"gradient-to-pos": [{ to: oe() }],
			"gradient-from": [{ from: N() }],
			"gradient-via": [{ via: N() }],
			"gradient-to": [{ to: N() }],
			rounded: [{ rounded: P() }],
			"rounded-s": [{ "rounded-s": P() }],
			"rounded-e": [{ "rounded-e": P() }],
			"rounded-t": [{ "rounded-t": P() }],
			"rounded-r": [{ "rounded-r": P() }],
			"rounded-b": [{ "rounded-b": P() }],
			"rounded-l": [{ "rounded-l": P() }],
			"rounded-ss": [{ "rounded-ss": P() }],
			"rounded-se": [{ "rounded-se": P() }],
			"rounded-ee": [{ "rounded-ee": P() }],
			"rounded-es": [{ "rounded-es": P() }],
			"rounded-tl": [{ "rounded-tl": P() }],
			"rounded-tr": [{ "rounded-tr": P() }],
			"rounded-br": [{ "rounded-br": P() }],
			"rounded-bl": [{ "rounded-bl": P() }],
			"border-w": [{ border: I() }],
			"border-w-x": [{ "border-x": I() }],
			"border-w-y": [{ "border-y": I() }],
			"border-w-s": [{ "border-s": I() }],
			"border-w-e": [{ "border-e": I() }],
			"border-w-bs": [{ "border-bs": I() }],
			"border-w-be": [{ "border-be": I() }],
			"border-w-t": [{ "border-t": I() }],
			"border-w-r": [{ "border-r": I() }],
			"border-w-b": [{ "border-b": I() }],
			"border-w-l": [{ "border-l": I() }],
			"divide-x": [{ "divide-x": I() }],
			"divide-x-reverse": ["divide-x-reverse"],
			"divide-y": [{ "divide-y": I() }],
			"divide-y-reverse": ["divide-y-reverse"],
			"border-style": [{ border: [
				...se(),
				"hidden",
				"none"
			] }],
			"divide-style": [{ divide: [
				...se(),
				"hidden",
				"none"
			] }],
			"border-color": [{ border: N() }],
			"border-color-x": [{ "border-x": N() }],
			"border-color-y": [{ "border-y": N() }],
			"border-color-s": [{ "border-s": N() }],
			"border-color-e": [{ "border-e": N() }],
			"border-color-bs": [{ "border-bs": N() }],
			"border-color-be": [{ "border-be": N() }],
			"border-color-t": [{ "border-t": N() }],
			"border-color-r": [{ "border-r": N() }],
			"border-color-b": [{ "border-b": N() }],
			"border-color-l": [{ "border-l": N() }],
			"divide-color": [{ divide: N() }],
			"outline-style": [{ outline: [
				...se(),
				"none",
				"hidden"
			] }],
			"outline-offset": [{ "outline-offset": [
				R,
				B,
				z
			] }],
			"outline-w": [{ outline: [
				"",
				R,
				Me,
				Te
			] }],
			"outline-color": [{ outline: N() }],
			shadow: [{ shadow: [
				"",
				"none",
				u,
				Le,
				je
			] }],
			"shadow-color": [{ shadow: N() }],
			"inset-shadow": [{ "inset-shadow": [
				"none",
				d,
				Le,
				je
			] }],
			"inset-shadow-color": [{ "inset-shadow": N() }],
			"ring-w": [{ ring: I() }],
			"ring-w-inset": ["ring-inset"],
			"ring-color": [{ ring: N() }],
			"ring-offset-w": [{ "ring-offset": [R, Te] }],
			"ring-offset-color": [{ "ring-offset": N() }],
			"inset-ring-w": [{ "inset-ring": I() }],
			"inset-ring-color": [{ "inset-ring": N() }],
			"text-shadow": [{ "text-shadow": [
				"none",
				f,
				Le,
				je
			] }],
			"text-shadow-color": [{ "text-shadow": N() }],
			opacity: [{ opacity: [
				R,
				B,
				z
			] }],
			"mix-blend": [{ "mix-blend": [
				...ce(),
				"plus-darker",
				"plus-lighter"
			] }],
			"bg-blend": [{ "bg-blend": ce() }],
			"mask-clip": [{ "mask-clip": [
				"border",
				"padding",
				"content",
				"fill",
				"stroke",
				"view"
			] }, "mask-no-clip"],
			"mask-composite": [{ mask: [
				"add",
				"subtract",
				"intersect",
				"exclude"
			] }],
			"mask-image-linear-pos": [{ "mask-linear": [R] }],
			"mask-image-linear-from-pos": [{ "mask-linear-from": L() }],
			"mask-image-linear-to-pos": [{ "mask-linear-to": L() }],
			"mask-image-linear-from-color": [{ "mask-linear-from": N() }],
			"mask-image-linear-to-color": [{ "mask-linear-to": N() }],
			"mask-image-t-from-pos": [{ "mask-t-from": L() }],
			"mask-image-t-to-pos": [{ "mask-t-to": L() }],
			"mask-image-t-from-color": [{ "mask-t-from": N() }],
			"mask-image-t-to-color": [{ "mask-t-to": N() }],
			"mask-image-r-from-pos": [{ "mask-r-from": L() }],
			"mask-image-r-to-pos": [{ "mask-r-to": L() }],
			"mask-image-r-from-color": [{ "mask-r-from": N() }],
			"mask-image-r-to-color": [{ "mask-r-to": N() }],
			"mask-image-b-from-pos": [{ "mask-b-from": L() }],
			"mask-image-b-to-pos": [{ "mask-b-to": L() }],
			"mask-image-b-from-color": [{ "mask-b-from": N() }],
			"mask-image-b-to-color": [{ "mask-b-to": N() }],
			"mask-image-l-from-pos": [{ "mask-l-from": L() }],
			"mask-image-l-to-pos": [{ "mask-l-to": L() }],
			"mask-image-l-from-color": [{ "mask-l-from": N() }],
			"mask-image-l-to-color": [{ "mask-l-to": N() }],
			"mask-image-x-from-pos": [{ "mask-x-from": L() }],
			"mask-image-x-to-pos": [{ "mask-x-to": L() }],
			"mask-image-x-from-color": [{ "mask-x-from": N() }],
			"mask-image-x-to-color": [{ "mask-x-to": N() }],
			"mask-image-y-from-pos": [{ "mask-y-from": L() }],
			"mask-image-y-to-pos": [{ "mask-y-to": L() }],
			"mask-image-y-from-color": [{ "mask-y-from": N() }],
			"mask-image-y-to-color": [{ "mask-y-to": N() }],
			"mask-image-radial": [{ "mask-radial": [B, z] }],
			"mask-image-radial-from-pos": [{ "mask-radial-from": L() }],
			"mask-image-radial-to-pos": [{ "mask-radial-to": L() }],
			"mask-image-radial-from-color": [{ "mask-radial-from": N() }],
			"mask-image-radial-to-color": [{ "mask-radial-to": N() }],
			"mask-image-radial-shape": [{ "mask-radial": ["circle", "ellipse"] }],
			"mask-image-radial-size": [{ "mask-radial": [{
				closest: ["side", "corner"],
				farthest: ["side", "corner"]
			}] }],
			"mask-image-radial-pos": [{ "mask-radial-at": b() }],
			"mask-image-conic-pos": [{ "mask-conic": [R] }],
			"mask-image-conic-from-pos": [{ "mask-conic-from": L() }],
			"mask-image-conic-to-pos": [{ "mask-conic-to": L() }],
			"mask-image-conic-from-color": [{ "mask-conic-from": N() }],
			"mask-image-conic-to-color": [{ "mask-conic-to": N() }],
			"mask-mode": [{ mask: [
				"alpha",
				"luminance",
				"match"
			] }],
			"mask-origin": [{ "mask-origin": [
				"border",
				"padding",
				"content",
				"fill",
				"stroke",
				"view"
			] }],
			"mask-position": [{ mask: re() }],
			"mask-repeat": [{ mask: ie() }],
			"mask-size": [{ mask: ae() }],
			"mask-type": [{ "mask-type": ["alpha", "luminance"] }],
			"mask-image": [{ mask: [
				"none",
				B,
				z
			] }],
			filter: [{ filter: [
				"",
				"none",
				B,
				z
			] }],
			blur: [{ blur: le() }],
			brightness: [{ brightness: [
				R,
				B,
				z
			] }],
			contrast: [{ contrast: [
				R,
				B,
				z
			] }],
			"drop-shadow": [{ "drop-shadow": [
				"",
				"none",
				p,
				Le,
				je
			] }],
			"drop-shadow-color": [{ "drop-shadow": N() }],
			grayscale: [{ grayscale: [
				"",
				R,
				B,
				z
			] }],
			"hue-rotate": [{ "hue-rotate": [
				R,
				B,
				z
			] }],
			invert: [{ invert: [
				"",
				R,
				B,
				z
			] }],
			saturate: [{ saturate: [
				R,
				B,
				z
			] }],
			sepia: [{ sepia: [
				"",
				R,
				B,
				z
			] }],
			"backdrop-filter": [{ "backdrop-filter": [
				"",
				"none",
				B,
				z
			] }],
			"backdrop-blur": [{ "backdrop-blur": le() }],
			"backdrop-brightness": [{ "backdrop-brightness": [
				R,
				B,
				z
			] }],
			"backdrop-contrast": [{ "backdrop-contrast": [
				R,
				B,
				z
			] }],
			"backdrop-grayscale": [{ "backdrop-grayscale": [
				"",
				R,
				B,
				z
			] }],
			"backdrop-hue-rotate": [{ "backdrop-hue-rotate": [
				R,
				B,
				z
			] }],
			"backdrop-invert": [{ "backdrop-invert": [
				"",
				R,
				B,
				z
			] }],
			"backdrop-opacity": [{ "backdrop-opacity": [
				R,
				B,
				z
			] }],
			"backdrop-saturate": [{ "backdrop-saturate": [
				R,
				B,
				z
			] }],
			"backdrop-sepia": [{ "backdrop-sepia": [
				"",
				R,
				B,
				z
			] }],
			"border-collapse": [{ border: ["collapse", "separate"] }],
			"border-spacing": [{ "border-spacing": w() }],
			"border-spacing-x": [{ "border-spacing-x": w() }],
			"border-spacing-y": [{ "border-spacing-y": w() }],
			"table-layout": [{ table: ["auto", "fixed"] }],
			caption: [{ caption: ["top", "bottom"] }],
			transition: [{ transition: [
				"",
				"all",
				"colors",
				"opacity",
				"shadow",
				"transform",
				"none",
				B,
				z
			] }],
			"transition-behavior": [{ transition: ["normal", "discrete"] }],
			duration: [{ duration: [
				R,
				"initial",
				B,
				z
			] }],
			ease: [{ ease: [
				"linear",
				"initial",
				_,
				B,
				z
			] }],
			delay: [{ delay: [
				R,
				B,
				z
			] }],
			animate: [{ animate: [
				"none",
				v,
				B,
				z
			] }],
			backface: [{ backface: ["hidden", "visible"] }],
			perspective: [{ perspective: [
				h,
				B,
				z
			] }],
			"perspective-origin": [{ "perspective-origin": x() }],
			rotate: [{ rotate: ue() }],
			"rotate-x": [{ "rotate-x": ue() }],
			"rotate-y": [{ "rotate-y": ue() }],
			"rotate-z": [{ "rotate-z": ue() }],
			scale: [{ scale: de() }],
			"scale-x": [{ "scale-x": de() }],
			"scale-y": [{ "scale-y": de() }],
			"scale-z": [{ "scale-z": de() }],
			"scale-3d": ["scale-3d"],
			skew: [{ skew: fe() }],
			"skew-x": [{ "skew-x": fe() }],
			"skew-y": [{ "skew-y": fe() }],
			transform: [{ transform: [
				B,
				z,
				"",
				"none",
				"gpu",
				"cpu"
			] }],
			"transform-origin": [{ origin: x() }],
			"transform-style": [{ transform: ["3d", "flat"] }],
			translate: [{ translate: ve() }],
			"translate-x": [{ "translate-x": ve() }],
			"translate-y": [{ "translate-y": ve() }],
			"translate-z": [{ "translate-z": ve() }],
			"translate-none": ["translate-none"],
			zoom: [{ zoom: [
				me,
				B,
				z
			] }],
			accent: [{ accent: N() }],
			appearance: [{ appearance: ["none", "auto"] }],
			"caret-color": [{ caret: N() }],
			"color-scheme": [{ scheme: [
				"normal",
				"dark",
				"light",
				"light-dark",
				"only-dark",
				"only-light"
			] }],
			cursor: [{ cursor: [
				"auto",
				"default",
				"pointer",
				"wait",
				"text",
				"move",
				"help",
				"not-allowed",
				"none",
				"context-menu",
				"progress",
				"cell",
				"crosshair",
				"vertical-text",
				"alias",
				"copy",
				"no-drop",
				"grab",
				"grabbing",
				"all-scroll",
				"col-resize",
				"row-resize",
				"n-resize",
				"e-resize",
				"s-resize",
				"w-resize",
				"ne-resize",
				"nw-resize",
				"se-resize",
				"sw-resize",
				"ew-resize",
				"ns-resize",
				"nesw-resize",
				"nwse-resize",
				"zoom-in",
				"zoom-out",
				B,
				z
			] }],
			"field-sizing": [{ "field-sizing": ["fixed", "content"] }],
			"pointer-events": [{ "pointer-events": ["auto", "none"] }],
			resize: [{ resize: [
				"none",
				"",
				"y",
				"x"
			] }],
			"scroll-behavior": [{ scroll: ["auto", "smooth"] }],
			"scrollbar-thumb-color": [{ "scrollbar-thumb": N() }],
			"scrollbar-track-color": [{ "scrollbar-track": N() }],
			"scrollbar-gutter": [{ "scrollbar-gutter": [
				"auto",
				"stable",
				"both"
			] }],
			"scrollbar-w": [{ scrollbar: [
				"auto",
				"thin",
				"none"
			] }],
			"scroll-m": [{ "scroll-m": w() }],
			"scroll-mx": [{ "scroll-mx": w() }],
			"scroll-my": [{ "scroll-my": w() }],
			"scroll-ms": [{ "scroll-ms": w() }],
			"scroll-me": [{ "scroll-me": w() }],
			"scroll-mbs": [{ "scroll-mbs": w() }],
			"scroll-mbe": [{ "scroll-mbe": w() }],
			"scroll-mt": [{ "scroll-mt": w() }],
			"scroll-mr": [{ "scroll-mr": w() }],
			"scroll-mb": [{ "scroll-mb": w() }],
			"scroll-ml": [{ "scroll-ml": w() }],
			"scroll-p": [{ "scroll-p": w() }],
			"scroll-px": [{ "scroll-px": w() }],
			"scroll-py": [{ "scroll-py": w() }],
			"scroll-ps": [{ "scroll-ps": w() }],
			"scroll-pe": [{ "scroll-pe": w() }],
			"scroll-pbs": [{ "scroll-pbs": w() }],
			"scroll-pbe": [{ "scroll-pbe": w() }],
			"scroll-pt": [{ "scroll-pt": w() }],
			"scroll-pr": [{ "scroll-pr": w() }],
			"scroll-pb": [{ "scroll-pb": w() }],
			"scroll-pl": [{ "scroll-pl": w() }],
			"snap-align": [{ snap: [
				"start",
				"end",
				"center",
				"align-none"
			] }],
			"snap-stop": [{ snap: ["normal", "always"] }],
			"snap-type": [{ snap: [
				"none",
				"x",
				"y",
				"both"
			] }],
			"snap-strictness": [{ snap: ["mandatory", "proximity"] }],
			touch: [{ touch: [
				"auto",
				"none",
				"manipulation"
			] }],
			"touch-x": [{ "touch-pan": [
				"x",
				"left",
				"right"
			] }],
			"touch-y": [{ "touch-pan": [
				"y",
				"up",
				"down"
			] }],
			"touch-pz": ["touch-pinch-zoom"],
			select: [{ select: [
				"none",
				"text",
				"all",
				"auto"
			] }],
			"will-change": [{ "will-change": [
				"auto",
				"scroll",
				"contents",
				"transform",
				B,
				z
			] }],
			fill: [{ fill: ["none", ...N()] }],
			"stroke-w": [{ stroke: [
				R,
				Me,
				Te,
				Ee
			] }],
			stroke: [{ stroke: ["none", ...N()] }],
			"forced-color-adjust": [{ "forced-color-adjust": ["auto", "none"] }]
		},
		conflictingClassGroups: {
			"container-named": ["container-type"],
			overflow: ["overflow-x", "overflow-y"],
			overscroll: ["overscroll-x", "overscroll-y"],
			inset: [
				"inset-x",
				"inset-y",
				"inset-bs",
				"inset-be",
				"start",
				"end",
				"top",
				"right",
				"bottom",
				"left"
			],
			"inset-x": ["right", "left"],
			"inset-y": ["top", "bottom"],
			flex: [
				"basis",
				"grow",
				"shrink"
			],
			gap: ["gap-x", "gap-y"],
			p: [
				"px",
				"py",
				"ps",
				"pe",
				"pbs",
				"pbe",
				"pt",
				"pr",
				"pb",
				"pl"
			],
			px: ["pr", "pl"],
			py: ["pt", "pb"],
			m: [
				"mx",
				"my",
				"ms",
				"me",
				"mbs",
				"mbe",
				"mt",
				"mr",
				"mb",
				"ml"
			],
			mx: ["mr", "ml"],
			my: ["mt", "mb"],
			size: ["w", "h"],
			"font-size": ["leading"],
			"fvn-normal": [
				"fvn-ordinal",
				"fvn-slashed-zero",
				"fvn-figure",
				"fvn-spacing",
				"fvn-fraction"
			],
			"fvn-ordinal": ["fvn-normal"],
			"fvn-slashed-zero": ["fvn-normal"],
			"fvn-figure": ["fvn-normal"],
			"fvn-spacing": ["fvn-normal"],
			"fvn-fraction": ["fvn-normal"],
			"line-clamp": ["display", "overflow"],
			rounded: [
				"rounded-s",
				"rounded-e",
				"rounded-t",
				"rounded-r",
				"rounded-b",
				"rounded-l",
				"rounded-ss",
				"rounded-se",
				"rounded-ee",
				"rounded-es",
				"rounded-tl",
				"rounded-tr",
				"rounded-br",
				"rounded-bl"
			],
			"rounded-s": ["rounded-ss", "rounded-es"],
			"rounded-e": ["rounded-se", "rounded-ee"],
			"rounded-t": ["rounded-tl", "rounded-tr"],
			"rounded-r": ["rounded-tr", "rounded-br"],
			"rounded-b": ["rounded-br", "rounded-bl"],
			"rounded-l": ["rounded-tl", "rounded-bl"],
			"border-spacing": ["border-spacing-x", "border-spacing-y"],
			"border-w": [
				"border-w-x",
				"border-w-y",
				"border-w-s",
				"border-w-e",
				"border-w-bs",
				"border-w-be",
				"border-w-t",
				"border-w-r",
				"border-w-b",
				"border-w-l"
			],
			"border-w-x": ["border-w-r", "border-w-l"],
			"border-w-y": ["border-w-t", "border-w-b"],
			"border-color": [
				"border-color-x",
				"border-color-y",
				"border-color-s",
				"border-color-e",
				"border-color-bs",
				"border-color-be",
				"border-color-t",
				"border-color-r",
				"border-color-b",
				"border-color-l"
			],
			"border-color-x": ["border-color-r", "border-color-l"],
			"border-color-y": ["border-color-t", "border-color-b"],
			translate: [
				"translate-x",
				"translate-y",
				"translate-none"
			],
			"translate-none": [
				"translate",
				"translate-x",
				"translate-y",
				"translate-z"
			],
			"scroll-m": [
				"scroll-mx",
				"scroll-my",
				"scroll-ms",
				"scroll-me",
				"scroll-mbs",
				"scroll-mbe",
				"scroll-mt",
				"scroll-mr",
				"scroll-mb",
				"scroll-ml"
			],
			"scroll-mx": ["scroll-mr", "scroll-ml"],
			"scroll-my": ["scroll-mt", "scroll-mb"],
			"scroll-p": [
				"scroll-px",
				"scroll-py",
				"scroll-ps",
				"scroll-pe",
				"scroll-pbs",
				"scroll-pbe",
				"scroll-pt",
				"scroll-pr",
				"scroll-pb",
				"scroll-pl"
			],
			"scroll-px": ["scroll-pr", "scroll-pl"],
			"scroll-py": ["scroll-pt", "scroll-pb"],
			touch: [
				"touch-x",
				"touch-y",
				"touch-pz"
			],
			"touch-x": ["touch"],
			"touch-y": ["touch"],
			"touch-pz": ["touch"]
		},
		conflictingClassGroupModifiers: { "font-size": ["leading"] },
		postfixLookupClassGroups: ["container-type"],
		orderSensitiveModifiers: [
			"*",
			"**",
			"after",
			"backdrop",
			"before",
			"details-content",
			"file",
			"first-letter",
			"first-line",
			"marker",
			"placeholder",
			"selection"
		]
	};
});
//#endregion
//#region src/utils/cn.ts
function V(...e) {
	return Ye(c(e));
}
//#endregion
//#region ../../node_modules/@radix-ui/react-compose-refs/dist/index.mjs
var Xe = Object.defineProperty, Ze = (e, t) => Xe(e, "name", {
	value: t,
	configurable: !0
});
function Qe(e, t) {
	if (typeof e == "function") return e(t);
	e != null && (e.current = t);
}
Ze(Qe, "setRef");
function $e(...e) {
	return (t) => {
		let n = !1, r = e.map((e) => {
			let r = Qe(e, t);
			return !n && typeof r == "function" && (n = !0), r;
		});
		if (n) return () => {
			for (let t = 0; t < r.length; t++) {
				let n = r[t];
				typeof n == "function" ? n() : Qe(e[t], null);
			}
		};
	};
}
Ze($e, "composeRefs");
function H(...t) {
	return e.useCallback($e(...t), t);
}
Ze(H, "useComposedRefs");
//#endregion
//#region ../../node_modules/@radix-ui/react-slot/dist/index.mjs
var et = Object.defineProperty, tt = (e, t) => et(e, "name", {
	value: t,
	configurable: !0
}), nt = /* @__PURE__ */ tt(((e, t) => {
	let n = { ...t };
	for (let r in t) {
		let i = e[r], a = t[r];
		if (/^on[A-Z]/.test(r)) if (i && a) {
			let e = typeof i == "function", t = typeof a == "function";
			n[r] = (...n) => {
				let r = t ? a(...n) : void 0;
				return e && i(...n), r;
			};
		} else i && (n[r] = i);
		else r === "style" ? n[r] = {
			...typeof i == "object" ? i : null,
			...typeof a == "object" ? a : null
		} : r === "className" ? n[r] = [i, a].filter(Boolean).join(" ") : r === "aria-describedby" && (n[r] = rt(a, i));
	}
	return {
		...e,
		...n
	};
}), "mergeProps");
function rt(...e) {
	let t = /* @__PURE__ */ new Set();
	for (let n of e) if (typeof n == "string") for (let e of String(n).trim().split(/\s+/)) e && t.add(e);
	return t.size > 0 ? Array.from(t).join(" ") : void 0;
}
tt(rt, "concatAriaDescribedby");
var it = e.createContext(nt);
it.displayName = "SlotContext";
// @__NO_SIDE_EFFECTS__
function at(t) {
	let n = e.forwardRef((n, r) => {
		let i = e.useContext(it), { children: a, mergeProps: o = i, ...s } = n, c = null, l = !1, u = [];
		pt(a) && typeof _t == "function" && (a = _t(a._payload)), e.Children.forEach(a, (e) => {
			if (dt(e)) {
				l = !0;
				let t = e, n = "child" in t.props ? t.props.child : t.props.children;
				pt(n) && typeof _t == "function" && (n = _t(n._payload)), c = lt(t, n), u.push(c?.props?.children);
			} else u.push(e);
		}), c ? c = e.cloneElement(c, void 0, u) : !l && e.Children.count(a) === 1 && e.isValidElement(a) && (c = a);
		let d = c ? ut(c) : void 0, f = H(r, d);
		if (!c) {
			if (a || a === 0) throw Error(l ? gt(t) : ht(t));
			return a;
		}
		let p = o(s, c.props ?? {});
		return c.type !== e.Fragment && (p.ref = r ? f : d), e.cloneElement(c, p);
	});
	return n.displayName = `${t}.Slot`, n;
}
tt(at, "createSlot");
var ot = /* @__PURE__ */ at("Slot"), st = Symbol.for("radix.slottable");
// @__NO_SIDE_EFFECTS__
function ct(e) {
	let t = /* @__PURE__ */ tt((e) => "child" in e ? e.children(e.child) : e.children, "Slottable");
	return t.displayName = `${e}.Slottable`, t.__radixId = st, t;
}
tt(ct, "createSlottable");
var lt = /* @__PURE__ */ tt((t, n) => {
	if ("child" in t.props) {
		let n = t.props.child;
		return e.isValidElement(n) ? e.cloneElement(n, void 0, t.props.children(n.props.children)) : null;
	}
	return e.isValidElement(n) ? n : null;
}, "getSlottableElementFromSlottable");
function ut(e) {
	let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
	return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
tt(ut, "getElementRef");
function dt(t) {
	return e.isValidElement(t) && typeof t.type == "function" && "__radixId" in t.type && t.type.__radixId === st;
}
tt(dt, "isSlottable");
var ft = Symbol.for("react.lazy");
function pt(e) {
	return typeof e == "object" && !!e && "$$typeof" in e && e.$$typeof === ft && "_payload" in e && mt(e._payload);
}
tt(pt, "isLazyComponent");
function mt(e) {
	return typeof e == "object" && !!e && "then" in e;
}
tt(mt, "isPromiseLike");
var ht = /* @__PURE__ */ tt((e) => `${e} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`, "createSlotError"), gt = /* @__PURE__ */ tt((e) => `${e} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`, "createSlottableError"), _t = e.use, vt = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, yt = c, U = (e, t) => (n) => {
	if (t?.variants == null) return yt(e, n?.class, n?.className);
	let { variants: r, defaultVariants: i } = t, a = Object.keys(r).map((e) => {
		let t = n?.[e], a = i?.[e];
		if (t === null) return null;
		let o = vt(t) || vt(a);
		return r[e][o];
	}), o = n && Object.entries(n).reduce((e, t) => {
		let [n, r] = t;
		return r === void 0 || (e[n] = r), e;
	}, {});
	return yt(e, a, t?.compoundVariants?.reduce((e, t) => {
		let { class: n, className: r, ...a } = t;
		return Object.entries(a).every((e) => {
			let [t, n] = e;
			return Array.isArray(n) ? n.includes({
				...i,
				...o
			}[t]) : {
				...i,
				...o
			}[t] === n;
		}) ? [
			...e,
			n,
			r
		] : e;
	}, []), n?.class, n?.className);
}, bt = U([
	"inline-flex items-center justify-center gap-2",
	"font-semibold",
	"transition-all duration-200",
	"focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2",
	"disabled:pointer-events-none disabled:opacity-50",
	"whitespace-nowrap",
	"active:scale-[0.98]"
], {
	variants: {
		variant: {
			primary: [
				"bg-gradient-to-br from-primary-500 to-primary-700 text-white",
				"hover:from-primary-600 hover:to-primary-800",
				"hover:shadow-glow-primary hover:scale-[1.02]",
				"focus-visible:ring-primary-500",
				"shadow-md"
			],
			secondary: [
				"bg-white text-zinc-700",
				"border border-zinc-200",
				"hover:bg-zinc-50 hover:border-zinc-300 hover:scale-[1.02]",
				"focus-visible:ring-primary-500",
				"shadow-sm"
			],
			danger: [
				"bg-gradient-to-br from-red-500 to-red-700 text-white",
				"hover:from-red-600 hover:to-red-800",
				"hover:shadow-lg hover:scale-[1.02]",
				"focus-visible:ring-red-500",
				"shadow-md"
			],
			ghost: [
				"bg-transparent text-zinc-700",
				"hover:bg-zinc-100",
				"focus-visible:ring-primary-500"
			],
			outline: [
				"bg-transparent text-primary-600",
				"border-2 border-primary-300",
				"hover:bg-primary-50 hover:border-primary-400 hover:scale-[1.02]",
				"focus-visible:ring-primary-500"
			],
			link: [
				"bg-transparent text-primary-600",
				"hover:text-primary-700",
				"focus-visible:ring-primary-500",
				"p-0 h-auto",
				"relative after:absolute after:bottom-0 after:left-0 after:h-[1px] after:w-0 after:bg-primary-600 after:transition-all after:duration-200 hover:after:w-full"
			],
			accent: [
				"bg-gradient-to-br from-accent-400 to-accent-600 text-white",
				"hover:from-accent-500 hover:to-accent-700",
				"hover:shadow-glow-accent hover:scale-[1.02]",
				"focus-visible:ring-accent-500",
				"shadow-md"
			]
		},
		size: {
			sm: "h-8 px-3 text-sm rounded-lg",
			md: "h-10 px-4 text-sm rounded-lg",
			lg: "h-12 px-6 text-base rounded-xl",
			icon: "h-10 w-10 rounded-lg",
			"icon-sm": "h-8 w-8 rounded-lg"
		}
	},
	defaultVariants: {
		variant: "primary",
		size: "md"
	}
}), xt = U("animate-spin", {
	variants: { size: {
		sm: "h-3 w-3",
		md: "h-4 w-4",
		lg: "h-5 w-5",
		icon: "h-4 w-4",
		"icon-sm": "h-3 w-3"
	} },
	defaultVariants: { size: "md" }
});
function St({ className: e }) {
	return /* @__PURE__ */ a("svg", {
		className: e,
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		children: [/* @__PURE__ */ i("circle", {
			className: "opacity-25",
			cx: "12",
			cy: "12",
			r: "10",
			stroke: "currentColor",
			strokeWidth: "4"
		}), /* @__PURE__ */ i("path", {
			className: "opacity-75",
			fill: "currentColor",
			d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
		})]
	});
}
var Ct = e.forwardRef(({ className: e, variant: t, size: n, asChild: o = !1, loading: s = !1, disabled: c, leftIcon: l, rightIcon: u, children: d, ...f }, p) => {
	let m = o ? ot : "button", h = c || s;
	return /* @__PURE__ */ i(m, {
		className: V(bt({
			variant: t,
			size: n,
			className: e
		})),
		ref: p,
		disabled: h,
		...f,
		children: s ? /* @__PURE__ */ a(r, { children: [/* @__PURE__ */ i(St, { className: V(xt({ size: n })) }), /* @__PURE__ */ i("span", { children: d })] }) : /* @__PURE__ */ a(r, { children: [
			l && /* @__PURE__ */ i("span", {
				className: "shrink-0",
				children: l
			}),
			d,
			u && /* @__PURE__ */ i("span", {
				className: "shrink-0",
				children: u
			})
		] })
	});
});
Ct.displayName = "Button";
//#endregion
//#region src/components/input/Input.tsx
var wt = U([
	"flex w-full",
	"bg-white",
	"border border-gray-300",
	"text-gray-900 placeholder:text-gray-400",
	"transition-colors duration-150",
	"focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-0 focus:border-primary-500",
	"disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500"
], {
	variants: {
		size: {
			sm: "h-8 px-3 text-sm rounded-md",
			md: "h-10 px-3 text-sm rounded-lg",
			lg: "h-12 px-4 text-base rounded-lg"
		},
		hasError: {
			true: "border-red-500 focus:ring-red-500 focus:border-red-500",
			false: ""
		}
	},
	defaultVariants: {
		size: "md",
		hasError: !1
	}
}), Tt = U("block text-sm font-medium text-gray-700 mb-1.5"), Et = U("mt-1.5 text-sm", {
	variants: { hasError: {
		true: "text-red-600",
		false: "text-gray-500"
	} },
	defaultVariants: { hasError: !1 }
}), Dt = e.forwardRef(({ className: t, type: n = "text", size: r, label: o, helperText: s, error: c, leftElement: l, rightElement: u, wrapperClassName: d, id: f, ...p }, m) => {
	let h = f || e.useId(), g = c || !1;
	return /* @__PURE__ */ a("div", {
		className: V("w-full", d),
		children: [
			o && /* @__PURE__ */ i("label", {
				htmlFor: h,
				className: Tt(),
				children: o
			}),
			/* @__PURE__ */ a("div", {
				className: "relative",
				children: [
					l && /* @__PURE__ */ i("div", {
						className: "absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none text-gray-400",
						children: l
					}),
					/* @__PURE__ */ i("input", {
						type: n,
						id: h,
						className: V(wt({
							size: r,
							hasError: g
						}), l && "pl-10", u && "pr-10", t),
						ref: m,
						"aria-invalid": g,
						"aria-describedby": s ? `${h}-helper` : void 0,
						...p
					}),
					u && /* @__PURE__ */ i("div", {
						className: "absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none text-gray-400",
						children: u
					})
				]
			}),
			s && /* @__PURE__ */ i("p", {
				id: `${h}-helper`,
				className: Et({ hasError: g }),
				children: s
			})
		]
	});
});
Dt.displayName = "Input";
//#endregion
//#region src/components/card/Card.tsx
var Ot = U("bg-white rounded-xl border border-zinc-100 overflow-hidden", {
	variants: {
		shadow: {
			none: "",
			subtle: "shadow-subtle",
			card: "shadow-card",
			elevated: "shadow-elevated"
		},
		padding: {
			none: "",
			sm: "p-4",
			md: "p-6",
			lg: "p-8"
		},
		interactive: {
			true: ["transition-all duration-200 cursor-pointer", "hover:shadow-elevated hover:scale-[1.01] hover:border-zinc-200"],
			false: ""
		},
		accent: {
			none: "",
			primary: "border-t-2 border-t-primary-500",
			accent: "border-t-2 border-t-accent-500",
			gradient: "relative before:absolute before:top-0 before:left-0 before:right-0 before:h-0.5 before:bg-gradient-to-r before:from-primary-500 before:to-accent-500"
		}
	},
	defaultVariants: {
		shadow: "card",
		padding: "none",
		interactive: !1,
		accent: "none"
	}
}), kt = e.forwardRef(({ className: e, shadow: t, padding: n, interactive: r, accent: a, ...o }, s) => /* @__PURE__ */ i("div", {
	ref: s,
	className: V(Ot({
		shadow: t,
		padding: n,
		interactive: r,
		accent: a
	}), e),
	...o
}));
kt.displayName = "Card";
var At = U("flex items-center justify-between px-6 py-4 border-b border-zinc-100"), jt = e.forwardRef(({ className: e, title: t, description: n, action: o, children: s, ...c }, l) => /* @__PURE__ */ i("div", {
	ref: l,
	className: V(At(), e),
	...c,
	children: s || /* @__PURE__ */ a(r, { children: [/* @__PURE__ */ a("div", { children: [t && /* @__PURE__ */ i("h3", {
		className: "text-base font-semibold text-zinc-900",
		children: t
	}), n && /* @__PURE__ */ i("p", {
		className: "mt-0.5 text-sm text-zinc-500",
		children: n
	})] }), o && /* @__PURE__ */ i("div", {
		className: "shrink-0 ml-4",
		children: o
	})] })
}));
jt.displayName = "CardHeader";
var Mt = U("px-6 py-4"), Nt = e.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i("div", {
	ref: n,
	className: V(Mt(), e),
	...t
}));
Nt.displayName = "CardContent";
var Pt = U("flex items-center px-6 py-4 border-t border-zinc-100 bg-zinc-50/50 rounded-b-xl"), Ft = e.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i("div", {
	ref: n,
	className: V(Pt(), e),
	...t
}));
Ft.displayName = "CardFooter";
//#endregion
//#region src/components/badge/Badge.tsx
var It = U([
	"inline-flex items-center",
	"font-semibold",
	"whitespace-nowrap",
	"transition-all duration-200"
], {
	variants: {
		variant: {
			default: "bg-zinc-100 text-zinc-700",
			primary: "bg-primary-100 text-primary-700",
			success: "bg-emerald-100 text-emerald-700",
			warning: "bg-amber-100 text-amber-700",
			error: "bg-red-100 text-red-700",
			info: "bg-blue-100 text-blue-700",
			accent: "bg-accent-500/15 text-accent-600"
		},
		size: {
			sm: "px-2 py-0.5 text-xs rounded-md",
			md: "px-2.5 py-0.5 text-xs rounded-lg",
			lg: "px-3 py-1 text-sm rounded-lg"
		},
		outline: {
			true: "bg-transparent border",
			false: ""
		},
		dot: {
			true: "",
			false: ""
		},
		glow: {
			true: "",
			false: ""
		},
		pulse: {
			true: "",
			false: ""
		}
	},
	compoundVariants: [
		{
			variant: "default",
			outline: !0,
			className: "border-zinc-300 text-zinc-600"
		},
		{
			variant: "primary",
			outline: !0,
			className: "border-primary-300 text-primary-600"
		},
		{
			variant: "success",
			outline: !0,
			className: "border-emerald-300 text-emerald-600"
		},
		{
			variant: "warning",
			outline: !0,
			className: "border-amber-400 text-amber-600"
		},
		{
			variant: "error",
			outline: !0,
			className: "border-red-300 text-red-600"
		},
		{
			variant: "info",
			outline: !0,
			className: "border-blue-300 text-blue-600"
		},
		{
			variant: "accent",
			outline: !0,
			className: "border-accent-400 text-accent-600"
		},
		{
			variant: "success",
			glow: !0,
			className: "shadow-[0_0_12px_rgba(34,197,94,0.3)]"
		},
		{
			variant: "primary",
			glow: !0,
			className: "shadow-[0_0_12px_rgba(61,100,147,0.3)]"
		},
		{
			variant: "error",
			glow: !0,
			className: "shadow-[0_0_12px_rgba(239,68,68,0.3)]"
		},
		{
			variant: "accent",
			glow: !0,
			className: "shadow-[0_0_12px_rgba(6,182,212,0.3)]"
		}
	],
	defaultVariants: {
		variant: "default",
		size: "md",
		outline: !1,
		dot: !1,
		glow: !1,
		pulse: !1
	}
}), Lt = U("rounded-full mr-1.5", {
	variants: {
		variant: {
			default: "bg-zinc-400",
			primary: "bg-primary-500",
			success: "bg-emerald-500",
			warning: "bg-amber-500",
			error: "bg-red-500",
			info: "bg-blue-500",
			accent: "bg-accent-500"
		},
		size: {
			sm: "h-1.5 w-1.5",
			md: "h-1.5 w-1.5",
			lg: "h-2 w-2"
		},
		pulse: {
			true: "animate-pulse",
			false: ""
		}
	},
	defaultVariants: {
		variant: "default",
		size: "md",
		pulse: !1
	}
}), Rt = e.forwardRef(({ className: e, variant: t, size: n, outline: r, dot: o, glow: s, pulse: c, children: l, ...u }, d) => /* @__PURE__ */ a("span", {
	ref: d,
	className: V(It({
		variant: t,
		size: n,
		outline: r,
		dot: o,
		glow: s,
		pulse: c
	}), e),
	...u,
	children: [o && /* @__PURE__ */ i("span", { className: Lt({
		variant: t,
		size: n,
		pulse: c || !1
	}) }), l]
}));
Rt.displayName = "Badge";
//#endregion
//#region src/components/table/Table.tsx
var zt = e.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i("div", {
	className: "relative w-full overflow-auto",
	children: /* @__PURE__ */ i("table", {
		ref: n,
		className: V("w-full caption-bottom text-sm", e),
		...t
	})
}));
zt.displayName = "Table";
var Bt = e.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i("thead", {
	ref: n,
	className: V("bg-gray-50 border-b border-gray-200", e),
	...t
}));
Bt.displayName = "TableHeader";
var Vt = e.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i("tbody", {
	ref: n,
	className: V("divide-y divide-gray-100", e),
	...t
}));
Vt.displayName = "TableBody";
var Ht = e.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i("tfoot", {
	ref: n,
	className: V("border-t border-gray-200 bg-gray-50 font-medium", e),
	...t
}));
Ht.displayName = "TableFooter";
var Ut = e.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i("tr", {
	ref: n,
	className: V("transition-colors hover:bg-gray-50/50", e),
	...t
}));
Ut.displayName = "TableRow";
var Wt = e.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i("th", {
	ref: n,
	className: V("h-11 px-4 text-left align-middle font-semibold text-gray-600 text-xs uppercase tracking-wide", "[&:has([role=checkbox])]:pr-0", e),
	...t
}));
Wt.displayName = "TableHead";
var Gt = e.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i("td", {
	ref: n,
	className: V("px-4 py-3 align-middle text-gray-700", "[&:has([role=checkbox])]:pr-0", e),
	...t
}));
Gt.displayName = "TableCell";
var Kt = e.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i("caption", {
	ref: n,
	className: V("mt-4 text-sm text-gray-500", e),
	...t
}));
Kt.displayName = "TableCaption";
function qt({ icon: e, title: t, description: n, action: r }) {
	return /* @__PURE__ */ a("div", {
		className: "flex flex-col items-center justify-center py-12 px-4",
		children: [
			e && /* @__PURE__ */ i("div", {
				className: "mb-4 text-gray-300",
				children: e
			}),
			/* @__PURE__ */ i("h3", {
				className: "text-sm font-medium text-gray-900",
				children: t
			}),
			n && /* @__PURE__ */ i("p", {
				className: "mt-1 text-sm text-gray-500 text-center max-w-sm",
				children: n
			}),
			r && /* @__PURE__ */ i("div", {
				className: "mt-4",
				children: r
			})
		]
	});
}
function Jt({ rows: e = 5, columns: t = 4 }) {
	return /* @__PURE__ */ i(r, { children: Array.from({ length: e }).map((e, n) => /* @__PURE__ */ i(Ut, { children: Array.from({ length: t }).map((e, t) => /* @__PURE__ */ i(Gt, { children: /* @__PURE__ */ i("div", { className: "h-4 bg-gray-200 rounded animate-pulse" }) }, t)) }, n)) });
}
//#endregion
//#region ../../node_modules/@radix-ui/primitive/dist/index.mjs
var Yt = Object.defineProperty, Xt = (e, t) => Yt(e, "name", {
	value: t,
	configurable: !0
}), Zt = !!(typeof window < "u" && window.document && window.document.createElement);
function W(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
	return /* @__PURE__ */ Xt(function(r) {
		if (e?.(r), n === !1 || !r || !r.defaultPrevented) return t?.(r);
	}, "handleEvent");
}
Xt(W, "composeEventHandlers");
function Qt(e) {
	if (!Zt) throw Error("Cannot access window outside of the DOM");
	return e?.ownerDocument?.defaultView ?? window;
}
Xt(Qt, "getOwnerWindow");
function $t(e) {
	if (!Zt) throw Error("Cannot access document outside of the DOM");
	return e?.ownerDocument ?? document;
}
Xt($t, "getOwnerDocument");
function en(e, t = !1) {
	let { activeElement: n } = $t(e);
	if (!n?.nodeName) return null;
	if (tn(n) && n.contentDocument) return en(n.contentDocument.body, t);
	if (t) {
		let e = n.getAttribute("aria-activedescendant");
		if (e) {
			let t = $t(n).getElementById(e);
			if (t) return t;
		}
	}
	return n;
}
Xt(en, "getActiveElement");
function tn(e) {
	return e.tagName === "IFRAME";
}
Xt(tn, "isFrame");
//#endregion
//#region ../../node_modules/@radix-ui/react-context/dist/index.mjs
var nn = Object.defineProperty, rn = (e, t) => nn(e, "name", {
	value: t,
	configurable: !0
});
// @__NO_SIDE_EFFECTS__
function an(t, n) {
	let r = e.createContext(n);
	r.displayName = t + "Context";
	let a = /* @__PURE__ */ rn((t) => {
		let { children: n, ...a } = t, o = e.useMemo(() => a, Object.values(a));
		return /* @__PURE__ */ i(r.Provider, {
			value: o,
			children: n
		});
	}, "Provider");
	a.displayName = t + "Provider";
	function o(i, a = {}) {
		let { optional: o = !1 } = a, s = e.useContext(r);
		if (s) return s;
		if (n !== void 0) return n;
		if (!o) throw Error(`\`${i}\` must be used within \`${t}\``);
	}
	return rn(o, "useContext"), [a, o];
}
rn(an, "createContext");
// @__NO_SIDE_EFFECTS__
function on(t, n = []) {
	let r = [];
	function a(n, a) {
		let o = e.createContext(a);
		o.displayName = n + "Context";
		let s = r.length;
		r = [...r, a];
		let c = /* @__PURE__ */ rn((n) => {
			let { scope: r, children: a, ...c } = n, l = r?.[t]?.[s] || o, u = e.useMemo(() => c, Object.values(c));
			return /* @__PURE__ */ i(l.Provider, {
				value: u,
				children: a
			});
		}, "Provider");
		c.displayName = n + "Provider";
		function l(r, i, c = {}) {
			let { optional: l = !1 } = c, u = i?.[t]?.[s] || o, d = e.useContext(u);
			if (d) return d;
			if (a !== void 0) return a;
			if (!l) throw Error(`\`${r}\` must be used within \`${n}\``);
		}
		return rn(l, "useContext"), [c, l];
	}
	rn(a, "createContext");
	let o = /* @__PURE__ */ rn(() => {
		let n = r.map((t) => e.createContext(t));
		return /* @__PURE__ */ rn(function(r) {
			let i = r?.[t] || n;
			return e.useMemo(() => ({ [`__scope${t}`]: {
				...r,
				[t]: i
			} }), [r, i]);
		}, "useScope");
	}, "createScope");
	return o.scopeName = t, [a, sn(o, ...n)];
}
rn(on, "createContextScope");
function sn(...t) {
	let n = t[0];
	if (t.length === 1) return n;
	let r = /* @__PURE__ */ rn(() => {
		let r = t.map((e) => ({
			useScope: e(),
			scopeName: e.scopeName
		}));
		return /* @__PURE__ */ rn(function(t) {
			let i = r.reduce((e, { useScope: n, scopeName: r }) => {
				let i = n(t)[`__scope${r}`];
				return {
					...e,
					...i
				};
			}, {});
			return e.useMemo(() => ({ [`__scope${n.scopeName}`]: i }), [i]);
		}, "useComposedScopes");
	}, "createScope");
	return r.scopeName = n.scopeName, r;
}
rn(sn, "composeContextScopes");
//#endregion
//#region ../../node_modules/@radix-ui/react-use-layout-effect/dist/index.mjs
var cn = globalThis?.document ? e.useLayoutEffect : () => {}, ln = Object.defineProperty, un = (e, t) => ln(e, "name", {
	value: t,
	configurable: !0
}), dn = e.useId || (() => void 0), fn = 0;
function pn(t) {
	let [n, r] = e.useState(dn());
	return cn(() => {
		t || r((e) => e ?? String(fn++));
	}, [t]), t || (n ? `radix-${n}` : "");
}
un(pn, "useId");
//#endregion
//#region ../../node_modules/@radix-ui/react-use-effect-event/dist/index.mjs
var mn = Object.defineProperty, hn = (e, t) => mn(e, "name", {
	value: t,
	configurable: !0
}), gn = e.useEffectEvent, _n = e.useInsertionEffect;
function vn(t) {
	if (typeof gn == "function") return gn(t);
	let n = e.useRef(() => {
		throw Error("Cannot call an event handler while rendering.");
	});
	return typeof _n == "function" ? _n(() => {
		n.current = t;
	}) : cn(() => {
		n.current = t;
	}), e.useMemo(() => ((...e) => n.current?.(...e)), []);
}
hn(vn, "useEffectEvent");
//#endregion
//#region ../../node_modules/@radix-ui/react-use-controllable-state/dist/index.mjs
var yn = Object.defineProperty, bn = (e, t) => yn(e, "name", {
	value: t,
	configurable: !0
}), xn = e.useInsertionEffect || cn;
function Sn({ prop: t, defaultProp: n, onChange: r = /* @__PURE__ */ bn(() => {}, "onChange"), caller: i }) {
	let [a, o, s] = Cn({
		defaultProp: n,
		onChange: r
	}), c = t !== void 0;
	return [c ? t : a, e.useCallback((e) => {
		if (c) {
			let n = wn(e) ? e(t) : e;
			n !== t && s.current?.(n);
		} else o(e);
	}, [
		c,
		t,
		o,
		s
	])];
}
bn(Sn, "useControllableState");
function Cn({ defaultProp: t, onChange: n }) {
	let [r, i] = e.useState(t), a = e.useRef(r), o = e.useRef(n);
	return xn(() => {
		o.current = n;
	}, [n]), e.useEffect(() => {
		a.current !== r && (o.current?.(r), a.current = r);
	}, [r, a]), [
		r,
		i,
		o
	];
}
bn(Cn, "useUncontrolledState");
function wn(e) {
	return typeof e == "function";
}
bn(wn, "isFunction");
var Tn = Symbol("RADIX:SYNC_STATE");
function En(t, n, r, i) {
	let { prop: a, defaultProp: o, onChange: s, caller: c } = n, l = a !== void 0, u = vn(s), d = [{
		...r,
		state: o
	}];
	i && d.push(i);
	let [f, p] = e.useReducer((e, n) => {
		if (n.type === Tn) return {
			...e,
			state: n.state
		};
		let r = t(e, n);
		return l && !Object.is(r.state, e.state) && u(r.state), r;
	}, ...d), m = f.state, h = e.useRef(m);
	e.useEffect(() => {
		h.current !== m && (h.current = m, l || u(m));
	}, [
		m,
		h,
		l
	]);
	let g = e.useMemo(() => a === void 0 ? f : {
		...f,
		state: a
	}, [f, a]);
	return e.useEffect(() => {
		l && !Object.is(a, f.state) && p({
			type: Tn,
			state: a
		});
	}, [
		a,
		f.state,
		l
	]), [g, p];
}
bn(En, "useControllableStateReducer");
//#endregion
//#region ../../node_modules/@radix-ui/react-primitive/dist/index.mjs
var Dn = Object.defineProperty, On = (e, t) => Dn(e, "name", {
	value: t,
	configurable: !0
}), G = [
	"a",
	"button",
	"div",
	"form",
	"h2",
	"h3",
	"img",
	"input",
	"label",
	"li",
	"nav",
	"ol",
	"p",
	"select",
	"span",
	"svg",
	"ul"
].reduce((t, n) => {
	let r = /* @__PURE__ */ at(`Primitive.${n}`), a = e.forwardRef((e, t) => {
		let { asChild: a, ...o } = e, s = a ? r : n;
		return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ i(s, {
			...o,
			ref: t
		});
	});
	return a.displayName = `Primitive.${n}`, {
		...t,
		[n]: a
	};
}, {});
function kn(e, t) {
	e && o.flushSync(() => e.dispatchEvent(t));
}
On(kn, "dispatchDiscreteCustomEvent");
//#endregion
//#region ../../node_modules/@radix-ui/react-use-callback-ref/dist/index.mjs
var An = Object.defineProperty, jn = (e, t) => An(e, "name", {
	value: t,
	configurable: !0
});
function Mn(t) {
	let n = e.useRef(t);
	return e.useEffect(() => {
		n.current = t;
	}), e.useMemo(() => ((...e) => n.current?.(...e)), []);
}
jn(Mn, "useCallbackRef");
//#endregion
//#region ../../node_modules/@radix-ui/react-dismissable-layer/dist/index.mjs
var Nn = Object.defineProperty, K = (e, t) => Nn(e, "name", {
	value: t,
	configurable: !0
}), Pn = "dismissableLayer.update", Fn = "dismissableLayer.pointerDownOutside", In = "dismissableLayer.focusOutside", Ln, Rn = e.createContext({
	layers: /* @__PURE__ */ new Set(),
	layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
	branches: /* @__PURE__ */ new Set(),
	dismissableSurfaces: /* @__PURE__ */ new Set()
}), zn = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ K(function(t, n) {
	let { disableOutsidePointerEvents: r = !1, deferPointerDownOutside: a = !1, onEscapeKeyDown: o, onPointerDownOutside: s, onFocusOutside: c, onInteractOutside: l, onDismiss: u, ...d } = t, f = e.useContext(Rn), [p, m] = e.useState(null), h = p?.ownerDocument ?? globalThis?.document, [, g] = e.useState({}), _ = H(n, m), v = Array.from(f.layers), [y] = [...f.layersWithOutsidePointerEventsDisabled].slice(-1), b = y ? v.indexOf(y) : -1, x = p ? v.indexOf(p) : -1, S = f.layersWithOutsidePointerEventsDisabled.size > 0, C = x >= b, w = e.useRef(!1), T = Hn((e) => {
		s?.(e), l?.(e), e.defaultPrevented || u?.();
	}, {
		ownerDocument: h,
		deferPointerDownOutside: a,
		isDeferredPointerDownOutsideRef: w,
		dismissableSurfaces: f.dismissableSurfaces,
		shouldHandlePointerDownOutside: e.useCallback((e) => {
			if (!(e instanceof Node)) return !1;
			let t = [...f.branches].some((t) => t.contains(e));
			return C && !t;
		}, [f.branches, C])
	}), E = Un((e) => {
		if (a && w.current) return;
		let t = e.target;
		[...f.branches].some((e) => e.contains(t)) || (c?.(e), l?.(e), e.defaultPrevented || u?.());
	}, h), ee = p ? x === v.length - 1 : !1, D = Mn((e) => {
		e.key === "Escape" && (o?.(e), !e.defaultPrevented && u && (e.preventDefault(), u()));
	});
	return e.useEffect(() => {
		if (ee) return h.addEventListener("keydown", D, { capture: !0 }), () => h.removeEventListener("keydown", D, { capture: !0 });
	}, [
		h,
		ee,
		D
	]), e.useEffect(() => {
		if (p) return r && (f.layersWithOutsidePointerEventsDisabled.size === 0 && (Ln = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), f.layersWithOutsidePointerEventsDisabled.add(p)), f.layers.add(p), Wn(), () => {
			r && (f.layersWithOutsidePointerEventsDisabled.delete(p), f.layersWithOutsidePointerEventsDisabled.size === 0 && (h.body.style.pointerEvents = Ln));
		};
	}, [
		p,
		h,
		r,
		f
	]), e.useEffect(() => () => {
		p && (f.layers.delete(p), f.layersWithOutsidePointerEventsDisabled.delete(p), Wn());
	}, [p, f]), e.useEffect(() => {
		let e = /* @__PURE__ */ K(() => g({}), "handleUpdate");
		return document.addEventListener(Pn, e), () => document.removeEventListener(Pn, e);
	}, []), /* @__PURE__ */ i(G.div, {
		...d,
		ref: _,
		style: {
			pointerEvents: S ? C ? "auto" : "none" : void 0,
			...t.style
		},
		onFocusCapture: W(t.onFocusCapture, E.onFocusCapture),
		onBlurCapture: W(t.onBlurCapture, E.onBlurCapture),
		onPointerDownCapture: W(t.onPointerDownCapture, T.onPointerDownCapture)
	});
}, "DismissableLayer"));
function Bn() {
	let t = e.useContext(Rn), [n, r] = e.useState(null);
	return e.useEffect(() => {
		if (n) return t.dismissableSurfaces.add(n), () => {
			t.dismissableSurfaces.delete(n);
		};
	}, [n, t.dismissableSurfaces]), r;
}
K(Bn, "useDismissableLayerSurface");
var Vn = /* @__PURE__ */ K(() => !0, "IS_TRUE");
function Hn(t, n) {
	let { ownerDocument: r = globalThis?.document, deferPointerDownOutside: i = !1, isDeferredPointerDownOutsideRef: a, dismissableSurfaces: o, shouldHandlePointerDownOutside: s = Vn } = n, c = Mn(t), l = e.useRef(!1), u = e.useRef(!1), d = e.useRef(/* @__PURE__ */ new Map()), f = e.useRef(() => {});
	return e.useEffect(() => {
		function e() {
			u.current = !1, a.current = !1, d.current.clear();
		}
		K(e, "resetOutsideInteraction");
		function t() {
			return Array.from(d.current.values()).some(Boolean);
		}
		K(t, "isOutsideInteractionIntercepted");
		function n(e) {
			if (!u.current) return;
			let t = e.target;
			t instanceof Node && [...o].some((e) => e.contains(t)) || d.current.set(e.type, !0), e.type === "click" && window.setTimeout(() => {
				u.current && f.current();
			}, 0);
		}
		K(n, "handleInteractionCapture");
		function p(e) {
			u.current && d.current.set(e.type, !1);
		}
		K(p, "handleInteractionBubble");
		let m = /* @__PURE__ */ K((n) => {
			if (n.target && !l.current) {
				let o = function() {
					r.removeEventListener("click", f.current);
					let n = t();
					e(), n || Gn(Fn, c, p, { discrete: !0 });
				};
				if (K(o, "handleAndDispatchPointerDownOutsideEvent"), !s(n.target)) {
					r.removeEventListener("click", f.current), e(), l.current = !1;
					return;
				}
				let p = { originalEvent: n };
				u.current = !0, a.current = i && n.button === 0, d.current.clear(), !i || n.button !== 0 ? o() : (r.removeEventListener("click", f.current), f.current = o, r.addEventListener("click", f.current, { once: !0 }));
			} else r.removeEventListener("click", f.current), e();
			l.current = !1;
		}, "handlePointerDown"), h = [
			"pointerup",
			"mousedown",
			"mouseup",
			"touchstart",
			"touchend",
			"click"
		];
		for (let e of h) r.addEventListener(e, n, !0), r.addEventListener(e, p);
		let g = window.setTimeout(() => {
			r.addEventListener("pointerdown", m);
		}, 0);
		return () => {
			window.clearTimeout(g), r.removeEventListener("pointerdown", m), r.removeEventListener("click", f.current);
			for (let e of h) r.removeEventListener(e, n, !0), r.removeEventListener(e, p);
		};
	}, [
		r,
		c,
		i,
		a,
		o,
		s
	]), { onPointerDownCapture: /* @__PURE__ */ K(() => l.current = !0, "onPointerDownCapture") };
}
K(Hn, "usePointerDownOutside");
function Un(t, n = globalThis?.document) {
	let r = Mn(t), i = e.useRef(!1);
	return e.useEffect(() => {
		let e = /* @__PURE__ */ K((e) => {
			e.target && !i.current && Gn(In, r, { originalEvent: e }, { discrete: !1 });
		}, "handleFocus");
		return n.addEventListener("focusin", e), () => n.removeEventListener("focusin", e);
	}, [n, r]), {
		onFocusCapture: /* @__PURE__ */ K(() => i.current = !0, "onFocusCapture"),
		onBlurCapture: /* @__PURE__ */ K(() => i.current = !1, "onBlurCapture")
	};
}
K(Un, "useFocusOutside");
function Wn() {
	let e = new CustomEvent(Pn);
	document.dispatchEvent(e);
}
K(Wn, "dispatchUpdate");
function Gn(e, t, n, { discrete: r }) {
	let i = n.originalEvent.target, a = new CustomEvent(e, {
		bubbles: !1,
		cancelable: !0,
		detail: n
	});
	t && i.addEventListener(e, t, { once: !0 }), r ? kn(i, a) : i.dispatchEvent(a);
}
K(Gn, "handleAndDispatchCustomEvent");
//#endregion
//#region ../../node_modules/@radix-ui/react-focus-scope/dist/index.mjs
var Kn = Object.defineProperty, q = (e, t) => Kn(e, "name", {
	value: t,
	configurable: !0
}), qn = "focusScope.autoFocusOnMount", Jn = "focusScope.autoFocusOnUnmount", Yn = {
	bubbles: !1,
	cancelable: !0
}, Xn = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ q(function(t, n) {
	let { loop: r = !1, trapped: a = !1, branches: o, onMountAutoFocus: s, onUnmountAutoFocus: c, ...l } = t, [u, d] = e.useState(null), f = Mn(s), p = Mn(c), m = e.useRef(null), h = H(n, d), g = e.useRef(o);
	e.useEffect(() => {
		g.current = o;
	});
	let _ = e.useCallback((e) => e ? u?.contains(e) ? !0 : !!g.current?.some((t) => t.contains(e)) : !1, [u]), v = e.useRef({
		paused: !1,
		pause() {
			this.paused = !0;
		},
		resume() {
			this.paused = !1;
		}
	}).current;
	e.useEffect(() => {
		if (a) {
			let e = function(e) {
				if (v.paused || !u) return;
				let t = e.target;
				_(t) ? m.current = t : sr(m.current, { select: !0 });
			}, t = function(e) {
				if (v.paused || !u) return;
				let t = e.relatedTarget;
				t !== null && (_(t) || sr(m.current, { select: !0 }));
			}, n = function(e) {
				if (document.activeElement === document.body) for (let t of e) t.removedNodes.length > 0 && sr(u);
			};
			q(e, "handleFocusIn"), q(t, "handleFocusOut"), q(n, "handleMutations"), document.addEventListener("focusin", e), document.addEventListener("focusout", t);
			let r = new MutationObserver(n);
			return u && r.observe(u, {
				childList: !0,
				subtree: !0
			}), () => {
				document.removeEventListener("focusin", e), document.removeEventListener("focusout", t), r.disconnect();
			};
		}
	}, [
		a,
		u,
		v.paused,
		_
	]), e.useEffect(() => {
		if (u) {
			cr.add(v);
			let e = document.activeElement;
			if (!u.contains(e)) {
				let t = new CustomEvent(qn, Yn);
				u.addEventListener(qn, f), u.dispatchEvent(t), t.defaultPrevented || (tr(dr(rr(u)), { select: !0 }), document.activeElement === e && sr(u));
			}
			return () => {
				u.removeEventListener(qn, f), setTimeout(() => {
					let t = new CustomEvent(Jn, Yn);
					u.addEventListener(Jn, p), u.dispatchEvent(t), t.defaultPrevented || sr(e ?? document.body, { select: !0 }), u.removeEventListener(Jn, p), cr.remove(v);
				}, 0);
			};
		}
	}, [
		u,
		f,
		p,
		v
	]);
	let y = e.useCallback((e) => {
		if (!r && !a || v.paused) return;
		let t = e.key === "Tab" && !e.altKey && !e.ctrlKey && !e.metaKey, n = document.activeElement;
		if (t && n) {
			let t = e.currentTarget, [i, a] = nr(t);
			i && a ? !e.shiftKey && n === a ? (e.preventDefault(), r && sr(i, { select: !0 })) : e.shiftKey && n === i && (e.preventDefault(), r && sr(a, { select: !0 })) : n === t && e.preventDefault();
		}
	}, [
		r,
		a,
		v.paused
	]);
	return /* @__PURE__ */ i(G.div, {
		tabIndex: -1,
		...l,
		ref: h,
		onKeyDown: y
	});
}, "FocusScope")), Zn = e.createContext(null), Qn = Zn.Provider;
function $n() {
	let [t, n] = e.useState([]);
	return {
		nodes: t,
		registry: e.useMemo(() => ({
			add: /* @__PURE__ */ q((e) => n((t) => t.includes(e) ? t : [...t, e]), "add"),
			remove: /* @__PURE__ */ q((e) => n((t) => t.filter((t) => t !== e)), "remove")
		}), [])
	};
}
q($n, "useFocusScopeBranchRegistry");
function er(t) {
	let n = e.useContext(Zn);
	e.useEffect(() => {
		if (!(!t || !n)) return n.add(t), () => n.remove(t);
	}, [t, n]);
}
q(er, "useFocusScopeBranch");
function tr(e, { select: t = !1 } = {}) {
	let n = document.activeElement;
	for (let r of e) if (sr(r, { select: t }), document.activeElement !== n) return;
}
q(tr, "focusFirst");
function nr(e) {
	let t = rr(e);
	return [ir(t, e), ir(t.reverse(), e)];
}
q(nr, "getTabbableEdges");
function rr(e) {
	let t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, { acceptNode: /* @__PURE__ */ q((e) => {
		let t = e.tagName === "INPUT" && e.type === "hidden";
		return e.disabled || e.hidden || t ? NodeFilter.FILTER_SKIP : e.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
	}, "acceptNode") });
	for (; n.nextNode();) t.push(n.currentNode);
	return t;
}
q(rr, "getTabbableCandidates");
function ir(e, t) {
	let n = typeof t.checkVisibility == "function" && t.checkVisibility({ checkVisibilityCSS: !0 });
	for (let r of e) if (!(n ? !r.checkVisibility({ checkVisibilityCSS: !0 }) : ar(r, { upTo: t }))) return r;
}
q(ir, "findVisible");
function ar(e, { upTo: t }) {
	if (getComputedStyle(e).visibility === "hidden") return !0;
	for (; e;) {
		if (t !== void 0 && e === t) return !1;
		if (getComputedStyle(e).display === "none") return !0;
		e = e.parentElement;
	}
	return !1;
}
q(ar, "isHidden");
function or(e) {
	return e instanceof HTMLInputElement && "select" in e;
}
q(or, "isSelectableInput");
function sr(e, { select: t = !1 } = {}) {
	if (e && e.focus) {
		let n = document.activeElement;
		e.focus({ preventScroll: !0 }), e !== n && or(e) && t && e.select();
	}
}
q(sr, "focus");
var cr = lr();
function lr() {
	let e = [];
	return {
		add(t) {
			let n = e[0];
			t !== n && n?.pause(), e = ur(e, t), e.unshift(t);
		},
		remove(t) {
			e = ur(e, t), e[0]?.resume();
		}
	};
}
q(lr, "createFocusScopesStack");
function ur(e, t) {
	let n = [...e], r = n.indexOf(t);
	return r !== -1 && n.splice(r, 1), n;
}
q(ur, "arrayRemove");
function dr(e) {
	return e.filter((e) => e.tagName !== "A");
}
q(dr, "removeLinks");
//#endregion
//#region ../../node_modules/@radix-ui/react-portal/dist/index.mjs
var fr = Object.defineProperty, pr = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ ((e, t) => fr(e, "name", {
	value: t,
	configurable: !0
}))(function(t, n) {
	let { container: r, ...a } = t, [s, c] = e.useState(!1);
	cn(() => c(!0), []);
	let l = r || s && globalThis?.document?.body;
	return l ? o.createPortal(/* @__PURE__ */ i(G.div, {
		...a,
		ref: n
	}), l) : null;
}, "Portal")), mr = Object.defineProperty, hr = (e, t) => mr(e, "name", {
	value: t,
	configurable: !0
});
function gr(t, n) {
	return e.useReducer((e, t) => n[e][t] ?? e, t);
}
hr(gr, "useStateMachine");
var _r = /* @__PURE__ */ hr((t) => {
	let { present: n, children: r } = t, i = vr(n), a = typeof r == "function" ? r({ present: i.isPresent }) : e.Children.only(r), o = br(i.ref, Sr(a));
	return typeof r == "function" || i.isPresent ? e.cloneElement(a, { ref: o }) : null;
}, "Presence");
function vr(t) {
	let [n, r] = e.useState(), i = e.useRef(null), a = e.useRef(t), o = e.useRef("none"), s = e.useRef(void 0), [c, l] = gr(t ? "mounted" : "unmounted", {
		mounted: {
			UNMOUNT: "unmounted",
			ANIMATION_OUT: "unmountSuspended"
		},
		unmountSuspended: {
			MOUNT: "mounted",
			ANIMATION_END: "unmounted"
		},
		unmounted: { MOUNT: "mounted" }
	});
	return e.useEffect(() => {
		c === "mounted" ? (o.current = s.current ?? xr(i.current), s.current = void 0) : o.current = "none";
	}, [c]), cn(() => {
		let e = i.current, n = a.current;
		if (n !== t) {
			let r = o.current, i = xr(e);
			t ? (s.current = i, l("MOUNT")) : i === "none" || e?.display === "none" ? l("UNMOUNT") : l(n && r !== i ? "ANIMATION_OUT" : "UNMOUNT"), a.current = t;
		}
	}, [t, l]), cn(() => {
		if (n) {
			let e, t = n.ownerDocument.defaultView ?? window, r = /* @__PURE__ */ hr((r) => {
				let o = xr(i.current).includes(CSS.escape(r.animationName));
				if (r.target === n && o && (l("ANIMATION_END"), !a.current)) {
					let r = n.style.animationFillMode;
					n.style.animationFillMode = "forwards", e = t.setTimeout(() => {
						n.style.animationFillMode === "forwards" && (n.style.animationFillMode = r);
					});
				}
			}, "handleAnimationEnd"), s = /* @__PURE__ */ hr((e) => {
				e.target === n && (o.current = xr(i.current));
			}, "handleAnimationStart");
			return n.addEventListener("animationstart", s), n.addEventListener("animationcancel", r), n.addEventListener("animationend", r), () => {
				t.clearTimeout(e), n.removeEventListener("animationstart", s), n.removeEventListener("animationcancel", r), n.removeEventListener("animationend", r);
			};
		} else l("ANIMATION_END");
	}, [n, l]), {
		isPresent: ["mounted", "unmountSuspended"].includes(c),
		ref: e.useCallback((e) => {
			if (e) {
				let t = getComputedStyle(e);
				i.current = t, s.current = xr(t);
			} else i.current = null;
			r(e);
		}, [])
	};
}
hr(vr, "usePresence");
function yr(e, t) {
	if (typeof e == "function") return e(t);
	e != null && (e.current = t);
}
hr(yr, "setRef");
function br(...t) {
	let n = e.useRef(t);
	return n.current = t, e.useCallback((e) => {
		let t = n.current, r = !1, i = t.map((t) => {
			let n = yr(t, e);
			return !r && typeof n == "function" && (r = !0), n;
		});
		if (r) return () => {
			for (let e = 0; e < i.length; e++) {
				let n = i[e];
				typeof n == "function" ? n() : yr(t[e], null);
			}
		};
	}, []);
}
hr(br, "useStableComposedRefs");
function xr(e) {
	return e?.animationName || "none";
}
hr(xr, "getAnimationName");
function Sr(e) {
	let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
	return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
hr(Sr, "getElementRef");
//#endregion
//#region ../../node_modules/@radix-ui/react-focus-guards/dist/index.mjs
var Cr = Object.defineProperty, wr = (e, t) => Cr(e, "name", {
	value: t,
	configurable: !0
}), Tr = 0, Er = null;
function Dr(e) {
	return Or(), e.children;
}
wr(Dr, "FocusGuards");
function Or() {
	e.useEffect(() => {
		Er ||= {
			start: kr(),
			end: kr()
		};
		let { start: e, end: t } = Er;
		return document.body.firstElementChild !== e && document.body.insertAdjacentElement("afterbegin", e), document.body.lastElementChild !== t && document.body.insertAdjacentElement("beforeend", t), Tr++, () => {
			Tr === 1 && (Er?.start.remove(), Er?.end.remove(), Er = null), Tr = Math.max(0, Tr - 1);
		};
	}, []);
}
wr(Or, "useFocusGuards");
function kr() {
	let e = document.createElement("span");
	return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
wr(kr, "createFocusGuard");
//#endregion
//#region ../../node_modules/tslib/tslib.es6.mjs
var Ar = function() {
	return Ar = Object.assign || function(e) {
		for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n], t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
		return e;
	}, Ar.apply(this, arguments);
};
function jr(e, t) {
	var n = {};
	for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++) t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
	return n;
}
function Mr(e, t, n) {
	if (n || arguments.length === 2) for (var r = 0, i = t.length, a; r < i; r++) (a || !(r in t)) && (a ||= Array.prototype.slice.call(t, 0, r), a[r] = t[r]);
	return e.concat(a || Array.prototype.slice.call(t));
}
//#endregion
//#region ../../node_modules/react-remove-scroll-bar/dist/es2015/constants.js
var Nr = "right-scroll-bar-position", Pr = "width-before-scroll-bar", Fr = "with-scroll-bars-hidden", Ir = "--removed-body-scroll-bar-size";
//#endregion
//#region ../../node_modules/use-callback-ref/dist/es2015/assignRef.js
function Lr(e, t) {
	return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
//#endregion
//#region ../../node_modules/use-callback-ref/dist/es2015/useRef.js
function Rr(e, t) {
	var r = n(function() {
		return {
			value: e,
			callback: t,
			facade: {
				get current() {
					return r.value;
				},
				set current(e) {
					var t = r.value;
					t !== e && (r.value = e, r.callback(e, t));
				}
			}
		};
	})[0];
	return r.callback = t, r.facade;
}
//#endregion
//#region ../../node_modules/use-callback-ref/dist/es2015/useMergeRef.js
var zr = typeof window < "u" ? e.useLayoutEffect : e.useEffect, Br = /* @__PURE__ */ new WeakMap();
function Vr(e, t) {
	var n = Rr(t || null, function(t) {
		return e.forEach(function(e) {
			return Lr(e, t);
		});
	});
	return zr(function() {
		var t = Br.get(n);
		if (t) {
			var r = new Set(t), i = new Set(e), a = n.current;
			r.forEach(function(e) {
				i.has(e) || Lr(e, null);
			}), i.forEach(function(e) {
				r.has(e) || Lr(e, a);
			});
		}
		Br.set(n, e);
	}, [e]), n;
}
//#endregion
//#region ../../node_modules/use-sidecar/dist/es2015/medium.js
function Hr(e) {
	return e;
}
function Ur(e, t) {
	t === void 0 && (t = Hr);
	var n = [], r = !1;
	return {
		read: function() {
			if (r) throw Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
			return n.length ? n[n.length - 1] : e;
		},
		useMedium: function(e) {
			var i = t(e, r);
			return n.push(i), function() {
				n = n.filter(function(e) {
					return e !== i;
				});
			};
		},
		assignSyncMedium: function(e) {
			for (r = !0; n.length;) {
				var t = n;
				n = [], t.forEach(e);
			}
			n = {
				push: function(t) {
					return e(t);
				},
				filter: function() {
					return n;
				}
			};
		},
		assignMedium: function(e) {
			r = !0;
			var t = [];
			if (n.length) {
				var i = n;
				n = [], i.forEach(e), t = n;
			}
			var a = function() {
				var n = t;
				t = [], n.forEach(e);
			}, o = function() {
				return Promise.resolve().then(a);
			};
			o(), n = {
				push: function(e) {
					t.push(e), o();
				},
				filter: function(e) {
					return t = t.filter(e), n;
				}
			};
		}
	};
}
function Wr(e) {
	e === void 0 && (e = {});
	var t = Ur(null);
	return t.options = Ar({
		async: !0,
		ssr: !1
	}, e), t;
}
//#endregion
//#region ../../node_modules/use-sidecar/dist/es2015/exports.js
var Gr = function(t) {
	var n = t.sideCar, r = jr(t, ["sideCar"]);
	if (!n) throw Error("Sidecar: please provide `sideCar` property to import the right car");
	var i = n.read();
	if (!i) throw Error("Sidecar medium not found");
	return e.createElement(i, Ar({}, r));
};
Gr.isSideCarExport = !0;
function Kr(e, t) {
	return e.useMedium(t), Gr;
}
//#endregion
//#region ../../node_modules/react-remove-scroll/dist/es2015/medium.js
var qr = Wr(), Jr = function() {}, Yr = e.forwardRef(function(t, n) {
	var r = e.useRef(null), i = e.useState({
		onScrollCapture: Jr,
		onWheelCapture: Jr,
		onTouchMoveCapture: Jr
	}), a = i[0], o = i[1], s = t.forwardProps, c = t.children, l = t.className, u = t.removeScrollBar, d = t.enabled, f = t.shards, p = t.sideCar, m = t.noRelative, h = t.noIsolation, g = t.inert, _ = t.allowPinchZoom, v = t.as, y = v === void 0 ? "div" : v, b = t.gapMode, x = jr(t, [
		"forwardProps",
		"children",
		"className",
		"removeScrollBar",
		"enabled",
		"shards",
		"sideCar",
		"noRelative",
		"noIsolation",
		"inert",
		"allowPinchZoom",
		"as",
		"gapMode"
	]), S = p, C = Vr([r, n]), w = Ar(Ar({}, x), a);
	return e.createElement(e.Fragment, null, d && e.createElement(S, {
		sideCar: qr,
		removeScrollBar: u,
		shards: f,
		noRelative: m,
		noIsolation: h,
		inert: g,
		setCallbacks: o,
		allowPinchZoom: !!_,
		lockRef: r,
		gapMode: b
	}), s ? e.cloneElement(e.Children.only(c), Ar(Ar({}, w), { ref: C })) : e.createElement(y, Ar({}, w, {
		className: l,
		ref: C
	}), c));
});
Yr.defaultProps = {
	enabled: !0,
	removeScrollBar: !0,
	inert: !1
}, Yr.classNames = {
	fullWidth: Pr,
	zeroRight: Nr
};
//#endregion
//#region ../../node_modules/get-nonce/dist/es2015/index.js
var Xr, Zr = function() {
	if (Xr) return Xr;
	if (typeof __webpack_nonce__ < "u") return __webpack_nonce__;
};
//#endregion
//#region ../../node_modules/react-style-singleton/dist/es2015/singleton.js
function Qr() {
	if (!document) return null;
	var e = document.createElement("style");
	e.type = "text/css";
	var t = Zr();
	return t && e.setAttribute("nonce", t), e;
}
function $r(e, t) {
	e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function ei(e) {
	(document.head || document.getElementsByTagName("head")[0]).appendChild(e);
}
var ti = function() {
	var e = 0, t = null;
	return {
		add: function(n) {
			e == 0 && (t = Qr()) && ($r(t, n), ei(t)), e++;
		},
		remove: function() {
			e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
		}
	};
}, ni = function() {
	var t = ti();
	return function(n, r) {
		e.useEffect(function() {
			return t.add(n), function() {
				t.remove();
			};
		}, [n && r]);
	};
}, ri = function() {
	var e = ni();
	return function(t) {
		var n = t.styles, r = t.dynamic;
		return e(n, r), null;
	};
}, ii = {
	left: 0,
	top: 0,
	right: 0,
	gap: 0
}, ai = function(e) {
	return parseInt(e || "", 10) || 0;
}, oi = function(e) {
	var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], i = t[e === "padding" ? "paddingRight" : "marginRight"];
	return [
		ai(n),
		ai(r),
		ai(i)
	];
}, si = function(e) {
	if (e === void 0 && (e = "margin"), typeof window > "u") return ii;
	var t = oi(e), n = document.documentElement.clientWidth, r = window.innerWidth;
	return {
		left: t[0],
		top: t[1],
		right: t[2],
		gap: Math.max(0, r - n + t[2] - t[0])
	};
}, ci = ri(), li = "data-scroll-locked", ui = function(e, t, n, r) {
	var i = e.left, a = e.top, o = e.right, s = e.gap;
	return n === void 0 && (n = "margin"), `
  .${Fr} {
   overflow: hidden ${r};
   padding-right: ${s}px ${r};
  }
  body[${li}] {
    overflow: hidden ${r};
    overscroll-behavior: contain;
    ${[
		t && `position: relative ${r};`,
		n === "margin" && `
    padding-left: ${i}px;
    padding-top: ${a}px;
    padding-right: ${o}px;
    margin-left:0;
    margin-top:0;
    margin-right: ${s}px ${r};
    `,
		n === "padding" && `padding-right: ${s}px ${r};`
	].filter(Boolean).join("")}
  }
  
  .${Nr} {
    right: ${s}px ${r};
  }
  
  .${Pr} {
    margin-right: ${s}px ${r};
  }
  
  .${Nr} .${Nr} {
    right: 0 ${r};
  }
  
  .${Pr} .${Pr} {
    margin-right: 0 ${r};
  }
  
  body[${li}] {
    ${Ir}: ${s}px;
  }
`;
}, di = function() {
	var e = parseInt(document.body.getAttribute("data-scroll-locked") || "0", 10);
	return isFinite(e) ? e : 0;
}, fi = function() {
	e.useEffect(function() {
		return document.body.setAttribute(li, (di() + 1).toString()), function() {
			var e = di() - 1;
			e <= 0 ? document.body.removeAttribute(li) : document.body.setAttribute(li, e.toString());
		};
	}, []);
}, pi = function(t) {
	var n = t.noRelative, r = t.noImportant, i = t.gapMode, a = i === void 0 ? "margin" : i;
	fi();
	var o = e.useMemo(function() {
		return si(a);
	}, [a]);
	return e.createElement(ci, { styles: ui(o, !n, a, r ? "" : "!important") });
}, mi = !1;
if (typeof window < "u") try {
	var hi = Object.defineProperty({}, "passive", { get: function() {
		return mi = !0, !0;
	} });
	window.addEventListener("test", hi, hi), window.removeEventListener("test", hi, hi);
} catch {
	mi = !1;
}
var gi = mi ? { passive: !1 } : !1, _i = function(e) {
	return e.tagName === "TEXTAREA";
}, vi = function(e, t) {
	if (!(e instanceof Element)) return !1;
	var n = window.getComputedStyle(e);
	return n[t] !== "hidden" && !(n.overflowY === n.overflowX && !_i(e) && n[t] === "visible");
}, yi = function(e) {
	return vi(e, "overflowY");
}, bi = function(e) {
	return vi(e, "overflowX");
}, xi = function(e, t) {
	var n = t.ownerDocument, r = t;
	do {
		if (typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host), wi(e, r)) {
			var i = Ti(e, r);
			if (i[1] > i[2]) return !0;
		}
		r = r.parentNode;
	} while (r && r !== n.body);
	return !1;
}, Si = function(e) {
	return [
		e.scrollTop,
		e.scrollHeight,
		e.clientHeight
	];
}, Ci = function(e) {
	return [
		e.scrollLeft,
		e.scrollWidth,
		e.clientWidth
	];
}, wi = function(e, t) {
	return e === "v" ? yi(t) : bi(t);
}, Ti = function(e, t) {
	return e === "v" ? Si(t) : Ci(t);
}, Ei = function(e, t) {
	return e === "h" && t === "rtl" ? -1 : 1;
}, Di = function(e, t, n, r, i) {
	var a = Ei(e, window.getComputedStyle(t).direction), o = a * r, s = n.target, c = t.contains(s), l = !1, u = o > 0, d = 0, f = 0;
	do {
		if (!s) break;
		var p = Ti(e, s), m = p[0], h = p[1] - p[2] - a * m;
		(m || h) && wi(e, s) && (d += h, f += m);
		var g = s.parentNode;
		s = g && g.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? g.host : g;
	} while (!c && s !== document.body || c && (t.contains(s) || t === s));
	return (u && (i && Math.abs(d) < 1 || !i && o > d) || !u && (i && Math.abs(f) < 1 || !i && -o > f)) && (l = !0), l;
}, Oi = function(e) {
	return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, ki = function(e) {
	return [e.deltaX, e.deltaY];
}, Ai = function(e) {
	return e && "current" in e ? e.current : e;
}, ji = function(e, t) {
	return e[0] === t[0] && e[1] === t[1];
}, Mi = function(e) {
	return `
  .block-interactivity-${e} {pointer-events: none;}
  .allow-interactivity-${e} {pointer-events: all;}
`;
}, Ni = 0, Pi = [];
function Fi(t) {
	var n = e.useRef([]), r = e.useRef([0, 0]), i = e.useRef(), a = e.useState(Ni++)[0], o = e.useState(ri)[0], s = e.useRef(t);
	e.useEffect(function() {
		s.current = t;
	}, [t]), e.useEffect(function() {
		if (t.inert) {
			document.body.classList.add(`block-interactivity-${a}`);
			var e = Mr([t.lockRef.current], (t.shards || []).map(Ai), !0).filter(Boolean);
			return e.forEach(function(e) {
				return e.classList.add(`allow-interactivity-${a}`);
			}), function() {
				document.body.classList.remove(`block-interactivity-${a}`), e.forEach(function(e) {
					return e.classList.remove(`allow-interactivity-${a}`);
				});
			};
		}
	}, [
		t.inert,
		t.lockRef.current,
		t.shards
	]);
	var c = e.useCallback(function(e, t) {
		if ("touches" in e && e.touches.length === 2 || e.type === "wheel" && e.ctrlKey) return !s.current.allowPinchZoom;
		var n = Oi(e), a = r.current, o = "deltaX" in e ? e.deltaX : a[0] - n[0], c = "deltaY" in e ? e.deltaY : a[1] - n[1], l, u = e.target, d = Math.abs(o) > Math.abs(c) ? "h" : "v";
		if ("touches" in e && d === "h" && u.type === "range") return !1;
		var f = window.getSelection(), p = f && f.anchorNode;
		if (p && (p === u || p.contains(u))) return !1;
		var m = xi(d, u);
		if (!m) return !0;
		if (m ? l = d : (l = d === "v" ? "h" : "v", m = xi(d, u)), !m) return !1;
		if (!i.current && "changedTouches" in e && (o || c) && (i.current = l), !l) return !0;
		var h = i.current || l;
		return Di(h, t, e, h === "h" ? o : c, !0);
	}, []), l = e.useCallback(function(e) {
		var t = e;
		if (!(!Pi.length || Pi[Pi.length - 1] !== o)) {
			var r = "deltaY" in t ? ki(t) : Oi(t), i = n.current.filter(function(e) {
				return e.name === t.type && (e.target === t.target || t.target === e.shadowParent) && ji(e.delta, r);
			})[0];
			if (i && i.should) {
				t.cancelable && t.preventDefault();
				return;
			}
			if (!i) {
				var a = (s.current.shards || []).map(Ai).filter(Boolean).filter(function(e) {
					return e.contains(t.target);
				});
				(a.length > 0 ? c(t, a[0]) : !s.current.noIsolation) && t.cancelable && t.preventDefault();
			}
		}
	}, []), u = e.useCallback(function(e, t, r, i) {
		var a = {
			name: e,
			delta: t,
			target: r,
			should: i,
			shadowParent: Ii(r)
		};
		n.current.push(a), setTimeout(function() {
			n.current = n.current.filter(function(e) {
				return e !== a;
			});
		}, 1);
	}, []), d = e.useCallback(function(e) {
		r.current = Oi(e), i.current = void 0;
	}, []), f = e.useCallback(function(e) {
		u(e.type, ki(e), e.target, c(e, t.lockRef.current));
	}, []), p = e.useCallback(function(e) {
		u(e.type, Oi(e), e.target, c(e, t.lockRef.current));
	}, []);
	e.useEffect(function() {
		return Pi.push(o), t.setCallbacks({
			onScrollCapture: f,
			onWheelCapture: f,
			onTouchMoveCapture: p
		}), document.addEventListener("wheel", l, gi), document.addEventListener("touchmove", l, gi), document.addEventListener("touchstart", d, gi), function() {
			Pi = Pi.filter(function(e) {
				return e !== o;
			}), document.removeEventListener("wheel", l, gi), document.removeEventListener("touchmove", l, gi), document.removeEventListener("touchstart", d, gi);
		};
	}, []);
	var m = t.removeScrollBar, h = t.inert;
	return e.createElement(e.Fragment, null, h ? e.createElement(o, { styles: Mi(a) }) : null, m ? e.createElement(pi, {
		noRelative: t.noRelative,
		gapMode: t.gapMode
	}) : null);
}
function Ii(e) {
	for (var t = null; e !== null;) e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
	return t;
}
//#endregion
//#region ../../node_modules/react-remove-scroll/dist/es2015/sidecar.js
var Li = Kr(qr, Fi), Ri = e.forwardRef(function(t, n) {
	return e.createElement(Yr, Ar({}, t, {
		ref: n,
		sideCar: Li
	}));
});
Ri.classNames = Yr.classNames;
//#endregion
//#region ../../node_modules/aria-hidden/dist/es2015/index.js
var zi = function(e) {
	return typeof document > "u" ? null : (Array.isArray(e) ? e[0] : e).ownerDocument.body;
}, Bi = /* @__PURE__ */ new WeakMap(), Vi = /* @__PURE__ */ new WeakMap(), Hi = {}, Ui = 0, Wi = function(e) {
	return e && (e.host || Wi(e.parentNode));
}, Gi = function(e, t) {
	return t.map(function(t) {
		if (e.contains(t)) return t;
		var n = Wi(t);
		return n && e.contains(n) ? n : (console.error("aria-hidden", t, "in not contained inside", e, ". Doing nothing"), null);
	}).filter(function(e) {
		return !!e;
	});
}, Ki = function(e, t, n, r) {
	var i = Gi(t, Array.isArray(e) ? e : [e]);
	Hi[n] || (Hi[n] = /* @__PURE__ */ new WeakMap());
	var a = Hi[n], o = [], s = /* @__PURE__ */ new Set(), c = new Set(i), l = function(e) {
		!e || s.has(e) || (s.add(e), l(e.parentNode));
	};
	i.forEach(l);
	var u = function(e) {
		!e || c.has(e) || Array.prototype.forEach.call(e.children, function(e) {
			if (s.has(e)) u(e);
			else try {
				var t = e.getAttribute(r), i = t !== null && t !== "false", c = (Bi.get(e) || 0) + 1, l = (a.get(e) || 0) + 1;
				Bi.set(e, c), a.set(e, l), o.push(e), c === 1 && i && Vi.set(e, !0), l === 1 && e.setAttribute(n, "true"), i || e.setAttribute(r, "true");
			} catch (t) {
				console.error("aria-hidden: cannot operate on ", e, t);
			}
		});
	};
	return u(t), s.clear(), Ui++, function() {
		o.forEach(function(e) {
			var t = Bi.get(e) - 1, i = a.get(e) - 1;
			Bi.set(e, t), a.set(e, i), t || (Vi.has(e) || e.removeAttribute(r), Vi.delete(e)), i || e.removeAttribute(n);
		}), Ui--, Ui || (Bi = /* @__PURE__ */ new WeakMap(), Bi = /* @__PURE__ */ new WeakMap(), Vi = /* @__PURE__ */ new WeakMap(), Hi = {});
	};
}, qi = function(e, t, n) {
	n === void 0 && (n = "data-aria-hidden");
	var r = Array.from(Array.isArray(e) ? e : [e]), i = t || zi(e);
	return i ? (r.push.apply(r, Array.from(i.querySelectorAll("[aria-live], script"))), Ki(r, i, n, "aria-hidden")) : function() {
		return null;
	};
}, Ji = Object.defineProperty, J = (e, t) => Ji(e, "name", {
	value: t,
	configurable: !0
}), Yi = "Dialog", [Xi, Zi] = /* @__PURE__ */ on(Yi), [Qi, $i] = Xi(Yi), ea = /* @__PURE__ */ J((t) => {
	let { __scopeDialog: n, children: r, open: a, defaultOpen: o, onOpenChange: s, modal: c = !0 } = t, l = e.useRef(null), u = e.useRef(null), { nodes: d, registry: f } = $n(), [p, m] = Sn({
		prop: a,
		defaultProp: o ?? !1,
		onChange: s,
		caller: Yi
	}), [h, g] = e.useState(0), [_, v] = e.useState(0);
	return /* @__PURE__ */ i(Qi, {
		scope: n,
		triggerRef: l,
		contentRef: u,
		contentId: pn(),
		titleId: pn(),
		descriptionId: pn(),
		titlePresent: h > 0,
		descriptionPresent: _ > 0,
		setTitleCount: g,
		setDescriptionCount: v,
		open: p,
		onOpenChange: m,
		onOpenToggle: e.useCallback(() => m((e) => !e), [m]),
		modal: c,
		branchNodes: d,
		branchRegistry: f,
		children: r
	});
}, "Dialog"), ta = "DialogTrigger", na = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ J(function(e, t) {
	let { __scopeDialog: n, ...r } = e, a = $i(ta, n), o = H(t, a.triggerRef);
	return /* @__PURE__ */ i(G.button, {
		type: "button",
		"aria-haspopup": "dialog",
		"aria-expanded": a.open,
		"aria-controls": a.open ? a.contentId : void 0,
		"data-state": xa(a.open),
		...r,
		ref: o,
		onClick: W(e.onClick, a.onOpenToggle)
	});
}, "DialogTrigger")), ra = "DialogPortal", [ia, aa] = Xi(ra, { forceMount: void 0 }), oa = /* @__PURE__ */ J((t) => {
	let { __scopeDialog: n, forceMount: r, children: a, container: o } = t, s = $i(ra, n);
	return /* @__PURE__ */ i(ia, {
		scope: n,
		forceMount: r,
		children: e.Children.map(a, (e) => /* @__PURE__ */ i(_r, {
			present: r || s.open,
			children: /* @__PURE__ */ i(pr, {
				asChild: !0,
				container: o,
				children: e
			})
		}))
	});
}, "DialogPortal"), sa = "DialogOverlay", ca = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ J(function(e, t) {
	let n = aa(sa, e.__scopeDialog), { forceMount: r = n.forceMount, ...a } = e, o = $i(sa, e.__scopeDialog);
	return o.modal ? /* @__PURE__ */ i(_r, {
		present: r || o.open,
		children: /* @__PURE__ */ i(ua, {
			...a,
			ref: t
		})
	}) : null;
}, "DialogOverlay")), la = /* @__PURE__ */ at("DialogOverlay.RemoveScroll"), ua = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ J(function(t, n) {
	let { __scopeDialog: r, ...a } = t, o = $i(sa, r), s = H(n, Bn());
	return /* @__PURE__ */ i(Ri, {
		as: la,
		allowPinchZoom: !0,
		shards: e.useMemo(() => [o.contentRef, ...o.branchNodes.map((e) => ({ current: e }))], [o.contentRef, o.branchNodes]),
		children: /* @__PURE__ */ i(G.div, {
			"data-state": xa(o.open),
			...a,
			ref: s,
			style: {
				pointerEvents: "auto",
				...a.style
			}
		})
	});
}, "DialogOverlayImpl")), da = "DialogContent", fa = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ J(function(e, t) {
	let n = aa(da, e.__scopeDialog), { forceMount: r = n.forceMount, ...a } = e, o = $i(da, e.__scopeDialog);
	return /* @__PURE__ */ i(_r, {
		present: r || o.open,
		children: o.modal ? /* @__PURE__ */ i(pa, {
			...a,
			ref: t
		}) : /* @__PURE__ */ i(ma, {
			...a,
			ref: t
		})
	});
}, "DialogContent")), pa = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ J(function(t, n) {
	let r = $i(da, t.__scopeDialog), a = e.useRef(null), o = H(n, r.contentRef, a);
	return e.useEffect(() => {
		let e = a.current;
		if (e) return qi(e);
	}, []), /* @__PURE__ */ i(ha, {
		...t,
		ref: o,
		trapFocus: r.open,
		disableOutsidePointerEvents: r.open,
		onCloseAutoFocus: W(t.onCloseAutoFocus, (e) => {
			e.preventDefault(), r.triggerRef.current?.focus();
		}),
		onPointerDownOutside: W(t.onPointerDownOutside, (e) => {
			let t = e.detail.originalEvent, n = t.button === 0 && t.ctrlKey === !0;
			(t.button === 2 || n) && e.preventDefault();
		}),
		onFocusOutside: W(t.onFocusOutside, (e) => e.preventDefault())
	});
}, "DialogContentModal")), ma = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ J(function(t, n) {
	let r = $i(da, t.__scopeDialog), a = e.useRef(!1), o = e.useRef(!1);
	return /* @__PURE__ */ i(ha, {
		...t,
		ref: n,
		trapFocus: !1,
		disableOutsidePointerEvents: !1,
		onCloseAutoFocus: (e) => {
			t.onCloseAutoFocus?.(e), e.defaultPrevented || (a.current || r.triggerRef.current?.focus(), e.preventDefault()), a.current = !1, o.current = !1;
		},
		onInteractOutside: (e) => {
			t.onInteractOutside?.(e), e.defaultPrevented || (a.current = !0, e.detail.originalEvent.type === "pointerdown" && (o.current = !0));
			let n = e.target;
			r.triggerRef.current?.contains(n) && e.preventDefault(), e.detail.originalEvent.type === "focusin" && o.current && e.preventDefault();
		}
	});
}, "DialogContentNonModal")), ha = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ J(function(e, t) {
	let { __scopeDialog: n, trapFocus: a, onOpenAutoFocus: o, onCloseAutoFocus: s, "aria-describedby": c, ...l } = e, { children: u, ...d } = l, f = $i(da, n);
	return Or(), /* @__PURE__ */ i(r, { children: /* @__PURE__ */ i(Xn, {
		asChild: !0,
		loop: !0,
		trapped: a,
		branches: f.branchNodes,
		onMountAutoFocus: o,
		onUnmountAutoFocus: s,
		children: /* @__PURE__ */ i(zn, {
			role: "dialog",
			id: f.contentId,
			"aria-labelledby": f.titlePresent ? f.titleId : void 0,
			"aria-describedby": f.descriptionPresent ? ba(c, f.descriptionId) : c,
			"data-state": xa(f.open),
			...d,
			ref: t,
			deferPointerDownOutside: !0,
			onDismiss: () => f.onOpenChange(!1),
			children: /* @__PURE__ */ i(Qn, {
				value: f.branchRegistry,
				children: u
			})
		})
	}) });
}, "DialogContentImpl")), ga = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ J(function(e, t) {
	let { __scopeDialog: n, ...r } = e, a = $i("DialogTitle", n), { setTitleCount: o } = a;
	return cn(() => (o((e) => e + 1), () => o((e) => e - 1)), [o]), /* @__PURE__ */ i(G.h2, {
		id: a.titleId,
		...r,
		ref: t
	});
}, "DialogTitle")), _a = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ J(function(e, t) {
	let { __scopeDialog: n, ...r } = e, a = $i("DialogDescription", n), { setDescriptionCount: o } = a;
	return cn(() => (o((e) => e + 1), () => o((e) => e - 1)), [o]), /* @__PURE__ */ i(G.p, {
		id: a.descriptionId,
		...r,
		ref: t
	});
}, "DialogDescription")), va = "DialogClose", ya = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ J(function(e, t) {
	let { __scopeDialog: n, ...r } = e, a = $i(va, n);
	return /* @__PURE__ */ i(G.button, {
		type: "button",
		...r,
		ref: t,
		onClick: W(e.onClick, () => a.onOpenChange(!1))
	});
}, "DialogClose"));
function ba(...e) {
	let t = /* @__PURE__ */ new Set();
	for (let n of e) if (typeof n == "string") for (let e of String(n).trim().split(/\s+/)) e && t.add(e);
	return t.size > 0 ? Array.from(t).join(" ") : void 0;
}
J(ba, "concatAriaDescribedby");
function xa(e) {
	return e ? "open" : "closed";
}
J(xa, "getState");
//#endregion
//#region src/components/modal/Modal.tsx
var Sa = ea, Ca = na, wa = oa, Ta = ya, Ea = e.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(ca, {
	ref: n,
	className: V("fixed inset-0 z-50 bg-black/50 backdrop-blur-sm", "data-[state=open]:animate-fade-in data-[state=closed]:animate-fade-out", e),
	...t
}));
Ea.displayName = ca.displayName;
var Da = U([
	"fixed left-[50%] top-[50%] z-50",
	"translate-x-[-50%] translate-y-[-50%]",
	"bg-white shadow-modal rounded-xl",
	"w-full max-h-[85vh] overflow-hidden",
	"focus:outline-none",
	"data-[state=open]:animate-scale-in"
], {
	variants: { size: {
		sm: "max-w-sm",
		md: "max-w-lg",
		lg: "max-w-2xl",
		xl: "max-w-4xl",
		full: "max-w-[calc(100vw-2rem)]"
	} },
	defaultVariants: { size: "md" }
}), Oa = e.forwardRef(({ className: e, size: t, children: n, ...r }, o) => /* @__PURE__ */ a(wa, { children: [/* @__PURE__ */ i(Ea, {}), /* @__PURE__ */ i(fa, {
	ref: o,
	className: V(Da({ size: t }), e),
	...r,
	children: n
})] }));
Oa.displayName = fa.displayName;
var ka = ({ className: e, ...t }) => /* @__PURE__ */ i("div", {
	className: V("flex items-start justify-between px-6 py-4 border-b border-gray-100", e),
	...t
});
ka.displayName = "ModalHeader";
var Aa = ({ className: e, ...t }) => /* @__PURE__ */ i("div", {
	className: V("px-6 py-4 overflow-y-auto", e),
	...t
});
Aa.displayName = "ModalBody";
var ja = ({ className: e, ...t }) => /* @__PURE__ */ i("div", {
	className: V("flex items-center justify-end gap-3 px-6 py-4 border-t border-gray-100 bg-gray-50/50", e),
	...t
});
ja.displayName = "ModalFooter";
var Ma = e.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(ga, {
	ref: n,
	className: V("text-lg font-semibold text-gray-900", e),
	...t
}));
Ma.displayName = ga.displayName;
var Na = e.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(_a, {
	ref: n,
	className: V("text-sm text-gray-500", e),
	...t
}));
Na.displayName = _a.displayName;
function Pa({ className: e }) {
	return /* @__PURE__ */ a("svg", {
		className: e,
		xmlns: "http://www.w3.org/2000/svg",
		width: "24",
		height: "24",
		viewBox: "0 0 24 24",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: "2",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		children: [/* @__PURE__ */ i("path", { d: "M18 6 6 18" }), /* @__PURE__ */ i("path", { d: "m6 6 12 12" })]
	});
}
var Fa = e.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ a(ya, {
	ref: n,
	className: V("rounded-lg p-1.5 text-gray-400 hover:text-gray-500 hover:bg-gray-100", "focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500", "transition-colors", e),
	...t,
	children: [/* @__PURE__ */ i(Pa, { className: "h-5 w-5" }), /* @__PURE__ */ i("span", {
		className: "sr-only",
		children: "Close"
	})]
}));
Fa.displayName = "ModalCloseButton";
//#endregion
//#region ../../node_modules/@radix-ui/react-collection/dist/index.mjs
var Ia = Object.defineProperty, Y = (e, t) => Ia(e, "name", {
	value: t,
	configurable: !0
});
// @__NO_SIDE_EFFECTS__
function La(t) {
	let n = t + "CollectionProvider", [r, a] = /* @__PURE__ */ on(n), [o, s] = r(n, {
		collectionRef: { current: null },
		itemMap: /* @__PURE__ */ new Map()
	}), c = /* @__PURE__ */ Y((t) => {
		let { scope: n, children: r } = t, a = e.useRef(null), s = e.useRef(/* @__PURE__ */ new Map()).current;
		return /* @__PURE__ */ i(o, {
			scope: n,
			itemMap: s,
			collectionRef: a,
			children: r
		});
	}, "CollectionProvider");
	c.displayName = n;
	let l = t + "CollectionSlot", u = /* @__PURE__ */ at(l), d = e.forwardRef((e, t) => {
		let { scope: n, children: r } = e, a = H(t, s(l, n).collectionRef);
		return /* @__PURE__ */ i(u, {
			ref: a,
			children: r
		});
	});
	d.displayName = l;
	let f = t + "CollectionItemSlot", p = "data-radix-collection-item", m = /* @__PURE__ */ at(f), h = e.forwardRef((t, n) => {
		let { scope: r, children: a, ...o } = t, c = e.useRef(null), l = H(n, c), u = s(f, r);
		return e.useEffect(() => (u.itemMap.set(c, {
			ref: c,
			...o
		}), () => void u.itemMap.delete(c))), /* @__PURE__ */ i(m, {
			[p]: "",
			ref: l,
			children: a
		});
	});
	h.displayName = f;
	function g(n) {
		let r = s(t + "CollectionConsumer", n);
		return e.useCallback(() => {
			let e = r.collectionRef.current;
			if (!e) return [];
			let t = Array.from(e.querySelectorAll(`[${p}]`));
			return Array.from(r.itemMap.values()).sort((e, n) => t.indexOf(e.ref.current) - t.indexOf(n.ref.current));
		}, [r.collectionRef, r.itemMap]);
	}
	return Y(g, "useCollection"), [
		{
			Provider: c,
			Slot: d,
			ItemSlot: h
		},
		g,
		a
	];
}
Y(La, "createCollection");
var Ra = /* @__PURE__ */ new WeakMap(), za = class e extends Map {
	static {
		Y(this, "OrderedDict");
	}
	#e;
	constructor(e) {
		super(e), this.#e = [...super.keys()], Ra.set(this, !0);
	}
	set(e, t) {
		return Ra.get(this) && (this.has(e) ? this.#e[this.#e.indexOf(e)] = e : this.#e.push(e)), super.set(e, t), this;
	}
	insert(e, t, n) {
		let r = this.has(t), i = this.#e.length, a = Ha(e), o = a >= 0 ? a : i + a, s = o < 0 || o >= i ? -1 : o;
		if (s === this.size || r && s === this.size - 1 || s === -1) return this.set(t, n), this;
		let c = this.size + +!r;
		a < 0 && o++;
		let l = [...this.#e], u, d = !1;
		for (let e = o; e < c; e++) if (o === e) {
			let i = l[e];
			l[e] === t && (i = l[e + 1]), r && this.delete(t), u = this.get(i), this.set(t, n);
		} else {
			!d && l[e - 1] === t && (d = !0);
			let n = l[d ? e : e - 1], r = u;
			u = this.get(n), this.delete(n), this.set(n, r);
		}
		return this;
	}
	with(t, n, r) {
		let i = new e(this);
		return i.insert(t, n, r), i;
	}
	before(e) {
		let t = this.#e.indexOf(e) - 1;
		if (!(t < 0)) return this.entryAt(t);
	}
	setBefore(e, t, n) {
		let r = this.#e.indexOf(e);
		return r === -1 ? this : this.insert(r, t, n);
	}
	after(e) {
		let t = this.#e.indexOf(e);
		if (t = t === -1 || t === this.size - 1 ? -1 : t + 1, t !== -1) return this.entryAt(t);
	}
	setAfter(e, t, n) {
		let r = this.#e.indexOf(e);
		return r === -1 ? this : this.insert(r + 1, t, n);
	}
	first() {
		return this.entryAt(0);
	}
	last() {
		return this.entryAt(-1);
	}
	clear() {
		return this.#e = [], super.clear();
	}
	delete(e) {
		let t = super.delete(e);
		return t && this.#e.splice(this.#e.indexOf(e), 1), t;
	}
	deleteAt(e) {
		let t = this.keyAt(e);
		return t !== void 0 && this.delete(t);
	}
	at(e) {
		let t = Ba(this.#e, e);
		if (t !== void 0) return this.get(t);
	}
	entryAt(e) {
		let t = Ba(this.#e, e);
		if (t !== void 0) return [t, this.get(t)];
	}
	indexOf(e) {
		return this.#e.indexOf(e);
	}
	keyAt(e) {
		return Ba(this.#e, e);
	}
	from(e, t) {
		let n = this.indexOf(e);
		if (n === -1) return;
		let r = n + t;
		return r < 0 && (r = 0), r >= this.size && (r = this.size - 1), this.at(r);
	}
	keyFrom(e, t) {
		let n = this.indexOf(e);
		if (n === -1) return;
		let r = n + t;
		return r < 0 && (r = 0), r >= this.size && (r = this.size - 1), this.keyAt(r);
	}
	find(e, t) {
		let n = 0;
		for (let r of this) {
			if (Reflect.apply(e, t, [
				r,
				n,
				this
			])) return r;
			n++;
		}
	}
	findIndex(e, t) {
		let n = 0;
		for (let r of this) {
			if (Reflect.apply(e, t, [
				r,
				n,
				this
			])) return n;
			n++;
		}
		return -1;
	}
	filter(t, n) {
		let r = [], i = 0;
		for (let e of this) Reflect.apply(t, n, [
			e,
			i,
			this
		]) && r.push(e), i++;
		return new e(r);
	}
	map(t, n) {
		let r = [], i = 0;
		for (let e of this) r.push([e[0], Reflect.apply(t, n, [
			e,
			i,
			this
		])]), i++;
		return new e(r);
	}
	reduce(...e) {
		let [t, n] = e, r = 0, i = n ?? this.at(0);
		for (let n of this) i = r === 0 && e.length === 1 ? n : Reflect.apply(t, this, [
			i,
			n,
			r,
			this
		]), r++;
		return i;
	}
	reduceRight(...e) {
		let [t, n] = e, r = n ?? this.at(-1);
		for (let n = this.size - 1; n >= 0; n--) {
			let i = this.at(n);
			r = n === this.size - 1 && e.length === 1 ? i : Reflect.apply(t, this, [
				r,
				i,
				n,
				this
			]);
		}
		return r;
	}
	toSorted(t) {
		let n = [...this.entries()].sort(t);
		return new e(n);
	}
	toReversed() {
		let t = new e();
		for (let e = this.size - 1; e >= 0; e--) {
			let n = this.keyAt(e), r = this.get(n);
			t.set(n, r);
		}
		return t;
	}
	toSpliced(...t) {
		let n = [...this.entries()];
		return n.splice(...t), new e(n);
	}
	slice(t, n) {
		let r = new e(), i = this.size - 1;
		if (t === void 0) return r;
		t < 0 && (t += this.size), n !== void 0 && n > 0 && (i = n - 1);
		for (let e = t; e <= i; e++) {
			let t = this.keyAt(e), n = this.get(t);
			r.set(t, n);
		}
		return r;
	}
	every(e, t) {
		let n = 0;
		for (let r of this) {
			if (!Reflect.apply(e, t, [
				r,
				n,
				this
			])) return !1;
			n++;
		}
		return !0;
	}
	some(e, t) {
		let n = 0;
		for (let r of this) {
			if (Reflect.apply(e, t, [
				r,
				n,
				this
			])) return !0;
			n++;
		}
		return !1;
	}
};
function Ba(e, t) {
	if ("at" in Array.prototype) return Array.prototype.at.call(e, t);
	let n = Va(e, t);
	return n === -1 ? void 0 : e[n];
}
Y(Ba, "at");
function Va(e, t) {
	let n = e.length, r = Ha(t), i = r >= 0 ? r : n + r;
	return i < 0 || i >= n ? -1 : i;
}
Y(Va, "toSafeIndex");
function Ha(e) {
	return e !== e || e === 0 ? 0 : Math.trunc(e);
}
Y(Ha, "toSafeInteger");
// @__NO_SIDE_EFFECTS__
function Ua(t) {
	let n = t + "CollectionProvider", [r, a] = /* @__PURE__ */ on(n), [o, s] = r(n, {
		collectionElement: null,
		collectionRef: { current: null },
		collectionRefObject: { current: null },
		itemMap: new za(),
		setItemMap: /* @__PURE__ */ Y(() => void 0, "setItemMap")
	}), c = /* @__PURE__ */ Y(({ state: e, ...t }) => e ? /* @__PURE__ */ i(u, {
		...t,
		state: e
	}) : /* @__PURE__ */ i(l, { ...t }), "CollectionProvider");
	c.displayName = n;
	let l = /* @__PURE__ */ Y((e) => {
		let t = _();
		return /* @__PURE__ */ i(u, {
			...e,
			state: t
		});
	}, "CollectionInit");
	l.displayName = n + "Init";
	let u = /* @__PURE__ */ Y((t) => {
		let { scope: n, children: r, state: a } = t, s = e.useRef(null), [c, l] = e.useState(null), u = H(s, l), [d, f] = a;
		return e.useEffect(() => {
			if (!c) return;
			let e = qa(() => {});
			return e.observe(c, {
				childList: !0,
				subtree: !0
			}), () => {
				e.disconnect();
			};
		}, [c]), /* @__PURE__ */ i(o, {
			scope: n,
			itemMap: d,
			setItemMap: f,
			collectionRef: u,
			collectionRefObject: s,
			collectionElement: c,
			children: r
		});
	}, "CollectionProviderImpl");
	u.displayName = n + "Impl";
	let d = t + "CollectionSlot", f = /* @__PURE__ */ at(d), p = e.forwardRef((e, t) => {
		let { scope: n, children: r } = e, a = H(t, s(d, n).collectionRef);
		return /* @__PURE__ */ i(f, {
			ref: a,
			children: r
		});
	});
	p.displayName = d;
	let m = t + "CollectionItemSlot", h = /* @__PURE__ */ at(m), g = e.forwardRef((t, n) => {
		let { scope: r, children: a, ...o } = t, c = e.useRef(null), [l, u] = e.useState(null), d = H(n, c, u), { setItemMap: f } = s(m, r), p = e.useRef(o);
		Wa(p.current, o) || (p.current = o);
		let g = p.current;
		return e.useEffect(() => {
			let e = g;
			return f((t) => l ? t.has(l) ? t.set(l, {
				...e,
				element: l
			}).toSorted(Ka) : (t.set(l, {
				...e,
				element: l
			}), t.toSorted(Ka)) : t), () => {
				f((e) => !l || !e.has(l) ? e : (e.delete(l), new za(e)));
			};
		}, [
			l,
			g,
			f
		]), /* @__PURE__ */ i(h, {
			"data-radix-collection-item": "",
			ref: d,
			children: a
		});
	});
	g.displayName = m;
	function _() {
		return e.useState(new za());
	}
	Y(_, "useInitCollection");
	function v(e) {
		let { itemMap: n } = s(t + "CollectionConsumer", e);
		return n;
	}
	return Y(v, "useCollection"), [{
		Provider: c,
		Slot: p,
		ItemSlot: g
	}, {
		createCollectionScope: a,
		useCollection: v,
		useInitCollection: _
	}];
}
Y(Ua, "createCollection");
function Wa(e, t) {
	if (e === t) return !0;
	if (typeof e != "object" || typeof t != "object" || e == null || t == null) return !1;
	let n = Object.keys(e), r = Object.keys(t);
	if (n.length !== r.length) return !1;
	for (let r of n) if (!Object.prototype.hasOwnProperty.call(t, r) || e[r] !== t[r]) return !1;
	return !0;
}
Y(Wa, "shallowEqual");
function Ga(e, t) {
	return !!(t.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_PRECEDING);
}
Y(Ga, "isElementPreceding");
function Ka(e, t) {
	return !e[1].element || !t[1].element ? 0 : Ga(e[1].element, t[1].element) ? -1 : 1;
}
Y(Ka, "sortByDocumentPosition");
function qa(e) {
	return new MutationObserver((t) => {
		for (let n of t) if (n.type === "childList") {
			e();
			return;
		}
	});
}
Y(qa, "getChildListObserver");
//#endregion
//#region ../../node_modules/@radix-ui/react-direction/dist/index.mjs
var Ja = Object.defineProperty, Ya = (e, t) => Ja(e, "name", {
	value: t,
	configurable: !0
}), Xa = e.createContext(void 0);
function Za(t) {
	let n = e.useContext(Xa);
	return t || n || "ltr";
}
Ya(Za, "useDirection");
//#endregion
//#region ../../node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
var Qa = [
	"top",
	"right",
	"bottom",
	"left"
], $a = Math.min, eo = Math.max, to = Math.round, no = Math.floor, ro = (e) => ({
	x: e,
	y: e
}), io = {
	left: "right",
	right: "left",
	bottom: "top",
	top: "bottom"
};
function ao(e, t, n) {
	return eo(e, $a(t, n));
}
function oo(e, t) {
	return typeof e == "function" ? e(t) : e;
}
function so(e) {
	return e.split("-")[0];
}
function co(e) {
	return e.split("-")[1];
}
function lo(e) {
	return e === "x" ? "y" : "x";
}
function uo(e) {
	return e === "y" ? "height" : "width";
}
function fo(e) {
	let t = e[0];
	return t === "t" || t === "b" ? "y" : "x";
}
function po(e) {
	return lo(fo(e));
}
function mo(e, t, n) {
	n === void 0 && (n = !1);
	let r = co(e), i = po(e), a = uo(i), o = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
	return t.reference[a] > t.floating[a] && (o = Co(o)), [o, Co(o)];
}
function ho(e) {
	let t = Co(e);
	return [
		go(e),
		t,
		go(t)
	];
}
function go(e) {
	return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
var _o = ["left", "right"], vo = ["right", "left"], yo = ["top", "bottom"], bo = ["bottom", "top"];
function xo(e, t, n) {
	switch (e) {
		case "top":
		case "bottom": return n ? t ? vo : _o : t ? _o : vo;
		case "left":
		case "right": return t ? yo : bo;
		default: return [];
	}
}
function So(e, t, n, r) {
	let i = co(e), a = xo(so(e), n === "start", r);
	return i && (a = a.map((e) => e + "-" + i), t && (a = a.concat(a.map(go)))), a;
}
function Co(e) {
	let t = so(e);
	return io[t] + e.slice(t.length);
}
function wo(e) {
	return {
		top: e.top ?? 0,
		right: e.right ?? 0,
		bottom: e.bottom ?? 0,
		left: e.left ?? 0
	};
}
function To(e) {
	return typeof e == "number" ? {
		top: e,
		right: e,
		bottom: e,
		left: e
	} : wo(e);
}
function Eo(e) {
	let { x: t, y: n, width: r, height: i } = e;
	return {
		width: r,
		height: i,
		top: n,
		left: t,
		right: t + r,
		bottom: n + i,
		x: t,
		y: n
	};
}
//#endregion
//#region ../../node_modules/@floating-ui/core/dist/floating-ui.core.mjs
function Do(e, t, n) {
	let { reference: r, floating: i } = e, a = fo(t), o = po(t), s = uo(o), c = so(t), l = a === "y", u = r.x + r.width / 2 - i.width / 2, d = r.y + r.height / 2 - i.height / 2, f = r[s] / 2 - i[s] / 2, p;
	switch (c) {
		case "top":
			p = {
				x: u,
				y: r.y - i.height
			};
			break;
		case "bottom":
			p = {
				x: u,
				y: r.y + r.height
			};
			break;
		case "right":
			p = {
				x: r.x + r.width,
				y: d
			};
			break;
		case "left":
			p = {
				x: r.x - i.width,
				y: d
			};
			break;
		default: p = {
			x: r.x,
			y: r.y
		};
	}
	let m = co(t);
	return m && (p[o] += f * (m === "end" ? 1 : -1) * (n && l ? -1 : 1)), p;
}
async function Oo(e, t) {
	t === void 0 && (t = {});
	let { x: n, y: r, platform: i, rects: a, elements: o, strategy: s } = e, { boundary: c = "clippingAncestors", rootBoundary: l = "viewport", elementContext: u = "floating", altBoundary: d = !1, padding: f = 0 } = oo(t, e), p = To(f), m = o[d ? u === "floating" ? "reference" : "floating" : u], h = Eo(await i.getClippingRect({
		element: await (i.isElement == null ? void 0 : i.isElement(m)) ?? !0 ? m : m.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(o.floating)),
		boundary: c,
		rootBoundary: l,
		strategy: s
	})), g = u === "floating" ? {
		x: n,
		y: r,
		width: a.floating.width,
		height: a.floating.height
	} : a.reference, _ = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(o.floating)), v = await (i.isElement == null ? void 0 : i.isElement(_)) && await (i.getScale == null ? void 0 : i.getScale(_)) || {
		x: 1,
		y: 1
	}, y = Eo(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
		elements: o,
		rect: g,
		offsetParent: _,
		strategy: s
	}) : g);
	return {
		top: (h.top - y.top + p.top) / v.y,
		bottom: (y.bottom - h.bottom + p.bottom) / v.y,
		left: (h.left - y.left + p.left) / v.x,
		right: (y.right - h.right + p.right) / v.x
	};
}
var ko = 50, Ao = async (e, t, n) => {
	let { placement: r = "bottom", strategy: i = "absolute", middleware: a = [], platform: o } = n, s = o.detectOverflow ? o : {
		...o,
		detectOverflow: Oo
	}, c = await (o.isRTL == null ? void 0 : o.isRTL(t)), l = await o.getElementRects({
		reference: e,
		floating: t,
		strategy: i
	}), { x: u, y: d } = Do(l, r, c), f = r, p = 0, m = {};
	for (let n = 0; n < a.length; n++) {
		let h = a[n];
		if (!h) continue;
		let { name: g, fn: _ } = h, { x: v, y, data: b, reset: x } = await _({
			x: u,
			y: d,
			initialPlacement: r,
			placement: f,
			strategy: i,
			middlewareData: m,
			rects: l,
			platform: s,
			elements: {
				reference: e,
				floating: t
			}
		});
		u = v ?? u, d = y ?? d, m[g] = {
			...m[g],
			...b
		}, x && p < ko && (p++, typeof x == "object" && (x.placement && (f = x.placement), x.rects && (l = x.rects === !0 ? await o.getElementRects({
			reference: e,
			floating: t,
			strategy: i
		}) : x.rects), {x: u, y: d} = Do(l, f, c)), n = -1);
	}
	return {
		x: u,
		y: d,
		placement: f,
		strategy: i,
		middlewareData: m
	};
}, jo = (e) => ({
	name: "arrow",
	options: e,
	async fn(t) {
		let { x: n, y: r, placement: i, rects: a, platform: o, elements: s, middlewareData: c } = t, { element: l, padding: u = 0 } = oo(e, t) || {};
		if (l == null) return {};
		let d = To(u), f = {
			x: n,
			y: r
		}, p = po(i), m = uo(p), h = await o.getDimensions(l), g = p === "y", _ = g ? "top" : "left", v = g ? "bottom" : "right", y = g ? "clientHeight" : "clientWidth", b = a.reference[m] + a.reference[p] - f[p] - a.floating[m], x = f[p] - a.reference[p], S = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(l)), C = S ? S[y] : 0;
		(!C || !await (o.isElement == null ? void 0 : o.isElement(S))) && (C = s.floating[y] || a.floating[m]);
		let w = b / 2 - x / 2, T = C / 2 - h[m] / 2 - 1, E = $a(d[_], T), ee = $a(d[v], T), D = C - h[m] - ee, O = C / 2 - h[m] / 2 + w, te = ao(E, O, D), k = !c.arrow && co(i) != null && O !== te && a.reference[m] / 2 - (O < E ? E : ee) - h[m] / 2 < 0, A = k ? O < E ? O - E : O - D : 0;
		return {
			[p]: f[p] + A,
			data: {
				[p]: te,
				centerOffset: O - te - A,
				...k && { alignmentOffset: A }
			},
			reset: k
		};
	}
}), Mo = function(e) {
	return e === void 0 && (e = {}), {
		name: "flip",
		options: e,
		async fn(t) {
			var n;
			let { placement: r, middlewareData: i, rects: a, initialPlacement: o, platform: s, elements: c } = t, { mainAxis: l = !0, crossAxis: u = !0, fallbackPlacements: d, fallbackStrategy: f = "bestFit", fallbackAxisSideDirection: p = "none", flipAlignment: m = !0, ...h } = oo(e, t);
			if ((n = i.arrow) != null && n.alignmentOffset) return {};
			let g = so(r), _ = fo(o), v = so(o) === o, y = await (s.isRTL == null ? void 0 : s.isRTL(c.floating)), b = d || (v || !m ? [Co(o)] : ho(o)), x = p !== "none";
			!d && x && b.push(...So(o, m, p, y));
			let S = [o, ...b], C = await s.detectOverflow(t, h), w = [], T = i.flip?.overflows || [];
			if (l && w.push(C[g]), u) {
				let e = mo(r, a, y);
				w.push(C[e[0]], C[e[1]]);
			}
			if (T = [...T, {
				placement: r,
				overflows: w
			}], !w.every((e) => e <= 0)) {
				let e = (i.flip?.index || 0) + 1, t = S[e];
				if (t && (!(u === "alignment" && _ !== fo(t)) || T.every((e) => fo(e.placement) !== _ || e.overflows[0] > 0))) return {
					data: {
						index: e,
						overflows: T
					},
					reset: { placement: t }
				};
				let n = T.filter((e) => e.overflows[0] <= 0).sort((e, t) => e.overflows[1] - t.overflows[1])[0]?.placement;
				if (!n) switch (f) {
					case "bestFit": {
						let e = T.filter((e) => {
							if (x) {
								let t = fo(e.placement);
								return t === _ || t === "y";
							}
							return !0;
						}).map((e) => [e.placement, e.overflows.filter((e) => e > 0).reduce((e, t) => e + t, 0)]).sort((e, t) => e[1] - t[1])[0]?.[0];
						e && (n = e);
						break;
					}
					case "initialPlacement":
						n = o;
						break;
				}
				if (r !== n) return { reset: { placement: n } };
			}
			return {};
		}
	};
};
function No(e, t) {
	return {
		top: e.top - t.height,
		right: e.right - t.width,
		bottom: e.bottom - t.height,
		left: e.left - t.width
	};
}
function Po(e) {
	return Qa.some((t) => e[t] >= 0);
}
var Fo = function(e) {
	return e === void 0 && (e = {}), {
		name: "hide",
		options: e,
		async fn(t) {
			let { rects: n, platform: r } = t, { strategy: i = "referenceHidden", ...a } = oo(e, t);
			switch (i) {
				case "referenceHidden": {
					let e = No(await r.detectOverflow(t, {
						...a,
						elementContext: "reference"
					}), n.reference);
					return { data: {
						referenceHiddenOffsets: e,
						referenceHidden: Po(e)
					} };
				}
				case "escaped": {
					let e = No(await r.detectOverflow(t, {
						...a,
						altBoundary: !0
					}), n.floating);
					return { data: {
						escapedOffsets: e,
						escaped: Po(e)
					} };
				}
				default: return {};
			}
		}
	};
}, Io = /*#__PURE__*/ new Set(["left", "top"]);
async function Lo(e, t) {
	let { placement: n, platform: r, elements: i } = e, a = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), o = so(n), s = co(n), c = fo(n) === "y", l = Io.has(o) ? -1 : 1, u = a && c ? -1 : 1, d = oo(t, e), { mainAxis: f, crossAxis: p, alignmentAxis: m } = typeof d == "number" ? {
		mainAxis: d,
		crossAxis: 0,
		alignmentAxis: null
	} : {
		mainAxis: d.mainAxis || 0,
		crossAxis: d.crossAxis || 0,
		alignmentAxis: d.alignmentAxis
	};
	return s && typeof m == "number" && (p = s === "end" ? m * -1 : m), c ? {
		x: p * u,
		y: f * l
	} : {
		x: f * l,
		y: p * u
	};
}
var Ro = function(e) {
	return e === void 0 && (e = 0), {
		name: "offset",
		options: e,
		async fn(t) {
			var n;
			let { x: r, y: i, placement: a, middlewareData: o } = t, s = await Lo(t, e);
			return a === o.offset?.placement && (n = o.arrow) != null && n.alignmentOffset ? {} : {
				x: r + s.x,
				y: i + s.y,
				data: {
					...s,
					placement: a
				}
			};
		}
	};
}, zo = function(e) {
	return e === void 0 && (e = {}), {
		name: "shift",
		options: e,
		async fn(t) {
			let { x: n, y: r, placement: i, platform: a } = t, { mainAxis: o = !0, crossAxis: s = !1, limiter: c = { fn: (e) => {
				let { x: t, y: n } = e;
				return {
					x: t,
					y: n
				};
			} }, ...l } = oo(e, t), u = {
				x: n,
				y: r
			}, d = await a.detectOverflow(t, l), f = fo(i), p = lo(f), m = u[p], h = u[f], g = (e, t) => ao(t + d[e === "y" ? "top" : "left"], t, t - d[e === "y" ? "bottom" : "right"]);
			o && (m = g(p, m)), s && (h = g(f, h));
			let _ = c.fn({
				...t,
				[p]: m,
				[f]: h
			});
			return {
				..._,
				data: {
					x: _.x - n,
					y: _.y - r,
					enabled: {
						[p]: o,
						[f]: s
					}
				}
			};
		}
	};
}, Bo = function(e) {
	return e === void 0 && (e = {}), {
		options: e,
		fn(t) {
			let { x: n, y: r, placement: i, rects: a, middlewareData: o } = t, { offset: s = 0, mainAxis: c = !0, crossAxis: l = !0 } = oo(e, t), u = {
				x: n,
				y: r
			}, d = fo(i), f = lo(d), p = u[f], m = u[d], h = oo(s, t), g = typeof h == "number" ? {
				mainAxis: h,
				crossAxis: 0
			} : {
				mainAxis: h.mainAxis ?? 0,
				crossAxis: h.crossAxis ?? 0
			};
			if (c) {
				let e = f === "y" ? "height" : "width", t = a.reference[f] - a.floating[e] + g.mainAxis, n = a.reference[f] + a.reference[e] - g.mainAxis;
				p < t ? p = t : p > n && (p = n);
			}
			if (l) {
				let e = f === "y" ? "width" : "height", t = Io.has(so(i)), n = a.reference[d] - a.floating[e] + (t && o.offset?.[d] || 0) + (t ? 0 : g.crossAxis), r = a.reference[d] + a.reference[e] + (t ? 0 : o.offset?.[d] || 0) - (t ? g.crossAxis : 0);
				m < n ? m = n : m > r && (m = r);
			}
			return {
				[f]: p,
				[d]: m
			};
		}
	};
}, Vo = function(e) {
	return e === void 0 && (e = {}), {
		name: "size",
		options: e,
		async fn(t) {
			let { placement: n, rects: r, platform: i, elements: a } = t, { apply: o = () => {}, ...s } = oo(e, t), c = await i.detectOverflow(t, s), l = so(n), u = co(n), d = fo(n) === "y", { width: f, height: p } = r.floating, m, h;
			l === "top" || l === "bottom" ? (m = l, h = u === (await (i.isRTL == null ? void 0 : i.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (h = l, m = u === "end" ? "top" : "bottom");
			let g = p - c.top - c.bottom, _ = f - c.left - c.right, v = $a(p - c[m], g), y = $a(f - c[h], _), b = t.middlewareData.shift, x = !b, S = v, C = y;
			b != null && b.enabled.x && (C = _), b != null && b.enabled.y && (S = g), x && !u && (d ? C = f - 2 * eo(c.left, c.right) : S = p - 2 * eo(c.top, c.bottom)), await o({
				...t,
				availableWidth: C,
				availableHeight: S
			});
			let w = await i.getDimensions(a.floating);
			return f !== w.width || p !== w.height ? { reset: { rects: !0 } } : {};
		}
	};
};
//#endregion
//#region ../../node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
function Ho() {
	return typeof window < "u";
}
function Uo(e) {
	return Go(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function X(e) {
	var t;
	return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Wo(e) {
	return ((Go(e) ? e.ownerDocument : e.document) || window.document)?.documentElement;
}
function Go(e) {
	return Ho() ? e instanceof Node || e instanceof X(e).Node : !1;
}
function Ko(e) {
	return Ho() ? e instanceof Element || e instanceof X(e).Element : !1;
}
function qo(e) {
	return Ho() ? e instanceof HTMLElement || e instanceof X(e).HTMLElement : !1;
}
function Jo(e) {
	return !Ho() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof X(e).ShadowRoot;
}
function Yo(e) {
	let { overflow: t, overflowX: n, overflowY: r, display: i } = os(e);
	return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && i !== "inline" && i !== "contents";
}
function Xo(e) {
	return /^(table|td|th)$/.test(Uo(e));
}
function Zo(e) {
	try {
		if (e.matches(":popover-open")) return !0;
	} catch {}
	try {
		return e.matches(":modal");
	} catch {
		return !1;
	}
}
var Qo = /transform|translate|scale|rotate|perspective|filter/, $o = /paint|layout|strict|content/, es = (e) => !!e && e !== "none", ts;
function ns(e) {
	let t = Ko(e) ? os(e) : e;
	return es(t.transform) || es(t.translate) || es(t.scale) || es(t.rotate) || es(t.perspective) || !is() && (es(t.backdropFilter) || es(t.filter)) || Qo.test(t.willChange || "") || $o.test(t.contain || "");
}
function rs(e) {
	let t = cs(e);
	for (; qo(t) && !as(t);) {
		if (ns(t)) return t;
		if (Zo(t)) return null;
		t = cs(t);
	}
	return null;
}
function is() {
	return ts ??= typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none"), ts;
}
function as(e) {
	return /^(html|body|#document)$/.test(Uo(e));
}
function os(e) {
	return X(e).getComputedStyle(e);
}
function ss(e) {
	return Ko(e) ? {
		scrollLeft: e.scrollLeft,
		scrollTop: e.scrollTop
	} : {
		scrollLeft: e.scrollX,
		scrollTop: e.scrollY
	};
}
function cs(e) {
	if (Uo(e) === "html") return e;
	let t = e.assignedSlot || e.parentNode || Jo(e) && e.host || Wo(e);
	return Jo(t) ? t.host : t;
}
function ls(e) {
	let t = cs(e);
	return as(t) ? (e.ownerDocument || e).body : qo(t) && Yo(t) ? t : ls(t);
}
function us(e, t, n) {
	t === void 0 && (t = []), n === void 0 && (n = !0);
	let r = ls(e), i = r === e.ownerDocument?.body, a = X(r);
	if (i) {
		let e = ds(a);
		return t.concat(a, a.visualViewport || [], Yo(r) ? r : [], e && n ? us(e) : []);
	} else return t.concat(r, us(r, [], n));
}
function ds(e) {
	return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
//#endregion
//#region ../../node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs
function fs(e) {
	let t = os(e), n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0, i = qo(e), a = i ? e.offsetWidth : n, o = i ? e.offsetHeight : r, s = to(n) !== a || to(r) !== o;
	return s && (n = a, r = o), {
		width: n,
		height: r,
		$: s
	};
}
function ps(e) {
	return Ko(e) ? e : e.contextElement;
}
function ms(e) {
	let t = ps(e);
	if (!qo(t)) return ro(1);
	let n = t.getBoundingClientRect(), { width: r, height: i, $: a } = fs(t), o = (a ? to(n.width) : n.width) / r, s = (a ? to(n.height) : n.height) / i;
	return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
		x: o,
		y: s
	};
}
var hs = /*#__PURE__*/ ro(0);
function gs(e) {
	let t = X(e);
	return !is() || !t.visualViewport ? hs : {
		x: t.visualViewport.offsetLeft,
		y: t.visualViewport.offsetTop
	};
}
function _s(e, t, n) {
	return t === void 0 && (t = !1), !!n && t && n === X(e);
}
function vs(e, t, n, r) {
	t === void 0 && (t = !1), n === void 0 && (n = !1);
	let i = e.getBoundingClientRect(), a = ps(e), o = ro(1);
	t && (r ? Ko(r) && (o = ms(r)) : o = ms(e));
	let s = _s(a, n, r) ? gs(a) : ro(0), c = (i.left + s.x) / o.x, l = (i.top + s.y) / o.y, u = i.width / o.x, d = i.height / o.y;
	if (a && r) {
		let e = X(a), t = Ko(r) ? X(r) : r, n = e, i = ds(n);
		for (; i && t !== n;) {
			let e = ms(i), t = i.getBoundingClientRect(), r = os(i), a = t.left + (i.clientLeft + parseFloat(r.paddingLeft)) * e.x, o = t.top + (i.clientTop + parseFloat(r.paddingTop)) * e.y;
			c *= e.x, l *= e.y, u *= e.x, d *= e.y, c += a, l += o, n = X(i), i = ds(n);
		}
	}
	return Eo({
		width: u,
		height: d,
		x: c,
		y: l
	});
}
function ys(e, t) {
	let n = ss(e).scrollLeft;
	return t ? t.left + n : vs(Wo(e)).left + n;
}
function bs(e, t) {
	let n = e.getBoundingClientRect();
	return {
		x: n.left + t.scrollLeft - ys(e, n),
		y: n.top + t.scrollTop
	};
}
function xs(e) {
	let { elements: t, rect: n, offsetParent: r, strategy: i } = e, a = i === "fixed", o = Wo(r), s = t ? Zo(t.floating) : !1;
	if (r === o || s && a) return n;
	let c = {
		scrollLeft: 0,
		scrollTop: 0
	}, l = ro(1), u = ro(0), d = qo(r);
	if ((d || !a) && ((Uo(r) !== "body" || Yo(o)) && (c = ss(r)), d)) {
		let e = vs(r);
		l = ms(r), u.x = e.x + r.clientLeft, u.y = e.y + r.clientTop;
	}
	let f = o && !d && !a ? bs(o, c) : ro(0);
	return {
		width: n.width * l.x,
		height: n.height * l.y,
		x: n.x * l.x - c.scrollLeft * l.x + u.x + f.x,
		y: n.y * l.y - c.scrollTop * l.y + u.y + f.y
	};
}
function Ss(e) {
	return e.getClientRects ? Array.from(e.getClientRects()) : [];
}
function Cs(e) {
	let t = ss(e), n = e.ownerDocument.body, r = eo(e.scrollWidth, e.clientWidth, n.scrollWidth, n.clientWidth), i = eo(e.scrollHeight, e.clientHeight, n.scrollHeight, n.clientHeight), a = -t.scrollLeft + ys(e), o = -t.scrollTop;
	return os(n).direction === "rtl" && (a += eo(e.clientWidth, n.clientWidth) - r), {
		width: r,
		height: i,
		x: a,
		y: o
	};
}
var ws = 25;
function Ts(e, t, n) {
	n === void 0 && (n = "viewport");
	let r = n === "layoutViewport", i = X(e), a = Wo(e), o = i.visualViewport, s = a.clientWidth, c = a.clientHeight, l = 0, u = 0;
	if (o) {
		let e = !is() || t === "fixed";
		r ? e || (l = -o.offsetLeft, u = -o.offsetTop) : (s = o.width, c = o.height, e && (l = o.offsetLeft, u = o.offsetTop));
	}
	if (ys(a) <= 0) {
		let e = a.ownerDocument, t = e.body, n = getComputedStyle(t), r = e.compatMode === "CSS1Compat" && parseFloat(n.marginLeft) + parseFloat(n.marginRight) || 0, i = Math.abs(a.clientWidth - t.clientWidth - r), o = getComputedStyle(a).scrollbarGutter === "stable both-edges" ? i / 2 : i;
		o <= ws && (s -= o);
	}
	return {
		width: s,
		height: c,
		x: l,
		y: u
	};
}
function Es(e, t) {
	let n = vs(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, a = ms(e);
	return {
		width: e.clientWidth * a.x,
		height: e.clientHeight * a.y,
		x: i * a.x,
		y: r * a.y
	};
}
function Ds(e, t, n) {
	let r;
	if (t === "viewport" || t === "layoutViewport") r = Ts(e, n, t);
	else if (t === "document") r = Cs(Wo(e));
	else if (Ko(t)) r = Es(t, n);
	else {
		let n = gs(e);
		r = {
			x: t.x - n.x,
			y: t.y - n.y,
			width: t.width,
			height: t.height
		};
	}
	return Eo(r);
}
function Os(e, t) {
	let n = t.get(e);
	if (n) return n;
	let r = us(e, [], !1).filter((e) => Ko(e) && Uo(e) !== "body"), i = null, a = os(e).position === "fixed", o = a ? cs(e) : e;
	for (; Ko(o) && !as(o);) {
		let e = os(o), t = ns(o), n = i ? i.position : a ? "fixed" : "";
		!t && (n === "fixed" || n === "absolute" && e.position === "static") ? r = r.filter((e) => e !== o) : i = e, o = cs(o);
	}
	return t.set(e, r), r;
}
function ks(e) {
	let { element: t, boundary: n, rootBoundary: r, strategy: i } = e, a = [...n === "clippingAncestors" ? Zo(t) ? [] : Os(t, this._c) : [].concat(n), r], o = Ds(t, a[0], i), s = o.top, c = o.right, l = o.bottom, u = o.left;
	for (let e = 1; e < a.length; e++) {
		let n = Ds(t, a[e], i);
		s = eo(n.top, s), c = $a(n.right, c), l = $a(n.bottom, l), u = eo(n.left, u);
	}
	return {
		width: c - u,
		height: l - s,
		x: u,
		y: s
	};
}
function As(e) {
	let { width: t, height: n } = fs(e);
	return {
		width: t,
		height: n
	};
}
function js(e, t, n) {
	let r = qo(t), i = Wo(t), a = n === "fixed", o = vs(e, !0, a, t), s = {
		scrollLeft: 0,
		scrollTop: 0
	}, c = ro(0);
	if ((r || !a) && ((Uo(t) !== "body" || Yo(i)) && (s = ss(t)), r)) {
		let e = vs(t, !0, a, t);
		c.x = e.x + t.clientLeft, c.y = e.y + t.clientTop;
	}
	!r && i && (c.x = ys(i));
	let l = i && !r && !a ? bs(i, s) : ro(0);
	return {
		x: o.left + s.scrollLeft - c.x - l.x,
		y: o.top + s.scrollTop - c.y - l.y,
		width: o.width,
		height: o.height
	};
}
function Ms(e) {
	return os(e).position === "static";
}
function Ns(e, t) {
	if (!qo(e) || os(e).position === "fixed") return null;
	if (t) return t(e);
	let n = e.offsetParent;
	return Wo(e) === n && (n = n.ownerDocument.body), n;
}
function Ps(e, t) {
	let n = X(e);
	if (Zo(e)) return n;
	if (!qo(e)) {
		let t = cs(e);
		for (; t && !as(t);) {
			if (Ko(t) && !Ms(t)) return t;
			t = cs(t);
		}
		return n;
	}
	let r = Ns(e, t);
	for (; r && Xo(r) && Ms(r);) r = Ns(r, t);
	return r && as(r) && Ms(r) && !ns(r) ? n : r || rs(e) || n;
}
var Fs = async function(e) {
	let t = this.getOffsetParent || Ps, n = this.getDimensions, r = await n(e.floating);
	return {
		reference: js(e.reference, await t(e.floating), e.strategy),
		floating: {
			x: 0,
			y: 0,
			width: r.width,
			height: r.height
		}
	};
};
function Is(e) {
	return os(e).direction === "rtl";
}
var Ls = {
	convertOffsetParentRelativeRectToViewportRelativeRect: xs,
	getDocumentElement: Wo,
	getClippingRect: ks,
	getOffsetParent: Ps,
	getElementRects: Fs,
	getClientRects: Ss,
	getDimensions: As,
	getScale: ms,
	isElement: Ko,
	isRTL: Is
};
function Rs(e, t) {
	return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function zs(e, t, n) {
	let r = null, i, a = Wo(e);
	function o() {
		var e;
		clearTimeout(i), (e = r) == null || e.disconnect(), r = null;
	}
	function s(n, c) {
		n === void 0 && (n = !1), c === void 0 && (c = 1), o();
		let l = e.getBoundingClientRect(), { left: u, top: d, width: f, height: p } = l;
		if (n || t(), !f || !p) return;
		let m = no(d), h = no(a.clientWidth - (u + f)), g = no(a.clientHeight - (d + p)), _ = no(u), v = {
			rootMargin: -m + "px " + -h + "px " + -g + "px " + -_ + "px",
			threshold: eo(0, $a(1, c)) || 1
		}, y = !0;
		function b(t) {
			let n = t[0].intersectionRatio;
			if (!Rs(l, e.getBoundingClientRect())) return s();
			if (n !== c) {
				if (!y) return s();
				n ? s(!1, n) : i = setTimeout(() => {
					s(!1, 1e-7);
				}, 1e3);
			}
			y = !1;
		}
		try {
			r = new IntersectionObserver(b, {
				...v,
				root: a.ownerDocument
			});
		} catch {
			r = new IntersectionObserver(b, v);
		}
		r.observe(e);
	}
	let c = X(e), l = () => s(n);
	return c.addEventListener("resize", l), s(!0), () => {
		c.removeEventListener("resize", l), o();
	};
}
function Bs(e, t, n, r) {
	r === void 0 && (r = {});
	let { ancestorScroll: i = !0, ancestorResize: a = !0, elementResize: o = typeof ResizeObserver == "function", layoutShift: s = typeof IntersectionObserver == "function", animationFrame: c = !1 } = r, l = ps(e), u = i || a ? [...l ? us(l) : [], ...t ? us(t) : []] : [];
	u.forEach((e) => {
		i && e.addEventListener("scroll", n), a && e.addEventListener("resize", n);
	});
	let d = l && s ? zs(l, n, a) : null, f = -1, p = null;
	o && (p = new ResizeObserver((e) => {
		let [r] = e;
		r && r.target === l && p && t && (p.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
			var e;
			(e = p) == null || e.observe(t);
		})), n();
	}), l && !c && p.observe(l), t && p.observe(t));
	let m, h = c ? vs(e) : null;
	c && g();
	function g() {
		let t = vs(e);
		h && !Rs(h, t) && n(), h = t, m = requestAnimationFrame(g);
	}
	return n(), () => {
		var e;
		u.forEach((e) => {
			i && e.removeEventListener("scroll", n), a && e.removeEventListener("resize", n);
		}), d?.(), (e = p) == null || e.disconnect(), p = null, c && cancelAnimationFrame(m);
	};
}
var Vs = Ro, Hs = zo, Us = Mo, Ws = Vo, Gs = Fo, Ks = jo, qs = Bo, Js = (e, t, n) => {
	let r = /* @__PURE__ */ new Map(), i = n ?? {}, a = {
		...Ls,
		...i.platform,
		_c: r
	};
	return Ao(e, t, {
		...i,
		platform: a
	});
}, Ys = typeof document < "u" ? t : function() {};
function Xs(e, t) {
	if (e === t) return !0;
	if (typeof e != typeof t) return !1;
	if (typeof e == "function" && e.toString() === t.toString()) return !0;
	let n, r, i;
	if (e && t && typeof e == "object") {
		if (Array.isArray(e)) {
			if (n = e.length, n !== t.length) return !1;
			for (r = n; r-- !== 0;) if (!Xs(e[r], t[r])) return !1;
			return !0;
		}
		if (i = Object.keys(e), n = i.length, n !== Object.keys(t).length) return !1;
		for (r = n; r-- !== 0;) if (!{}.hasOwnProperty.call(t, i[r])) return !1;
		for (r = n; r-- !== 0;) {
			let n = i[r];
			if (!(n === "_owner" && e.$$typeof) && !Xs(e[n], t[n])) return !1;
		}
		return !0;
	}
	return e !== e && t !== t;
}
function Zs(e) {
	return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Qs(e, t) {
	let n = Zs(e);
	return Math.round(t * n) / n;
}
function $s(t) {
	let n = e.useRef(t);
	return Ys(() => {
		n.current = t;
	}), n;
}
function ec(t) {
	t === void 0 && (t = {});
	let { placement: n = "bottom", strategy: r = "absolute", middleware: i = [], platform: a, elements: { reference: s, floating: c } = {}, transform: l = !0, whileElementsMounted: u, open: d } = t, [f, p] = e.useState({
		x: 0,
		y: 0,
		strategy: r,
		placement: n,
		middlewareData: {},
		isPositioned: !1
	}), [m, h] = e.useState(i);
	Xs(m, i) || h(i);
	let [g, _] = e.useState(null), [v, y] = e.useState(null), b = e.useCallback((e) => {
		e !== w.current && (w.current = e, _(e));
	}, []), x = e.useCallback((e) => {
		e !== T.current && (T.current = e, y(e));
	}, []), S = s || g, C = c || v, w = e.useRef(null), T = e.useRef(null), E = e.useRef(f), ee = u != null, D = $s(u), O = $s(a), te = $s(d), k = e.useCallback(() => {
		if (!w.current || !T.current) return;
		let e = {
			placement: n,
			strategy: r,
			middleware: m
		};
		O.current && (e.platform = O.current), Js(w.current, T.current, e).then((e) => {
			let t = {
				...e,
				isPositioned: te.current !== !1
			};
			A.current && !Xs(E.current, t) && (E.current = t, o.flushSync(() => {
				p(t);
			}));
		});
	}, [
		m,
		n,
		r,
		O,
		te
	]);
	Ys(() => {
		d === !1 && E.current.isPositioned && (E.current.isPositioned = !1, p((e) => ({
			...e,
			isPositioned: !1
		})));
	}, [d]);
	let A = e.useRef(!1);
	Ys(() => (A.current = !0, () => {
		A.current = !1;
	}), []), Ys(() => {
		if (S && (w.current = S), C && (T.current = C), S && C) {
			if (D.current) return D.current(S, C, k);
			k();
		}
	}, [
		S,
		C,
		k,
		D,
		ee
	]);
	let j = e.useMemo(() => ({
		reference: w,
		floating: T,
		setReference: b,
		setFloating: x
	}), [b, x]), M = e.useMemo(() => ({
		reference: S,
		floating: C
	}), [S, C]), ne = e.useMemo(() => {
		let e = {
			position: r,
			left: 0,
			top: 0
		};
		if (!M.floating) return e;
		let t = Qs(M.floating, f.x), n = Qs(M.floating, f.y);
		return l ? {
			...e,
			transform: "translate(" + t + "px, " + n + "px)",
			...Zs(M.floating) >= 1.5 && { willChange: "transform" }
		} : {
			position: r,
			left: t,
			top: n
		};
	}, [
		r,
		l,
		M.floating,
		f.x,
		f.y
	]);
	return e.useMemo(() => ({
		...f,
		update: k,
		refs: j,
		elements: M,
		floatingStyles: ne
	}), [
		f,
		k,
		j,
		M,
		ne
	]);
}
var tc = (e) => {
	function t(e) {
		return {}.hasOwnProperty.call(e, "current");
	}
	return {
		name: "arrow",
		options: e,
		fn(n) {
			let { element: r, padding: i } = typeof e == "function" ? e(n) : e;
			return r && t(r) ? r.current == null ? {} : Ks({
				element: r.current,
				padding: i
			}).fn(n) : r ? Ks({
				element: r,
				padding: i
			}).fn(n) : {};
		}
	};
}, nc = (e, t) => {
	let n = Vs(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, rc = (e, t) => {
	let n = Hs(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, ic = (e, t) => ({
	fn: qs(e).fn,
	options: [e, t]
}), ac = (e, t) => {
	let n = Us(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, oc = (e, t) => {
	let n = Ws(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, sc = (e, t) => {
	let n = Gs(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, cc = (e, t) => {
	let n = tc(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, lc = Object.defineProperty, uc = (e, t) => lc(e, "name", {
	value: t,
	configurable: !0
});
function dc(t) {
	let [n, r] = e.useState(void 0);
	return cn(() => {
		if (t) {
			r({
				width: t.offsetWidth,
				height: t.offsetHeight
			});
			let e = new ResizeObserver((e) => {
				if (!Array.isArray(e) || !e.length) return;
				let n = e[0], i, a;
				if ("borderBoxSize" in n) {
					let e = n.borderBoxSize, t = Array.isArray(e) ? e[0] : e;
					i = t.inlineSize, a = t.blockSize;
				} else i = t.offsetWidth, a = t.offsetHeight;
				r({
					width: i,
					height: a
				});
			});
			return e.observe(t, { box: "border-box" }), () => e.unobserve(t);
		} else r(void 0);
	}, [t]), n;
}
uc(dc, "useSize");
//#endregion
//#region ../../node_modules/@radix-ui/react-popper/dist/index.mjs
var fc = Object.defineProperty, pc = (e, t) => fc(e, "name", {
	value: t,
	configurable: !0
}), mc = {
	Partial: "partial",
	Always: "always"
}, hc = {
	Optimized: "optimized",
	Always: "always"
}, gc = "Popper", [_c, vc] = /* @__PURE__ */ on(gc), [yc, bc] = _c(gc), xc = /* @__PURE__ */ pc((t) => {
	let { __scopePopper: n, children: r } = t, [a, o] = e.useState(null), [s, c] = e.useState(void 0);
	return /* @__PURE__ */ i(yc, {
		scope: n,
		anchor: a,
		onAnchorChange: o,
		placementState: s,
		setPlacementState: c,
		children: r
	});
}, "Popper"), Sc = "PopperAnchor", Cc = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ pc(function(t, n) {
	let { __scopePopper: r, virtualRef: a, ...o } = t, s = bc(Sc, r), c = e.useRef(null), l = s.onAnchorChange, u = H(n, e.useCallback((e) => {
		c.current = e, e && l(e);
	}, [l])), d = e.useRef(null);
	e.useEffect(() => {
		if (!a) return;
		let e = d.current;
		d.current = a.current, e !== d.current && l(d.current);
	});
	let f = s.placementState && Ac(s.placementState), p = f?.[0], m = f?.[1];
	return a ? null : /* @__PURE__ */ i(G.div, {
		"data-radix-popper-side": p,
		"data-radix-popper-align": m,
		...o,
		ref: u
	});
}, "PopperAnchor")), wc = "PopperContent", [Tc, Ec] = _c(wc), Dc = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ pc(function(t, n) {
	let { __scopePopper: r, side: a = "bottom", sideOffset: o = 0, align: s = "center", alignOffset: c = 0, arrowPadding: l = 0, avoidCollisions: u = !0, collisionBoundary: d = [], collisionPadding: f = 0, sticky: p = mc.Partial, hideWhenDetached: m = !1, updatePositionStrategy: h = hc.Optimized, onPlaced: g, ..._ } = t, v = bc(wc, r), [y, b] = e.useState(null), x = H(n, b), [S, C] = e.useState(null), w = dc(S), T = w?.width ?? 0, E = w?.height ?? 0, ee = a + (s === "center" ? "" : "-" + s), D = typeof f == "number" ? f : {
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
		...f
	}, O = Array.isArray(d) ? d : [d], te = O.length > 0, k = {
		padding: D,
		boundary: O.filter(Oc),
		altBoundary: te
	}, { refs: A, floatingStyles: j, placement: M, isPositioned: ne, middlewareData: N } = ec({
		strategy: "fixed",
		placement: ee,
		whileElementsMounted: /* @__PURE__ */ pc((...e) => Bs(...e, { animationFrame: h === hc.Always }), "whileElementsMounted"),
		elements: { reference: v.anchor },
		middleware: [
			nc({
				mainAxis: o + E,
				alignmentAxis: c
			}),
			u && rc({
				mainAxis: !0,
				crossAxis: !1,
				limiter: p === mc.Partial ? ic() : void 0,
				...k
			}),
			u && ac({ ...k }),
			oc({
				...k,
				apply: /* @__PURE__ */ pc(({ elements: e, rects: t, availableWidth: n, availableHeight: r }) => {
					let { width: i, height: a } = t.reference, o = e.floating.style;
					o.setProperty("--radix-popper-available-width", `${n}px`), o.setProperty("--radix-popper-available-height", `${r}px`), o.setProperty("--radix-popper-anchor-width", `${i}px`), o.setProperty("--radix-popper-anchor-height", `${a}px`);
				}, "apply")
			}),
			S && cc({
				element: S,
				padding: l
			}),
			kc({
				arrowWidth: T,
				arrowHeight: E
			}),
			m && sc({
				strategy: "referenceHidden",
				...k,
				boundary: te ? k.boundary : void 0
			})
		]
	}), re = v.setPlacementState;
	cn(() => (re(M), () => {
		re(void 0);
	}), [M, re]);
	let [ie, ae] = Ac(M), oe = Mn(g);
	cn(() => {
		ne && oe?.();
	}, [ne, oe]);
	let P = N.arrow?.x, F = N.arrow?.y, I = N.arrow?.centerOffset !== 0, [se, ce] = e.useState();
	return cn(() => {
		y && ce(window.getComputedStyle(y).zIndex);
	}, [y]), /* @__PURE__ */ i("div", {
		ref: A.setFloating,
		"data-radix-popper-content-wrapper": "",
		style: {
			...j,
			transform: ne ? j.transform : "translate(0, -200%)",
			minWidth: "max-content",
			zIndex: se,
			"--radix-popper-transform-origin": [N.transformOrigin?.x, N.transformOrigin?.y].join(" "),
			...N.hide?.referenceHidden && {
				visibility: "hidden",
				pointerEvents: "none"
			}
		},
		dir: t.dir,
		children: /* @__PURE__ */ i(Tc, {
			scope: r,
			placedSide: ie,
			placedAlign: ae,
			onArrowChange: C,
			arrowX: P,
			arrowY: F,
			shouldHideArrow: I,
			children: /* @__PURE__ */ i(G.div, {
				"data-side": ie,
				"data-align": ae,
				..._,
				ref: x,
				style: {
					..._.style,
					animation: ne ? _.style?.animation : "none"
				}
			})
		})
	});
}, "PopperContent"));
function Oc(e) {
	return e !== null;
}
pc(Oc, "isNotNull");
var kc = /* @__PURE__ */ pc((e) => ({
	name: "transformOrigin",
	options: e,
	fn(t) {
		let { placement: n, rects: r, middlewareData: i } = t, a = i.arrow?.centerOffset !== 0, o = a ? 0 : e.arrowWidth, s = a ? 0 : e.arrowHeight, [c, l] = Ac(n), u = {
			start: "0%",
			center: "50%",
			end: "100%"
		}[l], d = (i.arrow?.x ?? 0) + o / 2, f = (i.arrow?.y ?? 0) + s / 2, p = "", m = "";
		return c === "bottom" ? (p = a ? u : `${d}px`, m = `${-s}px`) : c === "top" ? (p = a ? u : `${d}px`, m = `${r.floating.height + s}px`) : c === "right" ? (p = `${-s}px`, m = a ? u : `${f}px`) : c === "left" && (p = `${r.floating.width + s}px`, m = a ? u : `${f}px`), { data: {
			x: p,
			y: m
		} };
	}
}), "transformOrigin");
function Ac(e) {
	let [t, n = "center"] = e.split("-");
	return [t, n];
}
pc(Ac, "getSideAndAlignFromPlacement");
//#endregion
//#region ../../node_modules/@radix-ui/react-use-is-hydrated/dist/index.mjs
var jc = Object.defineProperty, Mc = (e, t) => jc(e, "name", {
	value: t,
	configurable: !0
}), Nc = !1;
function Pc() {
	let [t, n] = e.useState(Nc);
	return e.useEffect(() => {
		Nc || (Nc = !0, n(!0));
	}, []), t;
}
Mc(Pc, "useIsHydrated");
var Fc = e.useSyncExternalStore;
function Ic() {
	return () => {};
}
Mc(Ic, "subscribe");
function Lc() {
	return Fc(Ic, () => !0, () => !1);
}
Mc(Lc, "useIsHydratedModern");
var Rc = typeof Fc == "function" ? Lc : Pc, zc = Object.defineProperty, Bc = (e, t) => zc(e, "name", {
	value: t,
	configurable: !0
}), Vc = "rovingFocusGroup.onEntryFocus", Hc = {
	bubbles: !1,
	cancelable: !0
}, Uc = "RovingFocusGroup", [Wc, Gc, Kc] = /* @__PURE__ */ La(Uc), [qc, Jc] = /* @__PURE__ */ on(Uc, [Kc]), Yc = {
	Vertical: "vertical",
	Horizontal: "horizontal"
}, Xc = {
	LTR: "ltr",
	RTL: "rtl"
}, [Zc, Qc] = qc(Uc), $c = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Bc(function(e, t) {
	return /* @__PURE__ */ i(Wc.Provider, {
		scope: e.__scopeRovingFocusGroup,
		children: /* @__PURE__ */ i(Wc.Slot, {
			scope: e.__scopeRovingFocusGroup,
			children: /* @__PURE__ */ i(el, {
				...e,
				ref: t
			})
		})
	});
}, "RovingFocusGroup")), el = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Bc(function(t, n) {
	let { __scopeRovingFocusGroup: r, orientation: a, loop: o = !1, dir: s, currentTabStopId: c, defaultCurrentTabStopId: l, onCurrentTabStopIdChange: u, onEntryFocus: d, preventScrollOnEntryFocus: f = !1, ...p } = t, m = e.useRef(null), h = H(n, m), g = Za(s), [_, v] = Sn({
		prop: c,
		defaultProp: l ?? null,
		onChange: u,
		caller: Uc
	}), [y, b] = e.useState(!1), x = Mn(d), S = Gc(r), C = e.useRef(!1), [w, T] = e.useState(0);
	return e.useEffect(() => {
		let e = m.current;
		if (e) return e.addEventListener(Vc, x), () => e.removeEventListener(Vc, x);
	}, [x]), /* @__PURE__ */ i(Zc, {
		scope: r,
		orientation: a,
		dir: g,
		loop: o,
		currentTabStopId: _,
		onItemFocus: e.useCallback((e) => v(e), [v]),
		onItemShiftTab: e.useCallback(() => b(!0), []),
		onFocusableItemAdd: e.useCallback(() => T((e) => e + 1), []),
		onFocusableItemRemove: e.useCallback(() => T((e) => e - 1), []),
		children: /* @__PURE__ */ i(G.div, {
			tabIndex: y || w === 0 ? -1 : 0,
			"data-orientation": a,
			...p,
			ref: h,
			style: {
				outline: "none",
				...t.style
			},
			onMouseDown: W(t.onMouseDown, () => {
				C.current = !0;
			}),
			onFocus: W(t.onFocus, (e) => {
				let t = !C.current;
				if (e.target === e.currentTarget && t && !y) {
					let t = new CustomEvent(Vc, Hc);
					if (e.currentTarget.dispatchEvent(t), !t.defaultPrevented) {
						let e = S().filter((e) => e.focusable);
						ol([
							e.find((e) => e.active),
							e.find((e) => e.id === _),
							...e
						].filter(Boolean).map((e) => e.ref.current), f);
					}
				}
				C.current = !1;
			}),
			onBlur: W(t.onBlur, () => b(!1))
		})
	});
}, "RovingFocusGroupImpl")), tl = "RovingFocusGroupItem", nl = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Bc(function(t, n) {
	let { __scopeRovingFocusGroup: r, focusable: a = !0, active: o = !1, tabStopId: s, children: c, ...l } = t, u = pn(), d = s || u, f = Qc(tl, r), p = f.currentTabStopId === d, m = Gc(r), { onFocusableItemAdd: h, onFocusableItemRemove: g, currentTabStopId: _ } = f, v = Rc();
	return cn(() => {
		if (!(!v || !a)) return h(), () => g();
	}, [
		v,
		a,
		h,
		g
	]), e.useEffect(() => {
		if (!(v || !a)) return h(), () => g();
	}, [
		v,
		a,
		h,
		g
	]), /* @__PURE__ */ i(Wc.ItemSlot, {
		scope: r,
		id: d,
		focusable: a,
		active: o,
		children: /* @__PURE__ */ i(G.span, {
			tabIndex: p ? 0 : -1,
			"data-orientation": f.orientation,
			...l,
			ref: n,
			onMouseDown: W(t.onMouseDown, (e) => {
				a ? f.onItemFocus(d) : e.preventDefault();
			}),
			onFocus: W(t.onFocus, () => f.onItemFocus(d)),
			onKeyDown: W(t.onKeyDown, (e) => {
				if (e.key === "Tab" && e.shiftKey) {
					f.onItemShiftTab();
					return;
				}
				if (e.target !== e.currentTarget) return;
				let t = al(e, f.orientation, f.dir);
				if (t !== void 0) {
					if (e.metaKey || e.ctrlKey || e.altKey || e.shiftKey) return;
					e.preventDefault();
					let n = m().filter((e) => e.focusable).map((e) => e.ref.current);
					if (t === "last") n.reverse();
					else if (t === "prev" || t === "next") {
						t === "prev" && n.reverse();
						let r = n.indexOf(e.currentTarget);
						n = f.loop ? sl(n, r + 1) : n.slice(r + 1);
					}
					setTimeout(() => ol(n));
				}
			}),
			children: typeof c == "function" ? c({
				isCurrentTabStop: p,
				hasTabStop: _ != null
			}) : c
		})
	});
}, "RovingFocusGroupItem")), rl = {
	ArrowLeft: "prev",
	ArrowUp: "prev",
	ArrowRight: "next",
	ArrowDown: "next",
	PageUp: "first",
	Home: "first",
	PageDown: "last",
	End: "last"
};
function il(e, t) {
	return t === Xc.RTL ? e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e : e;
}
Bc(il, "getDirectionAwareKey");
function al(e, t, n) {
	let r = il(e.key, n);
	if (!(t === Yc.Vertical && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === Yc.Horizontal && ["ArrowUp", "ArrowDown"].includes(r))) return rl[r];
}
Bc(al, "getFocusIntent");
function ol(e, t = !1) {
	let n = document.activeElement;
	for (let r of e) if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
Bc(ol, "focusFirst");
function sl(e, t) {
	return e.map((n, r) => e[(t + r) % e.length]);
}
Bc(sl, "wrapArray");
//#endregion
//#region ../../node_modules/@radix-ui/react-menu/dist/index.mjs
var cl = Object.defineProperty, Z = (e, t) => cl(e, "name", {
	value: t,
	configurable: !0
}), ll = {
	LTR: "ltr",
	RTL: "rtl"
}, ul = ["Enter", " "], dl = [
	"ArrowDown",
	"PageUp",
	"Home"
], fl = [
	"ArrowUp",
	"PageDown",
	"End"
], pl = [...dl, ...fl], ml = {
	ltr: [...ul, "ArrowRight"],
	rtl: [...ul, "ArrowLeft"]
}, hl = {
	ltr: ["ArrowLeft"],
	rtl: ["ArrowRight"]
}, gl = "Menu", [_l, vl, yl] = /* @__PURE__ */ La(gl), [bl, xl] = /* @__PURE__ */ on(gl, [
	yl,
	vc,
	Jc
]), Sl = vc(), Cl = Jc(), [wl, Tl] = bl(gl), [El, Dl] = bl(gl), Ol = /* @__PURE__ */ Z((t) => {
	let { __scopeMenu: n, open: r = !1, children: a, dir: o, onOpenChange: s, modal: c = !0 } = t, l = Sl(n), [u, d] = e.useState(null), f = e.useRef(!1), p = Mn(s), m = Za(o);
	return e.useEffect(() => {
		let e = /* @__PURE__ */ Z(() => {
			f.current = !0, document.addEventListener("pointerdown", t, {
				capture: !0,
				once: !0
			}), document.addEventListener("pointermove", t, {
				capture: !0,
				once: !0
			});
		}, "handleKeyDown"), t = /* @__PURE__ */ Z(() => f.current = !1, "handlePointer");
		return document.addEventListener("keydown", e, { capture: !0 }), () => {
			document.removeEventListener("keydown", e, { capture: !0 }), document.removeEventListener("pointerdown", t, { capture: !0 }), document.removeEventListener("pointermove", t, { capture: !0 });
		};
	}, []), e.useEffect(() => {
		if (!r) return;
		let e = /* @__PURE__ */ Z(() => p(!1), "handleBlur");
		return window.addEventListener("blur", e), () => window.removeEventListener("blur", e);
	}, [r, p]), /* @__PURE__ */ i(xc, {
		...l,
		children: /* @__PURE__ */ i(wl, {
			scope: n,
			open: r,
			onOpenChange: p,
			content: u,
			onContentChange: d,
			children: /* @__PURE__ */ i(El, {
				scope: n,
				onClose: e.useCallback(() => p(!1), [p]),
				isUsingKeyboardRef: f,
				dir: m,
				modal: c,
				children: a
			})
		})
	});
}, "Menu"), kl = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Z(function(e, t) {
	let { __scopeMenu: n, ...r } = e;
	return /* @__PURE__ */ i(Cc, {
		...Sl(n),
		...r,
		ref: t
	});
}, "MenuAnchor")), Al = "MenuPortal", [jl, Ml] = bl(Al, { forceMount: void 0 }), Nl = /* @__PURE__ */ Z((e) => {
	let { __scopeMenu: t, forceMount: n, children: r, container: a } = e, o = Tl(Al, t);
	return /* @__PURE__ */ i(jl, {
		scope: t,
		forceMount: n,
		children: /* @__PURE__ */ i(_r, {
			present: n || o.open,
			children: /* @__PURE__ */ i(pr, {
				asChild: !0,
				container: a,
				children: r
			})
		})
	});
}, "MenuPortal"), Pl = "MenuContent", [Fl, Il] = bl(Pl), Ll = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Z(function(e, t) {
	let n = Ml(Pl, e.__scopeMenu), { forceMount: r = n.forceMount, ...a } = e, o = Tl(Pl, e.__scopeMenu), s = Dl(Pl, e.__scopeMenu);
	return /* @__PURE__ */ i(_l.Provider, {
		scope: e.__scopeMenu,
		children: /* @__PURE__ */ i(_r, {
			present: r || o.open,
			children: /* @__PURE__ */ i(_l.Slot, {
				scope: e.__scopeMenu,
				children: s.modal ? /* @__PURE__ */ i(Rl, {
					...a,
					ref: t
				}) : /* @__PURE__ */ i(zl, {
					...a,
					ref: t
				})
			})
		})
	});
}, "MenuContent")), Rl = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Z(function(t, n) {
	let r = Tl(Pl, t.__scopeMenu), a = e.useRef(null), o = H(n, a);
	return e.useEffect(() => {
		let e = a.current;
		if (e) return qi(e);
	}, []), /* @__PURE__ */ i(Vl, {
		...t,
		ref: o,
		trapFocus: r.open,
		disableOutsidePointerEvents: r.open,
		disableOutsideScroll: !0,
		onFocusOutside: W(t.onFocusOutside, (e) => e.preventDefault(), { checkForDefaultPrevented: !1 }),
		onDismiss: () => r.onOpenChange(!1)
	});
}, "MenuRootContentModal")), zl = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Z(function(e, t) {
	let n = Tl(Pl, e.__scopeMenu);
	return /* @__PURE__ */ i(Vl, {
		...e,
		ref: t,
		trapFocus: !1,
		disableOutsidePointerEvents: !1,
		disableOutsideScroll: !1,
		onDismiss: () => n.onOpenChange(!1)
	});
}, "MenuRootContentNonModal")), Bl = /* @__PURE__ */ at("MenuContent.ScrollLock"), Vl = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Z(function(t, n) {
	let { __scopeMenu: r, loop: a = !1, trapFocus: o, onOpenAutoFocus: s, onCloseAutoFocus: c, disableOutsidePointerEvents: l, onEntryFocus: u, onEscapeKeyDown: d, onPointerDownOutside: f, onFocusOutside: p, onInteractOutside: m, onDismiss: h, disableOutsideScroll: g, children: _, ...v } = t, y = Tl(Pl, r), b = Dl(Pl, r), x = Sl(r), S = Cl(r), C = vl(r), [w, T] = e.useState(null), E = e.useRef(null), [ee, D] = e.useState(null);
	er(ee);
	let { nodes: O, registry: te } = $n(), k = !!(o || g), A = H(n, E, y.onContentChange, D), j = e.useRef(0), M = e.useRef(""), ne = e.useRef(0), N = e.useRef(null), re = e.useRef("right"), ie = e.useRef(0), ae = e.useMemo(() => g ? [E, ...O.map((e) => ({ current: e }))] : [], [
		E,
		O,
		g
	]), oe = g ? Ri : e.Fragment, P = g ? {
		as: Bl,
		allowPinchZoom: !0,
		shards: ae
	} : void 0, F = /* @__PURE__ */ Z((e) => {
		let t = M.current + e, n = C().filter((e) => !e.disabled), r = document.activeElement, i = n.find((e) => e.ref.current === r)?.textValue, a = vu(n.map((e) => e.textValue), t, i), o = n.find((e) => e.textValue === a)?.ref.current;
		(/* @__PURE__ */ Z((function e(t) {
			M.current = t, window.clearTimeout(j.current), t !== "" && (j.current = window.setTimeout(() => e(""), 1e3));
		}), "updateSearch"))(t), o && setTimeout(() => o.focus());
	}, "handleTypeaheadSearch");
	e.useEffect(() => () => window.clearTimeout(j.current), []), Or();
	let I = e.useCallback((e) => re.current === N.current?.side && bu(e, N.current?.area), []);
	return /* @__PURE__ */ i(Fl, {
		scope: r,
		searchRef: M,
		onItemEnter: e.useCallback((e) => {
			I(e) && e.preventDefault();
		}, [I]),
		onItemLeave: e.useCallback((e) => {
			I(e) || (E.current?.focus(), T(null));
		}, [I]),
		onTriggerLeave: e.useCallback((e) => {
			I(e) && e.preventDefault();
		}, [I]),
		pointerGraceTimerRef: ne,
		onPointerGraceIntentChange: e.useCallback((e) => {
			N.current = e;
		}, []),
		children: /* @__PURE__ */ i(oe, {
			...P,
			children: /* @__PURE__ */ i(Xn, {
				asChild: !0,
				trapped: o,
				branches: O,
				onMountAutoFocus: W(s, (e) => {
					e.preventDefault(), E.current?.focus({ preventScroll: !0 });
				}),
				onUnmountAutoFocus: c,
				children: /* @__PURE__ */ i(zn, {
					asChild: !0,
					disableOutsidePointerEvents: l,
					onEscapeKeyDown: d,
					onPointerDownOutside: f,
					onFocusOutside: p,
					onInteractOutside: m,
					onDismiss: h,
					children: /* @__PURE__ */ i($c, {
						asChild: !0,
						...S,
						dir: b.dir,
						orientation: "vertical",
						loop: a,
						currentTabStopId: w,
						onCurrentTabStopIdChange: T,
						onEntryFocus: W(u, (e) => {
							b.isUsingKeyboardRef.current || e.preventDefault();
						}),
						preventScrollOnEntryFocus: !0,
						children: /* @__PURE__ */ i(Dc, {
							role: "menu",
							"aria-orientation": "vertical",
							"data-state": pu(y.open),
							"data-radix-menu-content": "",
							dir: b.dir,
							...x,
							...v,
							ref: A,
							style: {
								outline: "none",
								...v.style
							},
							onKeyDown: W(v.onKeyDown, (e) => {
								let t = e.target.closest("[data-radix-menu-content]") === e.currentTarget, n = e.ctrlKey || e.altKey || e.metaKey, r = e.key.length === 1;
								t && (e.key === "Tab" && e.preventDefault(), !n && r && F(e.key));
								let i = E.current;
								if (e.target !== i || !pl.includes(e.key)) return;
								e.preventDefault();
								let a = C().filter((e) => !e.disabled).map((e) => e.ref.current);
								fl.includes(e.key) && a.reverse(), gu(a);
							}),
							onBlur: W(t.onBlur, (e) => {
								e.currentTarget.contains(e.target) || (window.clearTimeout(j.current), M.current = "");
							}),
							onPointerMove: W(t.onPointerMove, xu((e) => {
								let t = e.target, n = ie.current !== e.clientX;
								if (e.currentTarget.contains(t) && n) {
									let t = e.clientX > ie.current ? "right" : "left";
									re.current = t, ie.current = e.clientX;
								}
							})),
							children: k ? /* @__PURE__ */ i(Qn, {
								value: te,
								children: _
							}) : _
						})
					})
				})
			})
		})
	});
}, "MenuContentImpl")), Hl = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Z(function(e, t) {
	let { __scopeMenu: n, ...r } = e;
	return /* @__PURE__ */ i(G.div, {
		role: "group",
		...r,
		ref: t
	});
}, "MenuGroup")), Ul = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Z(function(e, t) {
	let { __scopeMenu: n, ...r } = e;
	return /* @__PURE__ */ i(G.div, {
		...r,
		ref: t
	});
}, "MenuLabel")), Wl = "MenuItem", Gl = "menu.itemSelect", Kl = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Z(function(t, n) {
	let { disabled: r = !1, onSelect: a, ...o } = t, s = e.useRef(null), c = Dl(Wl, t.__scopeMenu), l = Il(Wl, t.__scopeMenu), u = H(n, s), d = e.useRef(!1), f = /* @__PURE__ */ Z(() => {
		let e = s.current;
		if (!r && e) {
			let t = new CustomEvent(Gl, {
				bubbles: !0,
				cancelable: !0
			});
			e.addEventListener(Gl, (e) => a?.(e), { once: !0 }), kn(e, t), t.defaultPrevented ? d.current = !1 : c.onClose();
		}
	}, "handleSelect");
	return /* @__PURE__ */ i(ql, {
		...o,
		ref: u,
		disabled: r,
		onClick: W(t.onClick, f),
		onPointerDown: (e) => {
			t.onPointerDown?.(e), d.current = !0;
		},
		onPointerUp: W(t.onPointerUp, (e) => {
			d.current || e.currentTarget?.click();
		}),
		onKeyDown: W(t.onKeyDown, (e) => {
			r || e.target !== e.currentTarget || l.searchRef.current !== "" && e.key === " " || ul.includes(e.key) && (e.currentTarget.click(), e.preventDefault());
		})
	});
}, "MenuItem")), ql = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Z(function(t, n) {
	let { __scopeMenu: r, disabled: a = !1, textValue: o, ...s } = t, c = Il(Wl, r), l = Cl(r), u = e.useRef(null), d = H(n, u), [f, p] = e.useState(!1), [m, h] = e.useState("");
	return e.useEffect(() => {
		let e = u.current;
		e && h((e.textContent ?? "").trim());
	}, [s.children]), /* @__PURE__ */ i(_l.ItemSlot, {
		scope: r,
		disabled: a,
		textValue: o ?? m,
		children: /* @__PURE__ */ i(nl, {
			asChild: !0,
			...l,
			focusable: !a,
			children: /* @__PURE__ */ i(G.div, {
				role: "menuitem",
				"data-highlighted": f ? "" : void 0,
				"aria-disabled": a || void 0,
				"data-disabled": a ? "" : void 0,
				...s,
				ref: d,
				onPointerMove: W(t.onPointerMove, xu((e) => {
					a ? c.onItemLeave(e) : (c.onItemEnter(e), e.defaultPrevented || e.currentTarget.focus({ preventScroll: !0 }));
				})),
				onPointerLeave: W(t.onPointerLeave, xu((e) => c.onItemLeave(e))),
				onFocus: W(t.onFocus, () => p(!0)),
				onBlur: W(t.onBlur, () => p(!1))
			})
		})
	});
}, "MenuItemImpl")), Jl = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Z(function(e, t) {
	let { checked: n = !1, onCheckedChange: r, ...a } = e;
	return /* @__PURE__ */ i(tu, {
		scope: e.__scopeMenu,
		checked: n,
		children: /* @__PURE__ */ i(Kl, {
			role: "menuitemcheckbox",
			"aria-checked": mu(n) ? "mixed" : n,
			...a,
			ref: t,
			"data-state": hu(n),
			onSelect: W(a.onSelect, () => r?.(mu(n) ? !0 : !n), { checkForDefaultPrevented: !1 })
		})
	});
}, "MenuCheckboxItem")), [Yl, Xl] = bl("MenuRadioGroup", {
	value: void 0,
	onValueChange: /* @__PURE__ */ Z(() => {}, "onValueChange")
}), Zl = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Z(function(e, t) {
	let { value: n, onValueChange: r, ...a } = e, o = Mn(r);
	return /* @__PURE__ */ i(Yl, {
		scope: e.__scopeMenu,
		value: n,
		onValueChange: o,
		children: /* @__PURE__ */ i(Hl, {
			...a,
			ref: t
		})
	});
}, "MenuRadioGroup")), Ql = "MenuRadioItem", $l = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Z(function(e, t) {
	let { value: n, ...r } = e, a = Xl(Ql, e.__scopeMenu), o = n === a.value;
	return /* @__PURE__ */ i(tu, {
		scope: e.__scopeMenu,
		checked: o,
		children: /* @__PURE__ */ i(Kl, {
			role: "menuitemradio",
			"aria-checked": o,
			...r,
			ref: t,
			"data-state": hu(o),
			onSelect: W(r.onSelect, () => a.onValueChange?.(n), { checkForDefaultPrevented: !1 })
		})
	});
}, "MenuRadioItem")), eu = "MenuItemIndicator", [tu, nu] = bl(eu, { checked: !1 }), ru = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Z(function(e, t) {
	let { __scopeMenu: n, forceMount: r, ...a } = e, o = nu(eu, n);
	return /* @__PURE__ */ i(_r, {
		present: r || mu(o.checked) || o.checked === !0,
		children: /* @__PURE__ */ i(G.span, {
			...a,
			ref: t,
			"data-state": hu(o.checked)
		})
	});
}, "MenuItemIndicator")), iu = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Z(function(e, t) {
	let { __scopeMenu: n, ...r } = e;
	return /* @__PURE__ */ i(G.div, {
		role: "separator",
		"aria-orientation": "horizontal",
		...r,
		ref: t
	});
}, "MenuSeparator")), au = "MenuSub", [ou, su] = bl(au), cu = /* @__PURE__ */ Z((t) => {
	let { __scopeMenu: n, children: r, open: a = !1, onOpenChange: o } = t, s = Tl(au, n), c = Sl(n), [l, u] = e.useState(null), [d, f] = e.useState(null), p = Mn(o);
	return e.useEffect(() => (s.open === !1 && p(!1), () => p(!1)), [s.open, p]), /* @__PURE__ */ i(xc, {
		...c,
		children: /* @__PURE__ */ i(wl, {
			scope: n,
			open: a,
			onOpenChange: p,
			content: d,
			onContentChange: f,
			children: /* @__PURE__ */ i(ou, {
				scope: n,
				contentId: pn(),
				triggerId: pn(),
				trigger: l,
				onTriggerChange: u,
				children: r
			})
		})
	});
}, "MenuSub"), lu = "MenuSubTrigger", uu = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Z(function(t, n) {
	let r = Tl(lu, t.__scopeMenu), a = Dl(lu, t.__scopeMenu), o = su(lu, t.__scopeMenu), s = Il(lu, t.__scopeMenu), c = e.useRef(null), { pointerGraceTimerRef: l, onPointerGraceIntentChange: u } = s, d = { __scopeMenu: t.__scopeMenu }, f = e.useCallback(() => {
		c.current && window.clearTimeout(c.current), c.current = null;
	}, []);
	e.useEffect(() => f, [f]), e.useEffect(() => {
		let e = l.current;
		return () => {
			window.clearTimeout(e), u(null);
		};
	}, [l, u]);
	let p = H(n, o.onTriggerChange);
	return /* @__PURE__ */ i(kl, {
		asChild: !0,
		...d,
		children: /* @__PURE__ */ i(ql, {
			id: o.triggerId,
			"aria-haspopup": "menu",
			"aria-expanded": r.open,
			"aria-controls": r.open ? o.contentId : void 0,
			"data-state": pu(r.open),
			...t,
			ref: p,
			onClick: (e) => {
				t.onClick?.(e), !(t.disabled || e.defaultPrevented) && (e.currentTarget.focus(), r.open || r.onOpenChange(!0));
			},
			onPointerMove: W(t.onPointerMove, xu((e) => {
				s.onItemEnter(e), !e.defaultPrevented && !t.disabled && !r.open && !c.current && (s.onPointerGraceIntentChange(null), c.current = window.setTimeout(() => {
					r.onOpenChange(!0), f();
				}, 100));
			})),
			onPointerLeave: W(t.onPointerLeave, xu((e) => {
				f();
				let t = r.content?.getBoundingClientRect();
				if (t) {
					let n = r.content?.dataset.side, i = n === "right", a = i ? -5 : 5, o = t[i ? "left" : "right"], c = t[i ? "right" : "left"];
					s.onPointerGraceIntentChange({
						area: [
							{
								x: e.clientX + a,
								y: e.clientY
							},
							{
								x: o,
								y: t.top
							},
							{
								x: c,
								y: t.top
							},
							{
								x: c,
								y: t.bottom
							},
							{
								x: o,
								y: t.bottom
							}
						],
						side: n
					}), window.clearTimeout(l.current), l.current = window.setTimeout(() => s.onPointerGraceIntentChange(null), 300);
				} else {
					if (s.onTriggerLeave(e), e.defaultPrevented) return;
					s.onPointerGraceIntentChange(null);
				}
			})),
			onKeyDown: W(t.onKeyDown, (e) => {
				t.disabled || e.target !== e.currentTarget || s.searchRef.current !== "" && e.key === " " || ml[a.dir].includes(e.key) && (r.onOpenChange(!0), r.content?.focus(), e.preventDefault());
			})
		})
	});
}, "MenuSubTrigger")), du = "MenuSubContent", fu = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Z(function(t, n) {
	let r = Ml(Pl, t.__scopeMenu), { forceMount: a = r.forceMount, align: o = "start", ...s } = t, c = Tl(Pl, t.__scopeMenu), l = Dl(Pl, t.__scopeMenu), u = su(du, t.__scopeMenu), d = e.useRef(null), f = H(n, d);
	return /* @__PURE__ */ i(_l.Provider, {
		scope: t.__scopeMenu,
		children: /* @__PURE__ */ i(_r, {
			present: a || c.open,
			children: /* @__PURE__ */ i(_l.Slot, {
				scope: t.__scopeMenu,
				children: /* @__PURE__ */ i(Vl, {
					id: u.contentId,
					"aria-labelledby": u.triggerId,
					...s,
					ref: f,
					align: o,
					side: l.dir === ll.RTL ? "left" : "right",
					disableOutsidePointerEvents: !1,
					disableOutsideScroll: !1,
					trapFocus: !1,
					onOpenAutoFocus: (e) => {
						l.isUsingKeyboardRef.current && d.current?.focus(), e.preventDefault();
					},
					onCloseAutoFocus: (e) => e.preventDefault(),
					onFocusOutside: W(t.onFocusOutside, (e) => {
						e.target !== u.trigger && c.onOpenChange(!1);
					}),
					onEscapeKeyDown: W(t.onEscapeKeyDown, (e) => {
						l.onClose(), e.preventDefault();
					}),
					onKeyDown: W(t.onKeyDown, (e) => {
						let t = e.currentTarget.contains(e.target), n = hl[l.dir].includes(e.key);
						t && n && (c.onOpenChange(!1), u.trigger?.focus(), e.preventDefault());
					})
				})
			})
		})
	});
}, "MenuSubContent"));
function pu(e) {
	return e ? "open" : "closed";
}
Z(pu, "getOpenState");
function mu(e) {
	return e === "indeterminate";
}
Z(mu, "isIndeterminate");
function hu(e) {
	return mu(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
Z(hu, "getCheckedState");
function gu(e) {
	let t = document.activeElement;
	for (let n of e) if (n === t || (n.focus(), document.activeElement !== t)) return;
}
Z(gu, "focusFirst");
function _u(e, t) {
	return e.map((n, r) => e[(t + r) % e.length]);
}
Z(_u, "wrapArray");
function vu(e, t, n) {
	let r = t.length > 1 && Array.from(t).every((e) => e === t[0]) ? t[0] : t, i = n ? e.indexOf(n) : -1, a = _u(e, Math.max(i, 0));
	r.length === 1 && (a = a.filter((e) => e !== n));
	let o = a.find((e) => e.toLowerCase().startsWith(r.toLowerCase()));
	return o === n ? void 0 : o;
}
Z(vu, "getNextMatch");
function yu(e, t) {
	let { x: n, y: r } = e, i = !1;
	for (let e = 0, a = t.length - 1; e < t.length; a = e++) {
		let o = t[e], s = t[a], c = o.x, l = o.y, u = s.x, d = s.y;
		l > r != d > r && n < (u - c) * (r - l) / (d - l) + c && (i = !i);
	}
	return i;
}
Z(yu, "isPointInPolygon");
function bu(e, t) {
	return t ? yu({
		x: e.clientX,
		y: e.clientY
	}, t) : !1;
}
Z(bu, "isPointerInGraceArea");
function xu(e) {
	return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
Z(xu, "whenMouse");
//#endregion
//#region ../../node_modules/@radix-ui/react-dropdown-menu/dist/index.mjs
var Su = Object.defineProperty, Q = (e, t) => Su(e, "name", {
	value: t,
	configurable: !0
}), Cu = "DropdownMenu", [wu, Tu] = /* @__PURE__ */ on(Cu, [xl]), $ = xl(), [Eu, Du] = wu(Cu), Ou = /* @__PURE__ */ Q((t) => {
	let { __scopeDropdownMenu: n, children: r, dir: a, open: o, defaultOpen: s, onOpenChange: c, modal: l = !0 } = t, u = $(n), d = e.useRef(null), [f, p] = Sn({
		prop: o,
		defaultProp: s ?? !1,
		onChange: c,
		caller: Cu
	});
	return /* @__PURE__ */ i(Eu, {
		scope: n,
		triggerId: pn(),
		triggerRef: d,
		contentId: pn(),
		open: f,
		onOpenChange: p,
		onOpenToggle: e.useCallback(() => p((e) => !e), [p]),
		modal: l,
		children: /* @__PURE__ */ i(Ol, {
			...u,
			open: f,
			onOpenChange: p,
			dir: a,
			modal: l,
			children: r
		})
	});
}, "DropdownMenu"), ku = "DropdownMenuTrigger", Au = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Q(function(e, t) {
	let { __scopeDropdownMenu: n, disabled: r = !1, ...a } = e, o = Du(ku, n), s = $(n), c = H(t, o.triggerRef);
	return /* @__PURE__ */ i(kl, {
		asChild: !0,
		...s,
		children: /* @__PURE__ */ i(G.button, {
			type: "button",
			id: o.triggerId,
			"aria-haspopup": "menu",
			"aria-expanded": o.open,
			"aria-controls": o.open ? o.contentId : void 0,
			"data-state": o.open ? "open" : "closed",
			"data-disabled": r ? "" : void 0,
			disabled: r,
			...a,
			ref: c,
			onPointerDown: W(e.onPointerDown, (e) => {
				!r && e.button === 0 && e.ctrlKey === !1 && (o.onOpenToggle(), o.open || e.preventDefault());
			}),
			onKeyDown: W(e.onKeyDown, (e) => {
				r || (["Enter", " "].includes(e.key) && o.onOpenToggle(), e.key === "ArrowDown" && o.onOpenChange(!0), [
					"Enter",
					" ",
					"ArrowDown"
				].includes(e.key) && e.preventDefault());
			})
		})
	});
}, "DropdownMenuTrigger")), ju = /* @__PURE__ */ Q((e) => {
	let { __scopeDropdownMenu: t, ...n } = e;
	return /* @__PURE__ */ i(Nl, {
		...$(t),
		...n
	});
}, "DropdownMenuPortal"), Mu = "DropdownMenuContent", Nu = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Q(function(t, n) {
	let { __scopeDropdownMenu: r, ...a } = t, o = Du(Mu, r), s = $(r), c = e.useRef(!1);
	return /* @__PURE__ */ i(Ll, {
		id: o.contentId,
		"aria-labelledby": o.triggerId,
		...s,
		...a,
		ref: n,
		onCloseAutoFocus: W(t.onCloseAutoFocus, (e) => {
			c.current || o.triggerRef.current?.focus(), c.current = !1, e.preventDefault();
		}),
		onInteractOutside: W(t.onInteractOutside, (e) => {
			let t = e.detail.originalEvent, n = t.button === 0 && t.ctrlKey === !0, r = t.button === 2 || n;
			(!o.modal || r) && (c.current = !0);
		}),
		style: {
			...t.style,
			"--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
			"--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
			"--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
			"--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
			"--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
		}
	});
}, "DropdownMenuContent")), Pu = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Q(function(e, t) {
	let { __scopeDropdownMenu: n, ...r } = e;
	return /* @__PURE__ */ i(Hl, {
		...$(n),
		...r,
		ref: t
	});
}, "DropdownMenuGroup")), Fu = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Q(function(e, t) {
	let { __scopeDropdownMenu: n, ...r } = e;
	return /* @__PURE__ */ i(Ul, {
		...$(n),
		...r,
		ref: t
	});
}, "DropdownMenuLabel")), Iu = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Q(function(e, t) {
	let { __scopeDropdownMenu: n, ...r } = e;
	return /* @__PURE__ */ i(Kl, {
		...$(n),
		...r,
		ref: t
	});
}, "DropdownMenuItem")), Lu = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Q(function(e, t) {
	let { __scopeDropdownMenu: n, ...r } = e;
	return /* @__PURE__ */ i(Jl, {
		...$(n),
		...r,
		ref: t
	});
}, "DropdownMenuCheckboxItem")), Ru = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Q(function(e, t) {
	let { __scopeDropdownMenu: n, ...r } = e;
	return /* @__PURE__ */ i(Zl, {
		...$(n),
		...r,
		ref: t
	});
}, "DropdownMenuRadioGroup")), zu = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Q(function(e, t) {
	let { __scopeDropdownMenu: n, ...r } = e;
	return /* @__PURE__ */ i($l, {
		...$(n),
		...r,
		ref: t
	});
}, "DropdownMenuRadioItem")), Bu = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Q(function(e, t) {
	let { __scopeDropdownMenu: n, ...r } = e;
	return /* @__PURE__ */ i(ru, {
		...$(n),
		...r,
		ref: t
	});
}, "DropdownMenuItemIndicator")), Vu = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Q(function(e, t) {
	let { __scopeDropdownMenu: n, ...r } = e;
	return /* @__PURE__ */ i(iu, {
		...$(n),
		...r,
		ref: t
	});
}, "DropdownMenuSeparator")), Hu = /* @__PURE__ */ Q((e) => {
	let { __scopeDropdownMenu: t, children: n, open: r, onOpenChange: a, defaultOpen: o } = e, s = $(t), [c, l] = Sn({
		prop: r,
		defaultProp: o ?? !1,
		onChange: a,
		caller: "DropdownMenuSub"
	});
	return /* @__PURE__ */ i(cu, {
		...s,
		open: c,
		onOpenChange: l,
		children: n
	});
}, "DropdownMenuSub"), Uu = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Q(function(e, t) {
	let { __scopeDropdownMenu: n, ...r } = e;
	return /* @__PURE__ */ i(uu, {
		...$(n),
		...r,
		ref: t
	});
}, "DropdownMenuSubTrigger")), Wu = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Q(function(e, t) {
	let { __scopeDropdownMenu: n, ...r } = e;
	return /* @__PURE__ */ i(fu, {
		...$(n),
		...r,
		ref: t,
		style: {
			...e.style,
			"--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
			"--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
			"--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
			"--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
			"--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
		}
	});
}, "DropdownMenuSubContent")), Gu = Ou, Ku = Au, qu = Pu, Ju = ju, Yu = Hu, Xu = Ru, Zu = e.forwardRef(({ className: e, inset: t, children: n, ...r }, o) => /* @__PURE__ */ a(Uu, {
	ref: o,
	className: V("flex cursor-pointer select-none items-center rounded-md px-2 py-1.5 text-sm outline-none", "focus:bg-gray-100 data-[state=open]:bg-gray-100", t && "pl-8", e),
	...r,
	children: [n, /* @__PURE__ */ i(od, { className: "ml-auto h-4 w-4" })]
}));
Zu.displayName = Uu.displayName;
var Qu = e.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(Wu, {
	ref: n,
	className: V("z-50 min-w-[8rem] overflow-hidden rounded-lg border border-gray-200 bg-white p-1 shadow-elevated", "data-[state=open]:animate-fade-in data-[state=closed]:animate-fade-out", e),
	...t
}));
Qu.displayName = Wu.displayName;
var $u = e.forwardRef(({ className: e, sideOffset: t = 4, ...n }, r) => /* @__PURE__ */ i(ju, { children: /* @__PURE__ */ i(Nu, {
	ref: r,
	sideOffset: t,
	className: V("z-50 min-w-[12rem] overflow-hidden rounded-lg border border-gray-200 bg-white p-1 shadow-elevated", "data-[state=open]:animate-fade-in data-[state=closed]:animate-fade-out", e),
	...n
}) }));
$u.displayName = Nu.displayName;
var ed = e.forwardRef(({ className: e, inset: t, variant: n = "default", ...r }, a) => /* @__PURE__ */ i(Iu, {
	ref: a,
	className: V("relative flex cursor-pointer select-none items-center rounded-md px-2 py-1.5 text-sm outline-none transition-colors", "focus:bg-gray-100", "data-[disabled]:pointer-events-none data-[disabled]:opacity-50", n === "danger" && "text-red-600 focus:bg-red-50 focus:text-red-700", t && "pl-8", e),
	...r
}));
ed.displayName = Iu.displayName;
var td = e.forwardRef(({ className: e, children: t, checked: n, ...r }, o) => /* @__PURE__ */ a(Lu, {
	ref: o,
	className: V("relative flex cursor-pointer select-none items-center rounded-md py-1.5 pl-8 pr-2 text-sm outline-none transition-colors", "focus:bg-gray-100", "data-[disabled]:pointer-events-none data-[disabled]:opacity-50", e),
	checked: n,
	...r,
	children: [/* @__PURE__ */ i("span", {
		className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center",
		children: /* @__PURE__ */ i(Bu, { children: /* @__PURE__ */ i(sd, { className: "h-4 w-4" }) })
	}), t]
}));
td.displayName = Lu.displayName;
var nd = e.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ a(zu, {
	ref: r,
	className: V("relative flex cursor-pointer select-none items-center rounded-md py-1.5 pl-8 pr-2 text-sm outline-none transition-colors", "focus:bg-gray-100", "data-[disabled]:pointer-events-none data-[disabled]:opacity-50", e),
	...n,
	children: [/* @__PURE__ */ i("span", {
		className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center",
		children: /* @__PURE__ */ i(Bu, { children: /* @__PURE__ */ i(cd, { className: "h-4 w-4 fill-current" }) })
	}), t]
}));
nd.displayName = zu.displayName;
var rd = e.forwardRef(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ i(Fu, {
	ref: r,
	className: V("px-2 py-1.5 text-xs font-semibold text-gray-500 uppercase tracking-wide", t && "pl-8", e),
	...n
}));
rd.displayName = Fu.displayName;
var id = e.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(Vu, {
	ref: n,
	className: V("-mx-1 my-1 h-px bg-gray-200", e),
	...t
}));
id.displayName = Vu.displayName;
var ad = ({ className: e, ...t }) => /* @__PURE__ */ i("span", {
	className: V("ml-auto text-xs tracking-widest text-gray-400", e),
	...t
});
ad.displayName = "DropdownMenuShortcut";
function od({ className: e }) {
	return /* @__PURE__ */ i("svg", {
		className: e,
		xmlns: "http://www.w3.org/2000/svg",
		width: "24",
		height: "24",
		viewBox: "0 0 24 24",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: "2",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		children: /* @__PURE__ */ i("path", { d: "m9 18 6-6-6-6" })
	});
}
function sd({ className: e }) {
	return /* @__PURE__ */ i("svg", {
		className: e,
		xmlns: "http://www.w3.org/2000/svg",
		width: "24",
		height: "24",
		viewBox: "0 0 24 24",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: "2",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		children: /* @__PURE__ */ i("path", { d: "M20 6 9 17l-5-5" })
	});
}
function cd({ className: e }) {
	return /* @__PURE__ */ i("svg", {
		className: e,
		xmlns: "http://www.w3.org/2000/svg",
		width: "24",
		height: "24",
		viewBox: "0 0 24 24",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: "2",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		children: /* @__PURE__ */ i("circle", {
			cx: "12",
			cy: "12",
			r: "4"
		})
	});
}
//#endregion
//#region ../../node_modules/@radix-ui/react-tabs/dist/index.mjs
var ld = Object.defineProperty, ud = (e, t) => ld(e, "name", {
	value: t,
	configurable: !0
}), dd = {
	Automatic: "automatic",
	Manual: "manual"
}, fd = "Tabs", [pd, md] = /* @__PURE__ */ on(fd, [Jc]), hd = Jc(), [gd, _d] = pd(fd), vd = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ ud(function(e, t) {
	let { __scopeTabs: n, value: r, onValueChange: a, defaultValue: o, orientation: s = "horizontal", dir: c, activationMode: l = dd.Automatic, ...u } = e, d = Za(c), [f, p] = Sn({
		prop: r,
		onChange: a,
		defaultProp: o ?? "",
		caller: fd
	});
	return /* @__PURE__ */ i(gd, {
		scope: n,
		baseId: pn(),
		value: f,
		onValueChange: p,
		orientation: s,
		dir: d,
		activationMode: l,
		children: /* @__PURE__ */ i(G.div, {
			dir: d,
			"data-orientation": s,
			...u,
			ref: t
		})
	});
}, "Tabs")), yd = "TabsList", bd = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ ud(function(e, t) {
	let { __scopeTabs: n, loop: r = !0, ...a } = e, o = _d(yd, n);
	return /* @__PURE__ */ i($c, {
		asChild: !0,
		...hd(n),
		orientation: o.orientation,
		dir: o.dir,
		loop: r,
		children: /* @__PURE__ */ i(G.div, {
			role: "tablist",
			"aria-orientation": o.orientation,
			...a,
			ref: t
		})
	});
}, "TabsList")), xd = "TabsTrigger", Sd = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ ud(function(e, t) {
	let { __scopeTabs: n, value: r, disabled: a = !1, ...o } = e, s = _d(xd, n), c = hd(n), l = Td(s.baseId, r), u = Ed(s.baseId, r), d = r === s.value;
	return /* @__PURE__ */ i(nl, {
		asChild: !0,
		...c,
		focusable: !a,
		active: d,
		children: /* @__PURE__ */ i(G.button, {
			type: "button",
			role: "tab",
			"aria-selected": d,
			"aria-controls": u,
			"data-state": d ? "active" : "inactive",
			"data-disabled": a ? "" : void 0,
			disabled: a,
			id: l,
			...o,
			ref: t,
			onMouseDown: W(e.onMouseDown, (e) => {
				!a && e.button === 0 && e.ctrlKey === !1 ? (e.currentTarget.focus(), s.onValueChange(r)) : e.preventDefault();
			}),
			onKeyDown: W(e.onKeyDown, (e) => {
				a || e.target !== e.currentTarget || [" ", "Enter"].includes(e.key) && s.onValueChange(r);
			}),
			onFocus: W(e.onFocus, () => {
				let e = s.activationMode !== dd.Manual;
				!d && !a && e && s.onValueChange(r);
			})
		})
	});
}, "TabsTrigger")), Cd = "TabsContent", wd = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ ud(function(t, n) {
	let { __scopeTabs: r, value: a, forceMount: o, children: s, ...c } = t, l = _d(Cd, r), u = Td(l.baseId, a), d = Ed(l.baseId, a), f = a === l.value, p = e.useRef(f);
	return e.useEffect(() => {
		let e = requestAnimationFrame(() => p.current = !1);
		return () => cancelAnimationFrame(e);
	}, []), /* @__PURE__ */ i(_r, {
		present: o || f,
		children: ({ present: e }) => /* @__PURE__ */ i(G.div, {
			"data-state": f ? "active" : "inactive",
			"data-orientation": l.orientation,
			role: "tabpanel",
			"aria-labelledby": u,
			hidden: !e,
			id: d,
			tabIndex: 0,
			...c,
			ref: n,
			style: {
				...t.style,
				animationDuration: p.current ? "0s" : void 0
			},
			children: e && s
		})
	});
}, "TabsContent"));
function Td(e, t) {
	return `${e}-trigger-${t}`;
}
ud(Td, "makeTriggerId");
function Ed(e, t) {
	return `${e}-content-${t}`;
}
ud(Ed, "makeContentId");
//#endregion
//#region src/components/tabs/Tabs.tsx
var Dd = vd, Od = e.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(bd, {
	ref: n,
	className: V("inline-flex items-center justify-center rounded-lg bg-gray-100 p-1", e),
	...t
}));
Od.displayName = bd.displayName;
var kd = e.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(Sd, {
	ref: n,
	className: V("inline-flex items-center justify-center whitespace-nowrap rounded-md px-3 py-1.5 text-sm font-medium transition-all", "text-gray-600 hover:text-gray-900", "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2", "disabled:pointer-events-none disabled:opacity-50", "data-[state=active]:bg-white data-[state=active]:text-gray-900 data-[state=active]:shadow-sm", e),
	...t
}));
kd.displayName = Sd.displayName;
var Ad = e.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(wd, {
	ref: n,
	className: V("mt-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2", e),
	...t
}));
Ad.displayName = wd.displayName;
var jd = e.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(bd, {
	ref: n,
	className: V("inline-flex items-center border-b border-gray-200", e),
	...t
}));
jd.displayName = "TabsListUnderline";
var Md = e.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(Sd, {
	ref: n,
	className: V("inline-flex items-center justify-center whitespace-nowrap px-4 py-2.5 text-sm font-medium transition-all", "text-gray-500 hover:text-gray-700 border-b-2 border-transparent -mb-px", "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2", "disabled:pointer-events-none disabled:opacity-50", "data-[state=active]:border-primary-500 data-[state=active]:text-gray-900", e),
	...t
}));
Md.displayName = "TabsTriggerUnderline";
//#endregion
//#region src/components/layout/PageHeader.tsx
var Nd = e.forwardRef(({ className: e, title: t, description: n, actions: r, breadcrumb: o, backLink: s, ...c }, l) => /* @__PURE__ */ a("div", {
	ref: l,
	className: V("mb-8", e),
	...c,
	children: [
		o && /* @__PURE__ */ i("div", {
			className: "mb-4",
			children: o
		}),
		s && /* @__PURE__ */ i("div", {
			className: "mb-4",
			children: s
		}),
		/* @__PURE__ */ a("div", {
			className: "flex items-start justify-between gap-4",
			children: [/* @__PURE__ */ a("div", {
				className: "min-w-0 flex-1",
				children: [/* @__PURE__ */ i("h1", {
					className: "text-2xl font-semibold text-gray-900 tracking-tight",
					children: t
				}), n && /* @__PURE__ */ i("p", {
					className: "mt-1.5 text-sm text-gray-500 max-w-2xl",
					children: n
				})]
			}), r && /* @__PURE__ */ i("div", {
				className: "flex items-center gap-3 shrink-0",
				children: r
			})]
		})
	]
}));
Nd.displayName = "PageHeader";
//#endregion
//#region src/components/layout/Container.tsx
var Pd = U("mx-auto w-full px-4 sm:px-6 lg:px-8", {
	variants: { maxWidth: {
		sm: "max-w-3xl",
		md: "max-w-5xl",
		lg: "max-w-7xl",
		xl: "max-w-screen-2xl",
		full: "max-w-full"
	} },
	defaultVariants: { maxWidth: "lg" }
}), Fd = e.forwardRef(({ className: e, maxWidth: t, ...n }, r) => /* @__PURE__ */ i("div", {
	ref: r,
	className: V(Pd({ maxWidth: t }), e),
	...n
}));
Fd.displayName = "Container";
//#endregion
//#region src/components/feedback/EmptyState.tsx
var Id = e.forwardRef(({ className: e, icon: t, title: n, description: r, action: o, size: s = "md", ...c }, l) => {
	let u = {
		sm: "py-8",
		md: "py-12",
		lg: "py-16"
	}, d = {
		sm: "[&>svg]:h-8 [&>svg]:w-8",
		md: "[&>svg]:h-12 [&>svg]:w-12",
		lg: "[&>svg]:h-16 [&>svg]:w-16"
	};
	return /* @__PURE__ */ a("div", {
		ref: l,
		className: V("flex flex-col items-center justify-center text-center px-4", u[s], e),
		...c,
		children: [
			t && /* @__PURE__ */ i("div", {
				className: V("mb-4 text-gray-300", d[s]),
				children: t
			}),
			/* @__PURE__ */ i("h3", {
				className: "text-base font-semibold text-gray-900",
				children: n
			}),
			r && /* @__PURE__ */ i("p", {
				className: "mt-1.5 text-sm text-gray-500 max-w-sm",
				children: r
			}),
			o && /* @__PURE__ */ i("div", {
				className: "mt-6",
				children: o
			})
		]
	});
});
Id.displayName = "EmptyState";
//#endregion
//#region src/components/feedback/Skeleton.tsx
var Ld = e.forwardRef(({ className: e, variant: t = "text", width: n, height: r, style: a, ...o }, s) => /* @__PURE__ */ i("div", {
	ref: s,
	className: V("animate-pulse bg-gray-200", {
		text: "rounded",
		circular: "rounded-full",
		rectangular: "rounded-lg"
	}[t], !r && {
		text: "h-4",
		circular: "h-10 w-10",
		rectangular: "h-24"
	}[t], n, r, e),
	style: a,
	...o
}));
Ld.displayName = "Skeleton";
var Rd = e.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(Ld, {
	ref: n,
	variant: "text",
	className: V("h-4", e),
	...t
}));
Rd.displayName = "SkeletonText";
var zd = e.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(Ld, {
	ref: n,
	variant: "circular",
	className: V("h-10 w-10", e),
	...t
}));
zd.displayName = "SkeletonAvatar";
var Bd = e.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(Ld, {
	ref: n,
	variant: "rectangular",
	className: V("h-32 w-full", e),
	...t
}));
Bd.displayName = "SkeletonCard";
//#endregion
//#region src/components/feedback/Alert.tsx
var Vd = U("relative w-full rounded-lg border p-4", {
	variants: { variant: {
		default: "bg-gray-50 border-gray-200 text-gray-800",
		info: "bg-blue-50 border-blue-200 text-blue-800",
		success: "bg-green-50 border-green-200 text-green-800",
		warning: "bg-yellow-50 border-yellow-200 text-yellow-800",
		error: "bg-red-50 border-red-200 text-red-800"
	} },
	defaultVariants: { variant: "default" }
}), Hd = U("h-5 w-5 shrink-0", {
	variants: { variant: {
		default: "text-gray-500",
		info: "text-blue-500",
		success: "text-green-500",
		warning: "text-yellow-500",
		error: "text-red-500"
	} },
	defaultVariants: { variant: "default" }
});
function Ud({ className: e }) {
	return /* @__PURE__ */ a("svg", {
		className: e,
		xmlns: "http://www.w3.org/2000/svg",
		width: "24",
		height: "24",
		viewBox: "0 0 24 24",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: "2",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		children: [/* @__PURE__ */ i("path", { d: "M18 6 6 18" }), /* @__PURE__ */ i("path", { d: "m6 6 12 12" })]
	});
}
var Wd = e.forwardRef(({ className: e, variant: t, icon: n, title: r, dismissible: o, onDismiss: s, children: c, ...l }, u) => /* @__PURE__ */ i("div", {
	ref: u,
	role: "alert",
	className: V(Vd({ variant: t }), e),
	...l,
	children: /* @__PURE__ */ a("div", {
		className: "flex gap-3",
		children: [
			n && /* @__PURE__ */ i("div", {
				className: Hd({ variant: t }),
				children: n
			}),
			/* @__PURE__ */ a("div", {
				className: "flex-1 min-w-0",
				children: [r && /* @__PURE__ */ i("h5", {
					className: "font-medium mb-1",
					children: r
				}), /* @__PURE__ */ i("div", {
					className: "text-sm opacity-90",
					children: c
				})]
			}),
			o && /* @__PURE__ */ a("button", {
				type: "button",
				onClick: s,
				className: "shrink-0 -mt-1 -mr-1 p-1 rounded hover:bg-black/5 transition-colors",
				children: [/* @__PURE__ */ i(Ud, { className: "h-4 w-4" }), /* @__PURE__ */ i("span", {
					className: "sr-only",
					children: "Dismiss"
				})]
			})
		]
	})
}));
Wd.displayName = "Alert";
//#endregion
export { Wd as Alert, Rt as Badge, Ct as Button, kt as Card, Nt as CardContent, Ft as CardFooter, jt as CardHeader, Fd as Container, Gu as DropdownMenu, td as DropdownMenuCheckboxItem, $u as DropdownMenuContent, qu as DropdownMenuGroup, ed as DropdownMenuItem, rd as DropdownMenuLabel, Ju as DropdownMenuPortal, Xu as DropdownMenuRadioGroup, nd as DropdownMenuRadioItem, id as DropdownMenuSeparator, ad as DropdownMenuShortcut, Yu as DropdownMenuSub, Qu as DropdownMenuSubContent, Zu as DropdownMenuSubTrigger, Ku as DropdownMenuTrigger, Id as EmptyState, Dt as Input, Sa as Modal, Aa as ModalBody, Ta as ModalClose, Fa as ModalCloseButton, Oa as ModalContent, Na as ModalDescription, ja as ModalFooter, ka as ModalHeader, Ea as ModalOverlay, wa as ModalPortal, Ma as ModalTitle, Ca as ModalTrigger, Nd as PageHeader, Ld as Skeleton, zd as SkeletonAvatar, Bd as SkeletonCard, Rd as SkeletonText, zt as Table, Vt as TableBody, Kt as TableCaption, Gt as TableCell, qt as TableEmptyState, Ht as TableFooter, Wt as TableHead, Bt as TableHeader, Ut as TableRow, Jt as TableSkeleton, Dd as Tabs, Ad as TabsContent, Od as TabsList, jd as TabsListUnderline, kd as TabsTrigger, Md as TabsTriggerUnderline, Vd as alertVariants, It as badgeVariants, bt as buttonVariants, Ot as cardVariants, V as cn, Pd as containerVariants, wt as inputVariants, Da as modalContentVariants };
